export const SA_AI_CLIENT_EVALUATION_SOURCE = {
  expectedTotalFromSummary: 448,
  extractedRows: 349,
  activeDetailedRows: 319,
  sourceFile: 'Évaluation clients BZ.xlsx',
  note: 'Le résumé Excel indique 448 lignes, mais les onglets détaillés du fichier fourni contiennent 349 lignes clients exploitables.'
} as const;

// Auto-generated from Évaluation clients BZ.xlsx. Do not edit manually.
export const saAiClientEvaluationSeed = [
  {
    "clientName": "AssurExperts",
    "accountManager": "Antoine Giroux",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Excellente relation avec eux. Historique de 20 ans d'affaires. On accepté il y a 5 ans une augmentation de 10k / mois sans broncher.. Prime vendeur: 5. Risque de perte: 4.",
    "recommendedAngle": "Ramener de la vitesse. Implanter l'IA à moyen terme. Remy a peur de perdre ses données",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Lenteur dans le TS. Logiciel Keal est un pain in the ass. | Ramener de la vitesse. Implanter l'IA à moyen terme. Remy a peur de perdre ses données",
    "comments": "On a vecu une année 2026 difficile avec des problèmes majeurs. | Départements: TI, Cyber, Télécom | Valeur contrats: 21118.81 | Rentabilité: Rentable (382 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Antoine Giroux). Priorités/enjeux: Ramener de la vitesse. Implanter l'IA à moyen terme. Remy a peur de perdre ses données. Relation: Excellente relation avec eux. Historique de 20 ans d'affaires. On accepté il y a 5 ans une augmentation de 10k / mois sans broncher.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Antoine Giroux",
    "sourceRow": 2,
    "ddcActive": true
  },
  {
    "clientName": "Barreau de Québec",
    "accountManager": "Antoine Giroux",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Excellente relation. Avec BZ depuis près de 20 ans. Je m'en occupe depuis presque 10 ans, probablement ma meilleure relation client. Prime vendeur: 9. Risque de perte: 1.",
    "recommendedAngle": "Sécuriser les renseignements, offrir plus de services à leurs membre, leur staff est ''toujours dans le jus''",
    "riskOrCondition": "Risque déclaré: 1. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Ont beaucoup d'enjeux sur la protection de leurs données mais ont beaucoup de difficultés à opérer sur leurs budgets. Ils travaillent sur un budget prédeterminer qui augmente pratiquement pas. | Sécuriser les renseignements, offrir plus de services à leurs membre, leur staff est ''toujours dans le jus''",
    "comments": "Départements: TI, Cyber, Télécom | Valeur contrats: 1640.32 | Rentabilité: Rentable (451 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Antoine Giroux). Priorités/enjeux: Sécuriser les renseignements, offrir plus de services à leurs membre, leur staff est ''toujours dans le jus''. Relation: Excellente relation. Avec BZ depuis près de 20 ans. Je m'en occupe depuis presque 10 ans, probablement ma meilleure relation client. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Antoine Giroux",
    "sourceRow": 3,
    "ddcActive": true
  },
  {
    "clientName": "Beauvais Truchon Avocats",
    "accountManager": "Antoine Giroux",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Toujours des hauts et des bas avec eux. Ca s'est beaucoup améliorer dans les années mais c'est toujours dur de savoir à quoi s'en tenir. Coté Humain avec Valérie j'ai crystalisé beaucoup dans les dernières années mais pas le point de contact le plus puissant. Prime vendeur: 6. Risque de perte: 6.",
    "recommendedAngle": "Implanter l'IA, Sécuriser l'environnement, Gérer l'enveloppe budgétaire TI",
    "riskOrCondition": "Risque déclaré: 6. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Veulent toujours avancer en cyber mais n'ont jamais de plan clair. Toujours quelqu'un qui leur conseille un produit quelconque (EX: insatisfait du SOC telus). Client qui fait énormément de demandes et les procédures de montages de postes sont longues. Il faut améliorer l'efficacité la bas. | Implanter l'IA, Sécuriser l'environnement, Gérer l'enveloppe budgétaire TI",
    "comments": "Départements: TI | Valeur contrats: 11699.88 | Rentabilité: Moyen (129 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Antoine Giroux). Priorités/enjeux: Implanter l'IA, Sécuriser l'environnement, Gérer l'enveloppe budgétaire TI. Relation: Toujours des hauts et des bas avec eux. Ca s'est beaucoup améliorer dans les années mais c'est toujours dur de savoir à quoi s'en tenir. Coté Humain avec Valérie j'ai crystalisé beaucoup dans les dernières années mais pas le point de contact le plus puissant. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Antoine Giroux",
    "sourceRow": 4,
    "ddcActive": true
  },
  {
    "clientName": "Centre Canin Entre Bonnes Pattes",
    "accountManager": "Antoine Giroux",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Pas de fit, toujours compliqué. Aucun intérêt envers la TI. Prime vendeur: 2. Risque de perte: 8.",
    "recommendedAngle": "Elle veut toujours juste payer moins cher.",
    "riskOrCondition": "Risque déclaré: 8. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Elle veut toujours juste payer moins cher.",
    "comments": "Je ne ferais rien avec ce client | Départements: Programmation | Valeur contrats: 1136.06",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Moyenne",
    "ddcRiskLevel": "Élevé",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Antoine Giroux). Priorités/enjeux: Elle veut toujours juste payer moins cher.. Relation: Pas de fit, toujours compliqué. Aucun intérêt envers la TI. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Antoine Giroux",
    "sourceRow": 5,
    "ddcActive": true
  },
  {
    "clientName": "COEFICIA",
    "accountManager": "Antoine Giroux",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Relation très opérationnel. On toujours refusé mes diners. Relation par contre très professionnel et le lien de confiance est bon.. Prime vendeur: 4. Risque de perte: 3.",
    "recommendedAngle": "Amélioration des rapports. Problèmes de facturation à adresser. Veulent toujours améliorer leur sécurité mais le $ ne sort pas facilement",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Beaucoup d'applications différentes, manque de visibilité. Enjeux de facturations clients | Amélioration des rapports. Problèmes de facturation à adresser. Veulent toujours améliorer leur sécurité mais le $ ne sort pas facilement",
    "comments": "Départements: TI | Valeur contrats: 13029 | Rentabilité: Rentable (262 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Antoine Giroux). Priorités/enjeux: Amélioration des rapports. Problèmes de facturation à adresser. Veulent toujours améliorer leur sécurité mais le $ ne sort pas facilement. Relation: Relation très opérationnel. On toujours refusé mes diners. Relation par contre très professionnel et le lien de confiance est bon.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Antoine Giroux",
    "sourceRow": 6,
    "ddcActive": true
  },
  {
    "clientName": "Coopérative Funéraire des deux rives",
    "accountManager": "Antoine Giroux",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Dans mon top 3 de bonnes relations. Alain a un intérêt marqué pour la TI et j'ai une excellente relation avec le DG.. Prime vendeur: 8. Risque de perte: 2.",
    "recommendedAngle": "Sécuriser ses données, ils ont énormément de données sensible et ce marché est très fragile par rapport aux données.Implanter l'IA pour accélerer ses opérations.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Avait un staff réfractaire au changement. Modernise tout ses applicatifs. | Sécuriser ses données, ils ont énormément de données sensible et ce marché est très fragile par rapport aux données.Implanter l'IA pour accélerer ses opérations.",
    "comments": "Départements: TI, Cyber | Valeur contrats: 11183.12 | Rentabilité: Rentable (294 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Antoine Giroux). Priorités/enjeux: Sécuriser ses données, ils ont énormément de données sensible et ce marché est très fragile par rapport aux données.Implanter l'IA pour accélerer ses opérations.. Relation: Dans mon top 3 de bonnes relations. Alain a un intérêt marqué pour la TI et j'ai une excellente relation avec le DG.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Antoine Giroux",
    "sourceRow": 7,
    "ddcActive": true
  },
  {
    "clientName": "Cycles Lambert inc.",
    "accountManager": "Antoine Giroux",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Relation très professionnel et opérationnel. Aucun attachement émotif mais tout se passe toujours très bien. Haut niveau de confiance bi directionnel. Prime vendeur: 6. Risque de perte: 2.",
    "recommendedAngle": "Garder le contrôle des données. Controler les couts avec leur expansion. Gérer leur nouvelle structure plus exigeante qu'avant.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Garder le contrôle de ses données il ne veulent pas que ca se ramasse sous contrôle de la grande entreprise au dessus d'eux. | Garder le contrôle des données. Controler les couts avec leur expansion. Gérer leur nouvelle structure plus exigeante qu'avant.",
    "comments": "Départements: TI | Valeur contrats: 18805.98 | Rentabilité: Rentable (44250 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Antoine Giroux). Priorités/enjeux: Garder le contrôle des données. Controler les couts avec leur expansion. Gérer leur nouvelle structure plus exigeante qu'avant.. Relation: Relation très professionnel et opérationnel. Aucun attachement émotif mais tout se passe toujours très bien. Haut niveau de confiance bi directionnel. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Antoine Giroux",
    "sourceRow": 8,
    "ddcActive": true
  },
  {
    "clientName": "GDA Services Immobiliers Intégrés",
    "accountManager": "Antoine Giroux",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Excellente relation avec Frederic. Il apprécie BZ, comprend ce qu'on fait et a un intérêt marqué pour la TI.. Prime vendeur: 7. Risque de perte: à valider.",
    "recommendedAngle": "Intégrer l'IA, améliorer leur prise de décision TI",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Croissance, restrictions sur les budgets en TI. Certains membres du CA remettaient BZ en doute sur l'expertise mais a été démoli lorsqu'ils ont recu un rapport impeccable. | Intégrer l'IA, améliorer leur prise de décision TI",
    "comments": "Départements: TI, Cyber | Valeur contrats: 10352.22 | Rentabilité: Rentable (304 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Antoine Giroux). Priorités/enjeux: Intégrer l'IA, améliorer leur prise de décision TI. Relation: Excellente relation avec Frederic. Il apprécie BZ, comprend ce qu'on fait et a un intérêt marqué pour la TI.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Antoine Giroux",
    "sourceRow": 9,
    "ddcActive": true
  },
  {
    "clientName": "Gestion Légalis inc.",
    "accountManager": "Antoine Giroux",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Excellente relation de confiance, avec BZ depuis le début. Confiance aveugle en Dany. Prime vendeur: 6. Risque de perte: 1.",
    "recommendedAngle": "Gouvernance, clarifier les roles de son équipe TI. Avoir une vision IA et avancer.",
    "riskOrCondition": "Risque déclaré: 1. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Gouvernance, cybersécurité les deux priorités. Veulent avancer en IA mais prudemment. Beaucoup de difficulté avec leur gestion du niveau de leur coté. | Gouvernance, clarifier les roles de son équipe TI. Avoir une vision IA et avancer.",
    "comments": "Départements: TI, Cyber, Programmation | Valeur contrats: 20189.18 | Rentabilité: Rentable (482 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Antoine Giroux). Priorités/enjeux: Gouvernance, clarifier les roles de son équipe TI. Avoir une vision IA et avancer.. Relation: Excellente relation de confiance, avec BZ depuis le début. Confiance aveugle en Dany. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Antoine Giroux",
    "sourceRow": 10,
    "ddcActive": true
  },
  {
    "clientName": "Groupe Conseil DFM inc.",
    "accountManager": "Antoine Giroux",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Top client de BZ. La relation avec les points de contact DG et responsable TI est difficile. Pas de retour, pas d'engagement. 10/10 avec le technicien et meme chose pour les décideurs à plus haut niveau qui comprenne la valeur de BZ. Prime vendeur: 2. Risque de perte: à valider.",
    "recommendedAngle": "IA, IA, IA et accélerer leurs processus",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Difficulté à gérer leur croissance. Refuse des clients. Tous les associés sont toujours dans le jus. | IA, IA, IA et accélerer leurs processus",
    "comments": "Départements: TI, Cyber | Valeur contrats: 20631.45 | Rentabilité: Rentable (1275 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Antoine Giroux). Priorités/enjeux: IA, IA, IA et accélerer leurs processus. Relation: Top client de BZ. La relation avec les points de contact DG et responsable TI est difficile. Pas de retour, pas d'engagement. 10/10 avec le technicien et meme chose pour les décideurs à plus haut niveau qui comprenne la valeur de BZ. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Antoine Giroux",
    "sourceRow": 11,
    "ddcActive": true
  },
  {
    "clientName": "Groupe Hébert Ferlatte inc.",
    "accountManager": "Antoine Giroux",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Compagnie fermé garde du cloud pour raisons legales rien a faire | Départements: TI | Valeur contrats: 502.68 | Rentabilité: Rentable (1067 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Antoine Giroux). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Antoine Giroux",
    "sourceRow": 12,
    "ddcActive": true
  },
  {
    "clientName": "Groupe Juste pour Divertir",
    "accountManager": "Antoine Giroux",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Toujours des hauts et des bas avec eux. David Normandin ne jure que par BZ mais la direction bouge toujours la bas et les intervenants TI ne tuff jamais.. Prime vendeur: 6. Risque de perte: 4.",
    "recommendedAngle": "Arreter de tirer de l'arrière en TI. Implanter l'IA pour sauver du temps toutes les executifs sont débordés",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Rotation de personnel. Enjeu budgétaires constant. Rien avance en TI. | Arreter de tirer de l'arrière en TI. Implanter l'IA pour sauver du temps toutes les executifs sont débordés",
    "comments": "Départements: TI | Valeur contrats: 19600.39 | Rentabilité: Rentable (330 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Antoine Giroux). Priorités/enjeux: Arreter de tirer de l'arrière en TI. Implanter l'IA pour sauver du temps toutes les executifs sont débordés. Relation: Toujours des hauts et des bas avec eux. David Normandin ne jure que par BZ mais la direction bouge toujours la bas et les intervenants TI ne tuff jamais.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Antoine Giroux",
    "sourceRow": 13,
    "ddcActive": true
  },
  {
    "clientName": "Gyro-Trac Corporation",
    "accountManager": "Antoine Giroux",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Steve quirion a pris sa retraite Jean Nicola nous fait énormément confiance mais toujours dur de ce faire payer.. Prime vendeur: 6. Risque de perte: 7.",
    "recommendedAngle": "Améliorer l'efficacité et ouvrir des nouveaux marchés",
    "riskOrCondition": "Risque déclaré: 7. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Enjeu avec les États-Unis(multi site, frais de douanes les ont tué). Doive revoir leurs marchés | Améliorer l'efficacité et ouvrir des nouveaux marchés",
    "comments": "Départements: TI | Valeur contrats: 3845.5 | Rentabilité: Rentable (594 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Antoine Giroux). Priorités/enjeux: Améliorer l'efficacité et ouvrir des nouveaux marchés. Relation: Steve quirion a pris sa retraite Jean Nicola nous fait énormément confiance mais toujours dur de ce faire payer.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Antoine Giroux",
    "sourceRow": 14,
    "ddcActive": true
  },
  {
    "clientName": "Harrisson solution",
    "accountManager": "Antoine Giroux",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Intégrateur d'applicatif qui revend notre cloud",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Antoine Giroux). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Antoine Giroux",
    "sourceRow": 15,
    "ddcActive": true
  },
  {
    "clientName": "Kathleen Négociant inc. (Groupe Eleganza)",
    "accountManager": "Antoine Giroux",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Relation correcte, ils sont plus en contact avec Éric Hains dans les comités TI.. Prime vendeur: 3. Risque de perte: 3.",
    "recommendedAngle": "Souvent en réduction de cout, devrait améliorer leur position cyber, bénéficerait assurément de l'IA",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Croissance, plusieurs sites à gérer | Souvent en réduction de cout, devrait améliorer leur position cyber, bénéficerait assurément de l'IA",
    "comments": "Départements: TI | Valeur contrats: 9686.98 | Rentabilité: Rentable (909 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Antoine Giroux). Priorités/enjeux: Souvent en réduction de cout, devrait améliorer leur position cyber, bénéficerait assurément de l'IA. Relation: Relation correcte, ils sont plus en contact avec Éric Hains dans les comités TI.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Antoine Giroux",
    "sourceRow": 16,
    "ddcActive": true
  },
  {
    "clientName": "Ouellet Canada inc.",
    "accountManager": "Antoine Giroux",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: Nulle, c'est vraiment Dave Landry qui nous a plugger la bas. On est la pour nos cost Cloud. Prime vendeur: 1. Risque de perte: 3.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Valeur contrats: 17886",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Antoine Giroux). Priorités/enjeux: à préciser. Relation: Nulle, c'est vraiment Dave Landry qui nous a plugger la bas. On est la pour nos cost Cloud. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Antoine Giroux",
    "sourceRow": 17,
    "ddcActive": true
  },
  {
    "clientName": "PCA Services corporatifs inc.",
    "accountManager": "Antoine Giroux",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Très bonne relation avec Alex Labrie le président de Québec. Prime vendeur: 7. Risque de perte: 5.",
    "recommendedAngle": "Gouvernance, besoin d'IA pour accélerer. Ils viennent juste de se racheter à l'interne.",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Ils sont toutes des succursalles semi indépendates, Risque de perdre certaines succursalle. Manque de Gouvernance, de vision commune et de RACI entre les succursalles. | Gouvernance, besoin d'IA pour accélerer. Ils viennent juste de se racheter à l'interne.",
    "comments": "PCA Québec est tres safe mais je crains pour d'autres succursalles | Départements: TI, Cyber | Valeur contrats: 7926.41 | Rentabilité: Rentable (252 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Antoine Giroux). Priorités/enjeux: Gouvernance, besoin d'IA pour accélerer. Ils viennent juste de se racheter à l'interne.. Relation: Très bonne relation avec Alex Labrie le président de Québec. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Antoine Giroux",
    "sourceRow": 18,
    "ddcActive": true
  },
  {
    "clientName": "SPÉCIBOIS",
    "accountManager": "Antoine Giroux",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Cedric adore BZ et nous fait confiance aveugle sous toute la ligne. Client qui trippe beaucoup sur BZ. Prime vendeur: 9. Risque de perte: 2.",
    "recommendedAngle": "Implanter l'IA.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Cédric a un penchant fort pour la TI, difficile parfois de sortir les $ qui semblent limités. | Implanter l'IA.",
    "comments": "Départements: TI | Valeur contrats: 1446.78 | Rentabilité: Rentable (315 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Antoine Giroux). Priorités/enjeux: Implanter l'IA.. Relation: Cedric adore BZ et nous fait confiance aveugle sous toute la ligne. Client qui trippe beaucoup sur BZ. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Antoine Giroux",
    "sourceRow": 19,
    "ddcActive": true
  },
  {
    "clientName": "Transport Bernières inc.",
    "accountManager": "Antoine Giroux",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: C'est beaucuop améliorer dans les dernières années. Martine est dure à satisfaire, Karl ne veut jamais rien payer. Par contre ils comprennent la valeur de BZ mais parfois plus la valeur de JMC et VB. Prime vendeur: 7. Risque de perte: 2.",
    "recommendedAngle": "Mettre l'infrastructure à jour. Intégrer Dolbec aussi.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Retards technologiques constants. Refus d'investir. Peur d'avancer. Toujours dans le jus | Mettre l'infrastructure à jour. Intégrer Dolbec aussi.",
    "comments": "Départements: TI | Valeur contrats: 5426.31 | Rentabilité: Rentable (290 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Antoine Giroux). Priorités/enjeux: Mettre l'infrastructure à jour. Intégrer Dolbec aussi.. Relation: C'est beaucuop améliorer dans les dernières années. Martine est dure à satisfaire, Karl ne veut jamais rien payer. Par contre ils comprennent la valeur de BZ mais parfois plus la valeur de JMC et VB. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Antoine Giroux",
    "sourceRow": 20,
    "ddcActive": true
  },
  {
    "clientName": "Verdon Armanda Gauthier",
    "accountManager": "Antoine Giroux",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Excellente. Sophie adore BZ, excellente relation humaine avec moi et JMC. Autrefois tres dure maintenant elle est à l'écoute et très plaisante à servir. Prime vendeur: 8. Risque de perte: 2.",
    "recommendedAngle": "Je les prioriserait dans les rencontre IA sophie trip ben raide quand on lui parle d'IA.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Transformation technologique en cours. Elle trippe sur l'IA mais ne sait pas comment s'y prendre | Je les prioriserait dans les rencontre IA sophie trip ben raide quand on lui parle d'IA.",
    "comments": "Départements: TI | Valeur contrats: 4758.02 | Rentabilité: Rentable (456 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Antoine Giroux). Priorités/enjeux: Je les prioriserait dans les rencontre IA sophie trip ben raide quand on lui parle d'IA.. Relation: Excellente. Sophie adore BZ, excellente relation humaine avec moi et JMC. Autrefois tres dure maintenant elle est à l'écoute et très plaisante à servir. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Antoine Giroux",
    "sourceRow": 21,
    "ddcActive": true
  },
  {
    "clientName": "Ville de Saint-Lin-Laurentides",
    "accountManager": "Antoine Giroux",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Client ultra sympathique, ecoute les recommandations de BZ. La distance géographique fait que je ne suis pas aussi proche que je le serais car j'adore les servir. Prime vendeur: 6. Risque de perte: 5 juste à cause qu'ils nous donnent beaucoup de $ et qu'un jour ils pourraient etre obliger d'aller en appel d'offre sinon j'écrirais 1.",
    "recommendedAngle": "Données clients sont importantes pour eux.",
    "riskOrCondition": "Risque déclaré: 5 juste à cause qu'ils nous donnent beaucoup de $ et qu'un jour ils pourraient etre obliger d'aller en appel d'offre sinon j'écrirais 1. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Obligations contractuelles relié au fait d'etre une ville sont un risque pour BZ. Croissance importante de la ville. Beaucoup de lieux physique à gérer et collaboration parfois difficile avec la MRC | Données clients sont importantes pour eux.",
    "comments": "Départements: TI, Cyber | Valeur contrats: 16648.05 | Rentabilité: Rentable (802 $/h)",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Antoine Giroux). Priorités/enjeux: Données clients sont importantes pour eux.. Relation: Client ultra sympathique, ecoute les recommandations de BZ. La distance géographique fait que je ne suis pas aussi proche que je le serais car j'adore les servir. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Antoine Giroux",
    "sourceRow": 22,
    "ddcActive": true
  },
  {
    "clientName": "Édifice 500 Grande-Allée Est inc. et 4 bourgeois/ Delta/Boul Laurier/la cité verte",
    "accountManager": "Antoine Giroux",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: La relation avec Jacques Gallant était plus qu'excellente mais son successeur Steve est vraiment moins cool. La relation est plus tendu et strictement professionnel. Prime vendeur: 5, anciennement 9. Risque de perte: 6.",
    "recommendedAngle": "Accélérer, alléger la structure et améliorer leur posture en cybersécurité",
    "riskOrCondition": "Risque déclaré: 6. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "La firme de Montréal décide pour eux, structure extremement lourdre. Projets avancent à pas de tortue | Accélérer, alléger la structure et améliorer leur posture en cybersécurité",
    "comments": "Départ de Jacques Gallant fait très mal. Nous sommes très plugger par contre c'est le plus gros donneur d'ouvrage pour BZ Telecom, je fais donc toujours tres attention à ce client. | Départements: TI | Valeur contrats: 2147.02",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Antoine Giroux). Priorités/enjeux: Accélérer, alléger la structure et améliorer leur posture en cybersécurité. Relation: La relation avec Jacques Gallant était plus qu'excellente mais son successeur Steve est vraiment moins cool. La relation est plus tendu et strictement professionnel. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Antoine Giroux",
    "sourceRow": 23,
    "ddcActive": true
  },
  {
    "clientName": "Aciers Fax",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: Pas beaucoup de retours, donc nous n'avons pas discuté autant que souhaité. Peut-être avec leur renouvellement qui s'en vient, il y aura plus d'occasions.. Prime vendeur: 3. Risque de perte: 5.",
    "recommendedAngle": "1. En attente d'un retour de leur part pour la présentatiion du renouvellement. 2. Cyber.",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Avoir un retour, ne sont pas très présents. | 1. En attente d'un retour de leur part pour la présentatiion du renouvellement. 2. Cyber.",
    "comments": "En renouvellement | Départements: TI | Valeur contrats: 962.53 | Rentabilité: Rentable (240 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: 1. En attente d'un retour de leur part pour la présentatiion du renouvellement. 2. Cyber.. Relation: Pas beaucoup de retours, donc nous n'avons pas discuté autant que souhaité. Peut-être avec leur renouvellement qui s'en vient, il y aura plus d'occasions.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 2,
    "ddcActive": false
  },
  {
    "clientName": "Bosk Bioproducts",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: La relation est correcte, pas d'attache émotionelle je m'assure de faire les rappels de paiements le plus diplomatiquement possible. Je mets de l'avant notre intention de maintenir une belle relation de partenariat.. Prime vendeur: 6. Risque de perte: 3 - Si on le perds c'est parce que la compagnie se ramasse dans le trouble financièrement, autrement avec la rentabilité, ils n'iront nulle part..",
    "recommendedAngle": "1. Potentiellement mettre un check-in 5 jours, 3 jours avant d'atteindre le premier 30 jours de retards de paiement. Style \"Votre facture arrive à échéance vendredi\" plutôt que d'attendre que le système les notifie??",
    "riskOrCondition": "Risque déclaré: 3 - Si on le perds c'est parce que la compagnie se ramasse dans le trouble financièrement, autrement avec la rentabilité, ils n'iront nulle part.. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Outre de devoir leur chanter la même chanson à chaque fois en ce qui concerne leurs soldes à payer, ils ne sont pas très intéressés TI. Sont fermés pour l'instant à l'idée de diner. | 1. Potentiellement mettre un check-in 5 jours, 3 jours avant d'atteindre le premier 30 jours de retards de paiement. Style \"Votre facture arrive à échéance vendredi\" plutôt que d'attendre que le système les notifie??",
    "comments": "Sont toujours en retard dans leurs paiements et attendent la dernière minute afin de régler leurs comptes. Peu, ou presque pas d'intéraction, ils ne sont pas très répondant. | Départements: TI | Valeur contrats: 787.13 | Rentabilité: Rentable (448 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: 1. Potentiellement mettre un check-in 5 jours, 3 jours avant d'atteindre le premier 30 jours de retards de paiement. Style \"Votre facture arrive à échéance vendredi\" plutôt que d'attendre que le système les notifie??. Relation: La relation est correcte, pas d'attache émotionelle je m'assure de faire les rappels de paiements le plus diplomatiquement possible. Je mets de l'avant notre intention de maintenir une belle relation de partenariat.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 3,
    "ddcActive": false
  },
  {
    "clientName": "Bouchard Bussières Carrier Architectes inc.",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: La relation est professionelle, pas vraiment d'emotions, ce sont des clients de type \"pas de nouvelles, bonne nouvelles\". Stéphanie m'a indiqué que lorsqu'ils auront des besoins additionnels ou changeants elle me contacterait sans faute. Elle aime la photographie de nature et d'oiseaux et ses deux fils jouent au hockey.. Prime vendeur: 6. Risque de perte: 3.",
    "recommendedAngle": "1. Automatiser leur processus répétitif (Onboarding, demande d'accès, etc) 2. BOT IA. 3. Implanter de la Cyber, quitte à commencer seulement avec un SAT. 4. Organiser un diner, cocktail, 5 à 7.",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Depuis mon arrivée en Février, ce client a eu 61 tickets TI ouverts dont la majorité se tournent autour du serveur, de la sauvegarde et du stockage. | 1. Automatiser leur processus répétitif (Onboarding, demande d'accès, etc) 2. BOT IA. 3. Implanter de la Cyber, quitte à commencer seulement avec un SAT. 4. Organiser un diner, cocktail, 5 à 7.",
    "comments": "NA | Départements: TI | Valeur contrats: 1904.35 | Rentabilité: Rentable (437 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: 1. Automatiser leur processus répétitif (Onboarding, demande d'accès, etc) 2. BOT IA. 3. Implanter de la Cyber, quitte à commencer seulement avec un SAT. 4. Organiser un diner, cocktail, 5 à 7.. Relation: La relation est professionelle, pas vraiment d'emotions, ce sont des clients de type \"pas de nouvelles, bonne nouvelles\". Stéphanie m'a indiqué que lorsqu'ils auront des besoins additionnels ou changeants elle me contacterait sans faute. Elle aime la photographie de nature et d'oiseaux et ses deux fils jouent au hockey.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 4,
    "ddcActive": false
  },
  {
    "clientName": "Construction CRD",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: Très bien, pas d'enjeu, j'attends toujours pour diner avec eux mais Simon m'a invité à passer directement dans leurs bureaux prochainement. Ce sera donc une petite visite.. Prime vendeur: 7. Risque de perte: 3.",
    "recommendedAngle": "1. Rencontrer afin de présenter plan directeur. 2. Céduler une recontre pour l'IA. Implanter de la Cyber. Aller diner dès qu'il a une dispo.",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Client très occupé, notamment en période printemps-été plus difficile de parler TI et autres projets | 1. Rencontrer afin de présenter plan directeur. 2. Céduler une recontre pour l'IA. Implanter de la Cyber. Aller diner dès qu'il a une dispo.",
    "comments": "Plan directeur | Départements: TI | Valeur contrats: 2615.29 | Rentabilité: Rentable (230 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: 1. Rencontrer afin de présenter plan directeur. 2. Céduler une recontre pour l'IA. Implanter de la Cyber. Aller diner dès qu'il a une dispo.. Relation: Très bien, pas d'enjeu, j'attends toujours pour diner avec eux mais Simon m'a invité à passer directement dans leurs bureaux prochainement. Ce sera donc une petite visite.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 5,
    "ddcActive": false
  },
  {
    "clientName": "Drains Secours (Labo LCS)",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Prospect",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 6,
    "ddcActive": false
  },
  {
    "clientName": "Durand Construction",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: Excellente relation avec Samuel. Je peux me permettre de l'appeler directement sur son téléphone personnel. C'est un jeune homme très calme, organisé et aime l'optimisation. Il adore la pêche, le hockey. Il a une Harley Davidson Dyna Low Rider, un Pick-up et un adorable Boston Terrier noir et blanc.. Prime vendeur: 8. Risque de perte: 2.",
    "recommendedAngle": "1. Implanter de la cyber. 2. Les rencontrer avec JM et Antoine pour discuter d'un potentiel partenariat pour leur autres projets. 3. Un BOT, ils sont jeunes, allumés et intéressés. 4. Plan de continuité et amélioration sécurité avancée (Simulation de panne, plan de reprise, etc)",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Les gars peuvent être vraiment débordé par moment, cela peut être long avant qu'ils répondent. Sinon, pas d'enjeux à ma connaissance. C'est très important avec eux de leur montrer concrètement ce qu'on offre. Ils ont besoins de visuel. | 1. Implanter de la cyber. 2. Les rencontrer avec JM et Antoine pour discuter d'un potentiel partenariat pour leur autres projets. 3. Un BOT, ils sont jeunes, allumés et intéressés. 4. Plan de continuité et amélioration sécurité avancée (Simulation de panne, plan de reprise, etc)",
    "comments": "Ils travaillent sur plusieurs nouveaux développement. Nous aimerions tenter de nous imposer pour l'infogérance de chacun des établissements mais également pour la téléphonie. | Départements: TI | Valeur contrats: 3168.78 | Rentabilité: Rentable (605 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: 1. Implanter de la cyber. 2. Les rencontrer avec JM et Antoine pour discuter d'un potentiel partenariat pour leur autres projets. 3. Un BOT, ils sont jeunes, allumés et intéressés. 4. Plan de continuité et amélioration sécurité avancée (Simulation de panne, plan de reprise, etc). Relation: Excellente relation avec Samuel. Je peux me permettre de l'appeler directement sur son téléphone personnel. C'est un jeune homme très calme, organisé et aime l'optimisation. Il adore la pêche, le hockey. Il a une Harley Davidson Dyna Low Rider, un Pick-up et un adorable Boston Terrier noir et blanc.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 7,
    "ddcActive": false
  },
  {
    "clientName": "Entretien JFB",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: Eu quelques contactes par téléphone. Mais définitivement un client à approfondir. Il y a du potentiel, belle entreprise en croissance.. Prime vendeur: 5. Risque de perte: 2.",
    "recommendedAngle": "1. Relancer la téléphonie suite à l'offre déposée avec les nouveaux développement présentés par Martin Carrier. 2. IA. 3. Diner, cocktail, évènement partenaires.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "NA | 1. Relancer la téléphonie suite à l'offre déposée avec les nouveaux développement présentés par Martin Carrier. 2. IA. 3. Diner, cocktail, évènement partenaires.",
    "comments": "NA | Départements: TI | Valeur contrats: 1243.39 | Rentabilité: Rentable (968 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: 1. Relancer la téléphonie suite à l'offre déposée avec les nouveaux développement présentés par Martin Carrier. 2. IA. 3. Diner, cocktail, évènement partenaires.. Relation: Eu quelques contactes par téléphone. Mais définitivement un client à approfondir. Il y a du potentiel, belle entreprise en croissance.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 8,
    "ddcActive": false
  },
  {
    "clientName": "Gestion ajc inc.",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: Très peu de contacte. Prime vendeur: 2. Risque de perte: 5.",
    "recommendedAngle": "L'objectif principal est de trouver un point de contact simple et idéal afin qu'on aille plus de retour. On veut des échanges simples selon le canal qui lui convient le mieux. SMS, appel, Teams, rencontre en vrai. Etc. 2. Planifier des rencontre récurrentes (Si c'est un 20 minutes de céduler déjà d'avance dans leur horaire, ils risquent pas d'annuler) 3. Voir comment optimiser et faciliter leur quotidien.",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Difficile d'avoir des retours. | L'objectif principal est de trouver un point de contact simple et idéal afin qu'on aille plus de retour. On veut des échanges simples selon le canal qui lui convient le mieux. SMS, appel, Teams, rencontre en vrai. Etc. 2. Planifier des rencontre récurrentes (Si c'est un 20 minutes de céduler déjà d'avance dans leur horaire, ils risquent pas d'annuler) 3. Voir comment optimiser et faciliter leur quotidien.",
    "comments": "NA | Départements: TI | Valeur contrats: 239.5 | Rentabilité: Moyen (151 $/h)",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: L'objectif principal est de trouver un point de contact simple et idéal afin qu'on aille plus de retour. On veut des échanges simples selon le canal qui lui convient le mieux. SMS, appel, Teams, rencontre en vrai. Etc. 2. Planifier des rencontre récurrentes (Si c'est un 20 minutes de céduler déjà d'avance dans leur horaire, ils risquent pas d'annuler) 3. Voir comment optimiser et faciliter leur quotidien.. Relation: Très peu de contacte. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 9,
    "ddcActive": false
  },
  {
    "clientName": "Gestion France Marcotte inc.",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: Très peu de contacte. Prime vendeur: 2. Risque de perte: 5.",
    "recommendedAngle": "L'objectif principal est de trouver un point de contact simple et idéal afin qu'on aille plus de retour. On veut des échanges simples selon le canal qui lui convient le mieux. SMS, appel, Teams, rencontre en vrai. Etc. 2. Planifier des rencontre récurrentes (Si c'est un 20 minutes de céduler déjà d'avance dans leur horaire, ils risquent pas d'annuler) 3. Voir comment optimiser et faciliter leur quotidien.",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Difficile d'avoir des retours. | L'objectif principal est de trouver un point de contact simple et idéal afin qu'on aille plus de retour. On veut des échanges simples selon le canal qui lui convient le mieux. SMS, appel, Teams, rencontre en vrai. Etc. 2. Planifier des rencontre récurrentes (Si c'est un 20 minutes de céduler déjà d'avance dans leur horaire, ils risquent pas d'annuler) 3. Voir comment optimiser et faciliter leur quotidien.",
    "comments": "NA | Départements: TI | Valeur contrats: 231.59 | Rentabilité: Rentable (5003 $/h)",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: L'objectif principal est de trouver un point de contact simple et idéal afin qu'on aille plus de retour. On veut des échanges simples selon le canal qui lui convient le mieux. SMS, appel, Teams, rencontre en vrai. Etc. 2. Planifier des rencontre récurrentes (Si c'est un 20 minutes de céduler déjà d'avance dans leur horaire, ils risquent pas d'annuler) 3. Voir comment optimiser et faciliter leur quotidien.. Relation: Très peu de contacte. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 10,
    "ddcActive": false
  },
  {
    "clientName": "Gosselin Tremblay Excavation inc.",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: La relation est bonne, polie et strictement professionnel. Ils sont plutôt froid et difficile à avoir par courriel et par téléphone. Pas particulièrement d'intérêt pour diner ou pour les TI.. Prime vendeur: 6. Risque de perte: 4.",
    "recommendedAngle": "L'objectif principal est de trouver un point de contact simple et idéal afin qu'on aille plus de retour. On veut des échanges simples selon le canal qui lui convient le mieux. SMS, appel, Teams, rencontre en vrai. Etc. 2. Planifier des rencontre récurrentes (Si c'est un 20 minutes de céduler déjà d'avance dans leur horaire, ils risquent pas d'annuler) 3. Voir comment optimiser et faciliter leur quotidien.",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Leur VPN et leur Onedrive leur donnait beaucoup de fil à retordre, la problématique était récurrente. | L'objectif principal est de trouver un point de contact simple et idéal afin qu'on aille plus de retour. On veut des échanges simples selon le canal qui lui convient le mieux. SMS, appel, Teams, rencontre en vrai. Etc. 2. Planifier des rencontre récurrentes (Si c'est un 20 minutes de céduler déjà d'avance dans leur horaire, ils risquent pas d'annuler) 3. Voir comment optimiser et faciliter leur quotidien.",
    "comments": "Toujours en meeting à toute heure de la journée. A refusé d'extensionner sa garantie serveur. | Départements: TI | Valeur contrats: 2,389.27 $ | Rentabilité: Rentable (383 $/h)",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: L'objectif principal est de trouver un point de contact simple et idéal afin qu'on aille plus de retour. On veut des échanges simples selon le canal qui lui convient le mieux. SMS, appel, Teams, rencontre en vrai. Etc. 2. Planifier des rencontre récurrentes (Si c'est un 20 minutes de céduler déjà d'avance dans leur horaire, ils risquent pas d'annuler) 3. Voir comment optimiser et faciliter leur quotidien.. Relation: La relation est bonne, polie et strictement professionnel. Ils sont plutôt froid et difficile à avoir par courriel et par téléphone. Pas particulièrement d'intérêt pour diner ou pour les TI.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 11,
    "ddcActive": false
  },
  {
    "clientName": "Groupe Gaétan Castonguay Inc",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: Relation un tantinet tendu par moments mais nos intéractions sont toujours transparentes, bienveillantes et dans un bon délais. J'ai invité Camille à diner avec moi lorsqu'elle aura une minute, elle va me revenir lorsqu'elle sera plus libre.. Prime vendeur: 5. Risque de perte: 4.",
    "recommendedAngle": "1. Redresser la relation, se repositionner comme un excellent partenaire. Je crois qu'ils ont tendance à nous voir comme \"il nous facture des services\" plutôt qu'un partenaire qui les aide à atteindre leurs objectifs. 2. PriSme. 3. Peut-être effectuer des sondages après plusieurs interventions offertes afin d'avoir leur feedback plus souvent. 4. Communication pro-active. 5. Mettre en évidence leur réussite, ce qui se passe très bien. 5. Les inviter à nos évènements clients. 6. Implanter plus de Cyber. Je pense que l'objectif avant tout avec ces clients est qu'ils se sentent écoutés, considérés et impliqués.",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "107 tickets d'ouvert depuis mon arrivée. Notamment sur 365 et leur sauvegardes. C'est souvent des demandes au niveau des courriels. Vont nous challenger sur les coûts. Ne sont pas les plus actif au niveau des réponses. Je dois donc les appeler plusieurs fois pour relancer. | 1. Redresser la relation, se repositionner comme un excellent partenaire. Je crois qu'ils ont tendance à nous voir comme \"il nous facture des services\" plutôt qu'un partenaire qui les aide à atteindre leurs objectifs. 2. PriSme. 3. Peut-être effectuer des sondages après plusieurs interventions offertes afin d'avoir leur feedback plus souvent. 4. Communication pro-active. 5. Mettre en évidence leur réussite, ce qui se passe très bien. 5. Les inviter à nos évènements clients. 6. Implanter plus de Cyber. Je pense que l'objectif avant tout avec ces clients est qu'ils se sentent écoutés, considérés et impliqués.",
    "comments": "Nous ont approché en challengeant ce qu'ils payaient vs ce que nous leur offrons. Ne voyait pas la valeur de ce que nous avions présentés. Antoine a donc tenté de sauver des frais en leur proposant une solution en cyber. Elles veulent toute avoir et ne sont pas très ouvertes à la négociation. Elles voulaient également obtenir des heures en facturable. Antoine m'a envoyé afin de tenter de me rapprocher de cette cliente, depuis je suis particulièrement à l'affut de ce compte. Ont également l'habitude par moment de \"Tchoké\" une rencontre ou appel. | Départements: TI, Cyber | Valeur contrats: 3339.89 | Rentabilité: Rentable (235 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: 1. Redresser la relation, se repositionner comme un excellent partenaire. Je crois qu'ils ont tendance à nous voir comme \"il nous facture des services\" plutôt qu'un partenaire qui les aide à atteindre leurs objectifs. 2. PriSme. 3. Peut-être effectuer des sondages après plusieurs interventions offertes afin d'avoir leur feedback plus souvent. 4. Communication pro-active. 5. Mettre en évidence leur réussite, ce qui se passe très bien. 5. Les inviter à nos évènements clients. 6. Implanter plus de Cyber. Je pense que l'objectif avant tout avec ces clients est qu'ils se sentent écoutés, considérés et impliqués.. Relation: Relation un tantinet tendu par moments mais nos intéractions sont toujours transparentes, bienveillantes et dans un bon délais. J'ai invité Camille à diner avec moi lorsqu'elle aura une minute, elle va me revenir lorsqu'elle sera plus libre.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 12,
    "ddcActive": false
  },
  {
    "clientName": "Isolation Beauport",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: Bien, aucun enjeu. J'aimerais me rapprocher davantages de David. Je sais qu'il a quand même une bonne ouverture globale.. Prime vendeur: 5. Risque de perte: 2.",
    "recommendedAngle": "1.Implanter potentiellement un BOT, le client a témoigné de l'intérêt dernièrement. 2. Se rapprocher d'eux.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Pas d'enjeux que je connaisse. Rien de réccurent non plus. Ne sont pas les plus bavards, j'aimerais trouver une manière de retirer plus d'intel d'eux. À suivre. | 1.Implanter potentiellement un BOT, le client a témoigné de l'intérêt dernièrement. 2. Se rapprocher d'eux.",
    "comments": "Ont signés leur renouvellement avec un SAT en plus. | Départements: TI | Valeur contrats: 835.84 | Rentabilité: Rentable (478 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: 1.Implanter potentiellement un BOT, le client a témoigné de l'intérêt dernièrement. 2. Se rapprocher d'eux.. Relation: Bien, aucun enjeu. J'aimerais me rapprocher davantages de David. Je sais qu'il a quand même une bonne ouverture globale.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 13,
    "ddcActive": false
  },
  {
    "clientName": "L'atelier Dentaire",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: Bien, aucun enjeu...avec les nombreux irritants, je risque de leur donner davantages d'amour prochainement. À voir comment améliorer le parc techno et renforcer notre relation.. Prime vendeur: 5. Risque de perte: 3.",
    "recommendedAngle": "1. Régulariser et optimiser son environnement TI afin de réduire le plus des problématiques expérimentées. 2. SAT. 3. Rencontre pour parler de l'IA. 4. Rafraîchir leur inventaire serait également pertinent.",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Les principaux irritants concernent un environnement informatique instable où des problèmes réseau récurrents, un accès distant complexe et peu fiable (VPN, Bureau à distance et Acomba), des erreurs fréquentes d’authentification, des interventions techniques longues en raison de la complexité de l’environnement, ainsi qu’un VPN ne respectant pas les bonnes pratiques de sécurité (absence de MFA et utilisation de comptes locaux sur le FortiGate) nuisent à l’efficacité et à la sécurité. | 1. Régulariser et optimiser son environnement TI afin de réduire le plus des problématiques expérimentées. 2. SAT. 3. Rencontre pour parler de l'IA. 4. Rafraîchir leur inventaire serait également pertinent.",
    "comments": "Alex Barrette m'a partagé déjà quelques fois que ce client éprouvait beaucoup d'enjeux. J'ai depuis déjà pris contact avec afin qu'on s'entende sur une solution à long terme. | Départements: TI | Valeur contrats: 341.86 | Rentabilité: Moyen (177 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: 1. Régulariser et optimiser son environnement TI afin de réduire le plus des problématiques expérimentées. 2. SAT. 3. Rencontre pour parler de l'IA. 4. Rafraîchir leur inventaire serait également pertinent.. Relation: Bien, aucun enjeu...avec les nombreux irritants, je risque de leur donner davantages d'amour prochainement. À voir comment améliorer le parc techno et renforcer notre relation.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 14,
    "ddcActive": false
  },
  {
    "clientName": "Le Charnycois",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: Sebastien est tellement gentil. on s'entends super bien. On s'appelles régulièrement. On rigoles beaucoup. Toujours tellement poli. 10/10, rien à dire.. Prime vendeur: 7. Risque de perte: 2.",
    "recommendedAngle": "1. Rencontre afin de voir comment optimiser leur environnement. 2. Cybersécurité. 3. IA. 4. Avoir une communication claire et proactive. Il aime savoir exactement à quoi s'attendre et dans quel délais.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Ont eu quelques problématiques au niveau de leur équipement, notamment leurs switch mais aussi au niveau de leur accès. | 1. Rencontre afin de voir comment optimiser leur environnement. 2. Cybersécurité. 3. IA. 4. Avoir une communication claire et proactive. Il aime savoir exactement à quoi s'attendre et dans quel délais.",
    "comments": "M'a partagé qu'il n'obtenait pas souvent de suivi clairs suite à ses requêtes. | Départements: TI | Valeur contrats: 734.5 | Rentabilité: Rentable (268 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: 1. Rencontre afin de voir comment optimiser leur environnement. 2. Cybersécurité. 3. IA. 4. Avoir une communication claire et proactive. Il aime savoir exactement à quoi s'attendre et dans quel délais.. Relation: Sebastien est tellement gentil. on s'entends super bien. On s'appelles régulièrement. On rigoles beaucoup. Toujours tellement poli. 10/10, rien à dire.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 15,
    "ddcActive": false
  },
  {
    "clientName": "Les Pierres Technoprofil",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: Belle relation, professionelle mais s'enligne tranquillement vers plus proche. Dès que l'opportunité de faire un évènement ou un 5 à 7 ou même juste un diner, je vais sauter là-dessus.. Prime vendeur: 7. Risque de perte: 3.",
    "recommendedAngle": "1. Ajout de Cyber, SAT et rencontrer pour IA. 2. Un diner avec eux serait également une priorité.",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Ont vécu des problématiques récurrentes au niveau de leur VPN, elles sont réglés. Autrement, pas d'autres enjeux notés. | 1. Ajout de Cyber, SAT et rencontrer pour IA. 2. Un diner avec eux serait également une priorité.",
    "comments": "NA | Départements: TI | Valeur contrats: 2265.31 | Rentabilité: Moyen (172 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: 1. Ajout de Cyber, SAT et rencontrer pour IA. 2. Un diner avec eux serait également une priorité.. Relation: Belle relation, professionelle mais s'enligne tranquillement vers plus proche. Dès que l'opportunité de faire un évènement ou un 5 à 7 ou même juste un diner, je vais sauter là-dessus.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 16,
    "ddcActive": false
  },
  {
    "clientName": "Maconnerie AMP Inc",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: À peine de contacte. Prime vendeur: 4. Risque de perte: à valider.",
    "recommendedAngle": "1. Augmenter le nombre de contacteé 2. Céduler un moment afin de leur présenter leur Plan directeur. 3. IA. 4. Cyber.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Difficile d'avoir des retours. | 1. Augmenter le nombre de contacteé 2. Céduler un moment afin de leur présenter leur Plan directeur. 3. IA. 4. Cyber.",
    "comments": "Plan directeur | Départements: TI | Valeur contrats: 868.96 | Rentabilité: Rentable (343 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: 1. Augmenter le nombre de contacteé 2. Céduler un moment afin de leur présenter leur Plan directeur. 3. IA. 4. Cyber.. Relation: À peine de contacte. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 17,
    "ddcActive": false
  },
  {
    "clientName": "Maison des métiers d'art de Québec",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: Belle relation avec Thierry bien que pas encore assez proche à mon goût. Il a beaucoup à gérer donc nous n'avons pas l'opportunité d'échanger autant que je le souhaiterais. Je lui laisse savoir périodiquement que je suis disponible s'il a des besoins, changements, irritants. C'est une personne très enjoué, pétillante et rigoleuse. Est un amoureux de la céramique comme moi. Il apprécie la musique classique, la nature, le bord de l'eau et adore mettre des chapeaux melons.. Prime vendeur: 7. Risque de perte: 1.",
    "recommendedAngle": "1. IA !!! 2. Se rapprocher d'eux, cocktails, évènements partenaires ou peut-être comité TI ? 3. On témoigné de l'interait afin qu'on les aider dans leur onboarding employé, donc une rencontre serait de mise.",
    "riskOrCondition": "Risque déclaré: 1. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Pas d'enjeux que je connaisse. Rien de réccurent non plus. Thierry m'a indiqué qu'il était plus \"tight\" actuellement niveau investissement TI mais qu'il y pensait. | 1. IA !!! 2. Se rapprocher d'eux, cocktails, évènements partenaires ou peut-être comité TI ? 3. On témoigné de l'interait afin qu'on les aider dans leur onboarding employé, donc une rencontre serait de mise.",
    "comments": "Ont atteint leur quota en terme de budget TI pour l'instant. Ils aimeraient beaucoup intégrer l'IA dans leur quotidien mais cela devra attendre. | Départements: TI | Valeur contrats: 3247.95",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: 1. IA !!! 2. Se rapprocher d'eux, cocktails, évènements partenaires ou peut-être comité TI ? 3. On témoigné de l'interait afin qu'on les aider dans leur onboarding employé, donc une rencontre serait de mise.. Relation: Belle relation avec Thierry bien que pas encore assez proche à mon goût. Il a beaucoup à gérer donc nous n'avons pas l'opportunité d'échanger autant que je le souhaiterais. Je lui laisse savoir périodiquement que je suis disponible s'il a des besoins, changements, irritants. C'est une personne très enjoué, pétillante et rigoleuse. Est un amoureux de la céramique comme moi. Il apprécie la musique classique, la nature, le bord de l'eau et adore mettre des chapeaux melons.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 18,
    "ddcActive": false
  },
  {
    "clientName": "Maçonnerie Gervais & Associés",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: Belle relation de confiance avec Keven Dallaire et Jessica, une belle proximité également. Ils nous gardent toujours dans la loupe pour les problématiques, irritants mais aussi les bons coups. Bon communicateur, c'est facile de les obtenirs au téléphone ou par courriel. Jessica est le bras droit de Keven, c'est majoritairement avec elle que je m'entretiens. Son anniversaire est le 25 mars. Elle aime les HIIT workout, les comédies musicales, le vin et les desserts très sucrées. Elle a 4 neveux et deux sœurs. Elle a 36 ans. Ils peuvent être désagréable par téléphone et sont très peu patients.. Prime vendeur: 8. Risque de perte: 2.",
    "recommendedAngle": "1. Régulariser les problématiques de lenteurs expérimenté. 2. Intégrer de la Cyber comme ils ont vécu un incident d'hameçonnage récemment. 3. Les rencontrer pour parler d'implanter un BOT afin de faciliter les rapports de Jessica. 4. Garder une relation de proximité afin qu'ils cessent de voir les TI comme une dépense et voit l'investissement à long terme.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Actuellement ils sont avec MIR pour leur garage et avec Maestro pour leur comptabilité. La relation avec Maestro est tendu comme ils ont manqués de transparence envers le client. Ce qui a créée quelques tensions avec BZ. Leur principal enjeux est au niveau de la performance de leur TI. Ils m'ont mentionnés à quelques reprises les pertes de connexion ainsi que les lenteurs qu'ils expérimentent régulièrement. | 1. Régulariser les problématiques de lenteurs expérimenté. 2. Intégrer de la Cyber comme ils ont vécu un incident d'hameçonnage récemment. 3. Les rencontrer pour parler d'implanter un BOT afin de faciliter les rapports de Jessica. 4. Garder une relation de proximité afin qu'ils cessent de voir les TI comme une dépense et voit l'investissement à long terme.",
    "comments": "Ils sont très frileux côté monétaire mais cherche à moderniser leur TI en même temps. Ils accordent beaucoup d'importance à l'efficacité dans leurs opérations. Keven est venu nous rendre visite directement dans nos bureaux afin qu'Antoine puisse lui dessiner les TI. La discussion a relevé des questions quant à la relation entre MIR-nos serveurs et Maestro. Actuellement, Francis Marquis est en investigation afin de comprendre le tout ainsi que tenter de trouver une solution qui peut baisser les coûts globaux de stockage. Ils ont tendances à challenger sans même savoir de quoi ils parlent. | Départements: TI | Valeur contrats: 1,618.75 $ | Rentabilité: Moyen (177 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: 1. Régulariser les problématiques de lenteurs expérimenté. 2. Intégrer de la Cyber comme ils ont vécu un incident d'hameçonnage récemment. 3. Les rencontrer pour parler d'implanter un BOT afin de faciliter les rapports de Jessica. 4. Garder une relation de proximité afin qu'ils cessent de voir les TI comme une dépense et voit l'investissement à long terme.. Relation: Belle relation de confiance avec Keven Dallaire et Jessica, une belle proximité également. Ils nous gardent toujours dans la loupe pour les problématiques, irritants mais aussi les bons coups. Bon communicateur, c'est facile de les obtenirs au téléphone ou par courriel. Jessica est le bras droit de Keven, c'est majoritairement avec elle que je m'entretiens. Son anniversaire est le 25 mars. Elle aime les HIIT workout, les comédies musicales, le vin et les desserts très sucrées. Elle a 4 neveux et deux sœurs. Elle a 36 ans. Ils peuvent être désagréable par téléphone et sont très peu patients.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 19,
    "ddcActive": false
  },
  {
    "clientName": "Métal Léger L. & V. inc.",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: Dave me fait part lorsqu'il a besoin de quelque chose, très sympathique. Rien à re-dire là-dessus, je pense que ça pourrait s'approfondir avec le temps.. Prime vendeur: 7. Risque de perte: 3.",
    "recommendedAngle": "1. Diner avec le client. 2. Implanter de la cyber. 3. Rencontre pour discuter de comment l'IA pourrait les aider. 4. Voir si plus avantageux de les héberger chez nous?",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Pas d'enjeux que je connaisse. Rien de réccurent non plus. Thierry m'a indiqué qu'il était plus \"tight\" actuellement niveau investissement TI mais qu'il y pensait. | 1. Diner avec le client. 2. Implanter de la cyber. 3. Rencontre pour discuter de comment l'IA pourrait les aider. 4. Voir si plus avantageux de les héberger chez nous?",
    "comments": "Ont récemment prolonger leur garantie serveur | Départements: TI | Valeur contrats: 927.44",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: 1. Diner avec le client. 2. Implanter de la cyber. 3. Rencontre pour discuter de comment l'IA pourrait les aider. 4. Voir si plus avantageux de les héberger chez nous?. Relation: Dave me fait part lorsqu'il a besoin de quelque chose, très sympathique. Rien à re-dire là-dessus, je pense que ça pourrait s'approfondir avec le temps.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 20,
    "ddcActive": false
  },
  {
    "clientName": "Nova Construction C.P. inc",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: On s'entends super bien, Seb est vraiment gentil. Il m'envoit des messages clairs sur ces besoins, je m'assure de le garder in the loop. J'aimerais avoir l'opportunité de diner avec prochainement mais je comprends que le domaine de la construction est souvent débordé, on s'est donc entendu que ça ira à l'automne.. Prime vendeur: 8. Risque de perte: 3.",
    "recommendedAngle": "1. Exploiter son potentiel intérêt pour de l'IA. 2. Continuer de renforcer sa Cyber. 3. Diner avec le client.",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Ils sont passé au feu donc, tranquillement mais surement en reconstruction de leur environnement TI. | 1. Exploiter son potentiel intérêt pour de l'IA. 2. Continuer de renforcer sa Cyber. 3. Diner avec le client.",
    "comments": "A eu quelques mouvements au niveau de son personnel récemment, j'ai envoyé la demande pour ses licences qui prennent fin en juillet. Changé celles qui était mensuelles en annuelles pour lui faire économiser des sous. | Départements: TI, Cyber | Valeur contrats: 2056.31 | Rentabilité: Rentable (218 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: 1. Exploiter son potentiel intérêt pour de l'IA. 2. Continuer de renforcer sa Cyber. 3. Diner avec le client.. Relation: On s'entends super bien, Seb est vraiment gentil. Il m'envoit des messages clairs sur ces besoins, je m'assure de le garder in the loop. J'aimerais avoir l'opportunité de diner avec prochainement mais je comprends que le domaine de la construction est souvent débordé, on s'est donc entendu que ça ira à l'automne.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 21,
    "ddcActive": false
  },
  {
    "clientName": "Orchestro",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: Belle relation avec JS, il est compréhensif et super gentil, s'il y a quoique ce soit il va m'appeler ou m'écrire.. Prime vendeur: 8. Risque de perte: 3.",
    "recommendedAngle": "1. Implanter de la cyber suite à leur récent incident. 2. Optimiser leurs opérations. 3. Intégrer de l'IA. 4. Diner avec le client afin de renforcer la relation.",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "NA | 1. Implanter de la cyber suite à leur récent incident. 2. Optimiser leurs opérations. 3. Intégrer de l'IA. 4. Diner avec le client afin de renforcer la relation.",
    "comments": "Le 25 mai ils ont subi un incident en cyber. Une tentative d'hameçonnage. Un des utilisateur aurait cliquer sur un lien qu'il croyait légitime comme il attendait un document d'un client. | Départements: TI | Valeur contrats: 2828.17 | Rentabilité: Rentable (659 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: 1. Implanter de la cyber suite à leur récent incident. 2. Optimiser leurs opérations. 3. Intégrer de l'IA. 4. Diner avec le client afin de renforcer la relation.. Relation: Belle relation avec JS, il est compréhensif et super gentil, s'il y a quoique ce soit il va m'appeler ou m'écrire.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 22,
    "ddcActive": false
  },
  {
    "clientName": "Philippe Girard Prosthodontiste Inc.",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: Belle relation somme toute, il est plutôt indépendant. C'est purement professionnel. Philippe est très gentil et jovial. Il a deux enfants un petit garçon et une petite fille. Aime voyager en France. A son propre cabinet dentaire depuis 2025. Il est également le président actuel de la société dentaire de Québec.. Prime vendeur: 5. Risque de perte: 4.",
    "recommendedAngle": "1. Implanter de la cyber. 2. Implanter de l'IA, le client a déjà manifesté de l'intérêt.",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Cabinet encore très jeune, en est encore à mode \"installation\" plutôt qu'en mode optimisation. | 1. Implanter de la cyber. 2. Implanter de l'IA, le client a déjà manifesté de l'intérêt.",
    "comments": "NA | Départements: TI | Valeur contrats: 668.8 | Rentabilité: Faible (53 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: 1. Implanter de la cyber. 2. Implanter de l'IA, le client a déjà manifesté de l'intérêt.. Relation: Belle relation somme toute, il est plutôt indépendant. C'est purement professionnel. Philippe est très gentil et jovial. Il a deux enfants un petit garçon et une petite fille. Aime voyager en France. A son propre cabinet dentaire depuis 2025. Il est également le président actuel de la société dentaire de Québec.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 23,
    "ddcActive": false
  },
  {
    "clientName": "Pro-métal plus",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: Belle relation. Pascale est super gentille. Si elle a besoin de quelque chose, elle va me l'écrire. Elle connait bien Eric Durand. Sa personnalité est plutôt sérieuse et calme. Elle aime les destinations soleils. Elle a trois enfants, 2 filles et un plus jeune garçon. Si j'ai mis 5 c'est parce que j'aimerais encore plus lui parler.. Prime vendeur: 5. Risque de perte: 3.",
    "recommendedAngle": "1. Faire un suivi au niveau de la prog. 2. La rencontrer afin de lui proposer de l'IA. 3. Renforcer sa cyber.",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Prend beaucoup de temps à réfléchir. | 1. Faire un suivi au niveau de la prog. 2. La rencontrer afin de lui proposer de l'IA. 3. Renforcer sa cyber.",
    "comments": "Eric et moi avions soumissionné une evaluation de prog. Elle a indiqué de lui revenir en juillet comme elle n'était pas prête à ce moment là | Départements: TI | Valeur contrats: 4889.34 | Rentabilité: Rentable (344 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: 1. Faire un suivi au niveau de la prog. 2. La rencontrer afin de lui proposer de l'IA. 3. Renforcer sa cyber.. Relation: Belle relation. Pascale est super gentille. Si elle a besoin de quelque chose, elle va me l'écrire. Elle connait bien Eric Durand. Sa personnalité est plutôt sérieuse et calme. Elle aime les destinations soleils. Elle a trois enfants, 2 filles et un plus jeune garçon. Si j'ai mis 5 c'est parce que j'aimerais encore plus lui parler.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 24,
    "ddcActive": false
  },
  {
    "clientName": "Proludik",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: Bien, pas denjeu mais j'aimerais beaucoup approfondir ce lien. Donner plus d'amour. J'attends toujours pour un diner ou n'importe quelle opportunité de me lier davantages.. Prime vendeur: 6. Risque de perte: 3.",
    "recommendedAngle": "1. Diner avec le client. 2. Implanter de la cyber. 3. Rencontre pour discuter de comment l'IA pourrait les aider.",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "NA | 1. Diner avec le client. 2. Implanter de la cyber. 3. Rencontre pour discuter de comment l'IA pourrait les aider.",
    "comments": "J'ai récemment héritée de ce client. Je leur ai sortie un inventaire de leurs postes, équipements. Également une installation de Claude a été effectué. | Départements: TI | Valeur contrats: 1461.11 | Rentabilité: Rentable (531 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: 1. Diner avec le client. 2. Implanter de la cyber. 3. Rencontre pour discuter de comment l'IA pourrait les aider.. Relation: Bien, pas denjeu mais j'aimerais beaucoup approfondir ce lien. Donner plus d'amour. J'attends toujours pour un diner ou n'importe quelle opportunité de me lier davantages.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 25,
    "ddcActive": false
  },
  {
    "clientName": "Rapide Transport",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: Relation bien mais sans plus, JF est très sympathique. Définitivement une relation à approfondir.. Prime vendeur: 5. Risque de perte: 3.",
    "recommendedAngle": "1. Les rencontrer afin de discuté IA. 2. Implanter de la Cyber.",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Sont très proche de leurs sous. Autrement, pas d'enjeux. | 1. Les rencontrer afin de discuté IA. 2. Implanter de la Cyber.",
    "comments": "NA | Départements: TI | Valeur contrats: 651.99 | Rentabilité: Rentable (577 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: 1. Les rencontrer afin de discuté IA. 2. Implanter de la Cyber.. Relation: Relation bien mais sans plus, JF est très sympathique. Définitivement une relation à approfondir.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 26,
    "ddcActive": false
  },
  {
    "clientName": "Services Financiers Patrick Forgues",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: On s'est parlé qu'une seule fois et à peine.. Prime vendeur: 2. Risque de perte: 5.",
    "recommendedAngle": "1. Se pencher sur comment avoir plus de point contacte avec le client. Comment obtenir plus de feedback.",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Difficile d'avoir des retours. | 1. Se pencher sur comment avoir plus de point contacte avec le client. Comment obtenir plus de feedback.",
    "comments": "NA | Départements: TI | Valeur contrats: 299.56 | Rentabilité: Moyen (190 $/h)",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: 1. Se pencher sur comment avoir plus de point contacte avec le client. Comment obtenir plus de feedback.. Relation: On s'est parlé qu'une seule fois et à peine.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 27,
    "ddcActive": false
  },
  {
    "clientName": "SV Avocate",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: Nous nous sommes parlé qu'une seule fois lorsque je l'ai appelé afin de lui laisser savoir que je serai sa ressource durant l'absence de Jess. L'échange était légèrement froid mais très poli.. Prime vendeur: 2. Risque de perte: 5.",
    "recommendedAngle": "1. Se pencher sur comment avoir plus de point contacte avec le client. Comment obtenir plus de feedback.",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Difficile d'avoir des retours. | 1. Se pencher sur comment avoir plus de point contacte avec le client. Comment obtenir plus de feedback.",
    "comments": "NA | Départements: TI | Valeur contrats: 131.87 | Rentabilité: Rentable (381 $/h)",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: 1. Se pencher sur comment avoir plus de point contacte avec le client. Comment obtenir plus de feedback.. Relation: Nous nous sommes parlé qu'une seule fois lorsque je l'ai appelé afin de lui laisser savoir que je serai sa ressource durant l'absence de Jess. L'échange était légèrement froid mais très poli.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 28,
    "ddcActive": false
  },
  {
    "clientName": "TJL Transport",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: Belle relation avec JF et Guillaume quand c'est à lui que je parle. On n'échange pas tout à fait régulièrement mais lorsqu'il y a quelque chose il me le communique. Je m'assure de toujours répondre le plus rapidement possible. J'aimerais approfondir notre relation dans les mois suivants avec un diner, cocktail ou autre. En savoir un peu plus sur le niveau humain aussi. Peut-être un évènement partenaires pourraient nous rapprocher. Je m'établie un plan pour cela.. Prime vendeur: 7. Risque de perte: 2.",
    "recommendedAngle": "1. Rencontrer pour présenter l'IA, surtout dans leur domaine, cela serait très avantageux. 2. Instaurer un comité TI? 3. Organiser un diner avec eux et/ou les inviter à nos évènements afin qu'on se rapproche. 4. Une visite spontannée à leurs bureaux, je sais qu'ils seraient pas contre.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "A récemment expérimenté quelques problèmes au niveau de la vitesse sinon rien de majeur | 1. Rencontrer pour présenter l'IA, surtout dans leur domaine, cela serait très avantageux. 2. Instaurer un comité TI? 3. Organiser un diner avec eux et/ou les inviter à nos évènements afin qu'on se rapproche. 4. Une visite spontannée à leurs bureaux, je sais qu'ils seraient pas contre.",
    "comments": "On déjà mentionner brièvement ne pas apprécier perdre du temps et aurait de l'intérêt pour simplifier et automatiser. Il faudrait creuser davantages. | Départements: TI, Cyber | Valeur contrats: 3322.78 | Rentabilité: Rentable (316 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: 1. Rencontrer pour présenter l'IA, surtout dans leur domaine, cela serait très avantageux. 2. Instaurer un comité TI? 3. Organiser un diner avec eux et/ou les inviter à nos évènements afin qu'on se rapproche. 4. Une visite spontannée à leurs bureaux, je sais qu'ils seraient pas contre.. Relation: Belle relation avec JF et Guillaume quand c'est à lui que je parle. On n'échange pas tout à fait régulièrement mais lorsqu'il y a quelque chose il me le communique. Je m'assure de toujours répondre le plus rapidement possible. J'aimerais approfondir notre relation dans les mois suivants avec un diner, cocktail ou autre. En savoir un peu plus sur le niveau humain aussi. Peut-être un évènement partenaires pourraient nous rapprocher. Je m'établie un plan pour cela.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 29,
    "ddcActive": false
  },
  {
    "clientName": "Trajectoire 16-35",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 30,
    "ddcActive": false
  },
  {
    "clientName": "Transport DLB Ltée",
    "accountManager": "Edita Puhovac",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À réassigner",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "À qualifier",
    "expertAssessment": "Source Excel DDC. Relation: Très belle relation avec Simon, sous ses airs plutôt réservés et sérieux il est franchement blagueur. A globalement une bonne connaissance au niveau TI. Il répond rapidement malgré son manque de disponibilités. Il a deux enfants, un petit garçon et une petite fille avec qui il fait souvent du quatres-roues. Son groupe musical préféré est Mumford & Sons et il adore les voitures de sports.. Prime vendeur: 8. Risque de perte: 2.",
    "recommendedAngle": "1. Les faire passer dans notre cloud à nous (en processus) 2. Rencontrer pour présenter l'IA. 3. CYBER. 4. Diner, mais cela ira en automne car trop débordé.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "À réassigner à un DDC actif avant approche client.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Sauf leur serveur qui se fait vieux et qui est à changer, je sais que le client est en relation avec une autre firme afin de programmer un ERP. | 1. Les faire passer dans notre cloud à nous (en processus) 2. Rencontrer pour présenter l'IA. 3. CYBER. 4. Diner, mais cela ira en automne car trop débordé.",
    "comments": "En renouvellement. Simon a actuellement un serveur local qui se fait pas mal vieux, on a exploré ensemble la Solution Cloud chez BZ. Il est définitivement intéressé, avant de signer il souhaite toutefois recevoir une quote de combien lui couterait un autre serveur local, à titre de comparaison. À suivre, | Départements: TI | Valeur contrats: 922.08 | Rentabilité: Rentable (422 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Edita Puhovac). Priorités/enjeux: 1. Les faire passer dans notre cloud à nous (en processus) 2. Rencontrer pour présenter l'IA. 3. CYBER. 4. Diner, mais cela ira en automne car trop débordé.. Relation: Très belle relation avec Simon, sous ses airs plutôt réservés et sérieux il est franchement blagueur. A globalement une bonne connaissance au niveau TI. Il répond rapidement malgré son manque de disponibilités. Il a deux enfants, un petit garçon et une petite fille avec qui il fait souvent du quatres-roues. Son groupe musical préféré est Mumford & Sons et il adore les voitures de sports.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Edita Puhovac",
    "sourceRow": 31,
    "ddcActive": false
  },
  {
    "clientName": "9437-7058 Quebec inc",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: 1. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Cloud seulement. | Valeur contrats: 891.82",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 2,
    "ddcActive": true
  },
  {
    "clientName": "AHC",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Très bonne relation avec Dany.. Prime vendeur: 5. Risque de perte: 4.",
    "recommendedAngle": "SAT",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Peux de moyen, OBNL | SAT",
    "comments": "Nous sommes commanditaire de l'association hockey Charlesbourg | Départements: TI | Valeur contrats: 267.84 | Rentabilité: Moyen (159 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: SAT. Relation: Très bonne relation avec Dany.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 3,
    "ddcActive": true
  },
  {
    "clientName": "Alimentation FC",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Excellente relation avec le client, il sont hyper gentil et veulenet seulement s'adapter a la technologie. Prime vendeur: 5. Risque de perte: 2.",
    "recommendedAngle": "Achat de poste pour ses employé(plusieurs on leur propre poste perso) SAT, BOT",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Achat de poste pour ses employé(plusieurs on leur propre poste perso) SAT, BOT",
    "comments": "Départements: TI, Cyber, Télécom | Valeur contrats: 2006.93",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Moyenne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Achat de poste pour ses employé(plusieurs on leur propre poste perso) SAT, BOT. Relation: Excellente relation avec le client, il sont hyper gentil et veulenet seulement s'adapter a la technologie. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 4,
    "ddcActive": true
  },
  {
    "clientName": "Aliments Porvico Ltée",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: 1. Risque de perte: 3.",
    "recommendedAngle": "Prendre contact pour revalider leur besoins. Valider leur infrastructure actuel. Elle a un autre enprise que nous pouvons aller chercher, mais pour ca je doit réussir a lui parlé",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Prendre contact pour revalider leur besoins. Valider leur infrastructure actuel. Elle a un autre enprise que nous pouvons aller chercher, mais pour ca je doit réussir a lui parlé",
    "comments": "Je n'ai jamais réussi a leur parlé, Jennifer est l'ex a Jérome | Départements: TI, Télécom | Valeur contrats: 484.71 | Rentabilité: Rentable (886 $/h)",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Prendre contact pour revalider leur besoins. Valider leur infrastructure actuel. Elle a un autre enprise que nous pouvons aller chercher, mais pour ca je doit réussir a lui parlé. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 5,
    "ddcActive": true
  },
  {
    "clientName": "Alliance Solutions Logistiques Inc.",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Excellente relation avec les 3 décideurs. Prime vendeur: 3. Risque de perte: 3.",
    "recommendedAngle": "Optimisation des ressource Cloud, Ajout de Bot (Planifier avec DUDU) Téléphonie",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Client demande beaucoup de temps et cherche a diminuer ses couts, client pas rentable a 68,82$/h | Optimisation des ressource Cloud, Ajout de Bot (Planifier avec DUDU) Téléphonie",
    "comments": "Départements: TI | Valeur contrats: 2667.9",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Optimisation des ressource Cloud, Ajout de Bot (Planifier avec DUDU) Téléphonie. Relation: Excellente relation avec les 3 décideurs. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 6,
    "ddcActive": true
  },
  {
    "clientName": "Alliance Verte",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Belle relation, aucun enjeux. Prime vendeur: à valider. Risque de perte: 3.",
    "recommendedAngle": "Renouvellement juillet 2026, Changement du Sonicwall pour un Forti50G, SAT, BOT, client tres rentable",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Renouvellement juillet 2026, Changement du Sonicwall pour un Forti50G, SAT, BOT, client tres rentable",
    "comments": "Départements: TI, Télécom | Valeur contrats: 1125.08",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Renouvellement juillet 2026, Changement du Sonicwall pour un Forti50G, SAT, BOT, client tres rentable. Relation: Belle relation, aucun enjeux. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 7,
    "ddcActive": true
  },
  {
    "clientName": "Animalerie Dyno",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Correct mais sans plus. Prime vendeur: 1. Risque de perte: 5.",
    "recommendedAngle": "Elle est fermée à toute discussion, même lorsqu’il s’agit d’une simple invitation à des événements privés.",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Elle est fermée à toute discussion, même lorsqu’il s’agit d’une simple invitation à des événements privés.",
    "comments": "Cloud seulement, et ne veux rien savoir de plus | Valeur contrats: 226.2",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Moyenne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Elle est fermée à toute discussion, même lorsqu’il s’agit d’une simple invitation à des événements privés.. Relation: Correct mais sans plus. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 8,
    "ddcActive": true
  },
  {
    "clientName": "APDA",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: N/A. Prime vendeur: N/A. Risque de perte: N/A.",
    "recommendedAngle": "N/A",
    "riskOrCondition": "Risque déclaré: N/A. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "N/A | N/A",
    "comments": "Téléphonie seulement, en discution | Départements: N/A | Valeur contrats: N/A | Rentabilité: N/A",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: N/A. Relation: N/A. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 9,
    "ddcActive": true
  },
  {
    "clientName": "Atelier Martin Pêcheur",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, aucun enjeux. Prime vendeur: 1. Risque de perte: 5.",
    "recommendedAngle": "Planifier une rencontre avec un Tech pour évaluer l'optimisable. Actuellement il sont tres frileux avec la tachnologie.",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Il nous contacter en urgence puisqu'il n'avais plus accès a leur courriel, il s'agissais seulement d'une problèmatique avec leur synchronisation | Planifier une rencontre avec un Tech pour évaluer l'optimisable. Actuellement il sont tres frileux avec la tachnologie.",
    "comments": "Personne d'une certaine age avec tres peu de connaissance avec la Technologie, utilise Copilot | Départements: TI | Valeur contrats: 418.91 | Rentabilité: Rentable (1405 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Planifier une rencontre avec un Tech pour évaluer l'optimisable. Actuellement il sont tres frileux avec la tachnologie.. Relation: Bonne, aucun enjeux. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 10,
    "ddcActive": true
  },
  {
    "clientName": "Cabinet MCB s.e.n.c",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, aucun enjeux. Prime vendeur: 1. Risque de perte: 3.",
    "recommendedAngle": "SAT, l'ajout de l'IA",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Entreprise en démarrage, veulent investire peu a peu | SAT, l'ajout de l'IA",
    "comments": "Bon client. Lors de leur démarrage il y a un an, ils ont choisi BZ pour l’ensemble de leurs besoins technologiques : postes de travail, infrastructure, logiciels, télécommunications et services gérés. Ils entretiennent une excellente relation avec nous et font confiance à notre expertise pour accompagner leur croissance. | Départements: TI, Télécom | Valeur contrats: 518.92 | Rentabilité: Rentable (758 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: SAT, l'ajout de l'IA. Relation: Bonne, aucun enjeux. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 11,
    "ddcActive": true
  },
  {
    "clientName": "Capitaine dabord",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, aucun enjeux. Prime vendeur: 2. Risque de perte: 4.",
    "recommendedAngle": "BOT pour l'optiminisation de leur logitel comptable, inventaire, boutique, et autres. Ajout de procédure cyber",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Boutique qui vois la technologie comme une dépense | BOT pour l'optiminisation de leur logitel comptable, inventaire, boutique, et autres. Ajout de procédure cyber",
    "comments": "Départements: TI | Valeur contrats: 688.48 | Rentabilité: Rentable (363 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: BOT pour l'optiminisation de leur logitel comptable, inventaire, boutique, et autres. Ajout de procédure cyber. Relation: Bonne, aucun enjeux. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 12,
    "ddcActive": true
  },
  {
    "clientName": "Centre Bonne Entente",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Correct, mais cliente TRES difficle. Prime vendeur: à valider. Risque de perte: 7.",
    "recommendedAngle": "Peux de technicien veulent les servires, OBNL qui n'ont pas les moyens de payer",
    "riskOrCondition": "Risque déclaré: 7. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Peux de technicien veulent les servires, OBNL qui n'ont pas les moyens de payer",
    "comments": "OBNL. Cliente très insatisfaite du soutien qu’elle reçoit. J’ai dû intervenir à quelques reprises puisqu’elle manquait de respect envers les techniciens. | Départements: TI | Valeur contrats: 557.87 | Rentabilité: Rentable (221 $/h)",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Moyenne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Peux de technicien veulent les servires, OBNL qui n'ont pas les moyens de payer. Relation: Correct, mais cliente TRES difficle. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 13,
    "ddcActive": true
  },
  {
    "clientName": "Christine Gagnon notaire inc.",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Tres belle relation. Prime vendeur: 3. Risque de perte: 2.",
    "recommendedAngle": "Ajout de l'IA pour leur quotidien",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Notaire avec des reglemes spécifique concernant la loi 25 | Ajout de l'IA pour leur quotidien",
    "comments": "Seulement deux notaires, mais souhaitent disposer en tout temps d’un troisième poste de travail pour les stagiaires, les adjointes ou toute autre ressource temporaire. | Départements: TI | Valeur contrats: 595.3 | Rentabilité: Rentable (397 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Ajout de l'IA pour leur quotidien. Relation: Tres belle relation. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 14,
    "ddcActive": true
  },
  {
    "clientName": "Conception RP",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, aucun enjeux. Prime vendeur: à valider. Risque de perte: 2.",
    "recommendedAngle": "Comité TI à venir afin de réévaluer leurs besoins. Plusieurs changements pourraient être apportés à la suite du comité TI déjà planifié. Le renouvellement est prévu en octobre 2026.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Tres difficile a rejoindre | Comité TI à venir afin de réévaluer leurs besoins. Plusieurs changements pourraient être apportés à la suite du comité TI déjà planifié. Le renouvellement est prévu en octobre 2026.",
    "comments": "Je suis actuellement sur le dossier avec FM | Départements: TI | Valeur contrats: 3809.99 | Rentabilité: Moyen (184 $/h)",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Comité TI à venir afin de réévaluer leurs besoins. Plusieurs changements pourraient être apportés à la suite du comité TI déjà planifié. Le renouvellement est prévu en octobre 2026.. Relation: Bonne, aucun enjeux. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 15,
    "ddcActive": true
  },
  {
    "clientName": "CONSTRUCTION POLARIS CMM INC",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Aucun enjeux. Prime vendeur: 1. Risque de perte: 2.",
    "recommendedAngle": "Parlé de l'IA",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Parlé de l'IA",
    "comments": "Seulement des service de sauvegarde | Valeur contrats: 1413.08",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Parlé de l'IA. Relation: Aucun enjeux. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 16,
    "ddcActive": true
  },
  {
    "clientName": "Constructions Envergure inc.",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Tres belle relation. Prime vendeur: 3. Risque de perte: 2.",
    "recommendedAngle": "Nous sommes entrain de migrer son logitiel comptable dans notre cloud",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Peu enclin à adopter les nouvelles technologies. Il nous a fallu près d’un an pour le convaincre que l’infonuagique (Cloud) représentait une meilleure option pour ses besoins que l’hébergement local de son logiciel comptable. | Nous sommes entrain de migrer son logitiel comptable dans notre cloud",
    "comments": "Départements: TI | Valeur contrats: 1134.88 | Rentabilité: Rentable (326 $/h)",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Nous sommes entrain de migrer son logitiel comptable dans notre cloud. Relation: Tres belle relation. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 17,
    "ddcActive": true
  },
  {
    "clientName": "CPE Les Copains",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Tres belle relation, client tres receptif a nos conseils. Prime vendeur: 5. Risque de perte: 2.",
    "recommendedAngle": "SAT",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "En tant qu'OBNL, l'organisation doit gérer ses ressources financières avec prudence. Hormis les contraintes budgétaires, peu d'enjeux significatifs ont été identifiés. | SAT",
    "comments": "Départements: TI | Valeur contrats: 1162.41 | Rentabilité: Rentable (446 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: SAT. Relation: Tres belle relation, client tres receptif a nos conseils. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 18,
    "ddcActive": true
  },
  {
    "clientName": "Diesel Expert Québec inc.",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: TRES TRES belle relation. Prime vendeur: 5. Risque de perte: 1.",
    "recommendedAngle": "Audit de sécurité, plusieurs potentiel breche a l'extérieur du pays.",
    "riskOrCondition": "Risque déclaré: 1. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Perte actuelle de plusieurs millions de dollars à la suite de la fermeture de Cuba. L'entreprise souhaite renforcer sa sécurité, mais ne possède actuellement pas les moyens financiers pour mettre en œuvre les améliorations requises. | Audit de sécurité, plusieurs potentiel breche a l'extérieur du pays.",
    "comments": "Départements: TI, Cyber | Valeur contrats: 5320.19 | Rentabilité: Rentable (607 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Audit de sécurité, plusieurs potentiel breche a l'extérieur du pays.. Relation: TRES TRES belle relation. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 19,
    "ddcActive": true
  },
  {
    "clientName": "ENEC",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bien, peu de discution. Prime vendeur: 3. Risque de perte: 2.",
    "recommendedAngle": "Rencontre à prévoir avec lui afin d’identifier les possibilités d’optimisation et les améliorations qui pourraient être apportées à son environnement technologique.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Un seul user, très difficile a rejoindre | Rencontre à prévoir avec lui afin d’identifier les possibilités d’optimisation et les améliorations qui pourraient être apportées à son environnement technologique.",
    "comments": "Electricient de BZ | Départements: TI, Télécom | Valeur contrats: 263.87 | Rentabilité: Rentable (410 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Rencontre à prévoir avec lui afin d’identifier les possibilités d’optimisation et les améliorations qui pourraient être apportées à son environnement technologique.. Relation: Bien, peu de discution. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 20,
    "ddcActive": true
  },
  {
    "clientName": "Équilibre",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Tres belle relation. Prime vendeur: 4. Risque de perte: 2.",
    "recommendedAngle": "SAT, l'ajout de l'IA",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "OBNL | SAT, l'ajout de l'IA",
    "comments": "Très réceptif à nos conseils et recommandations. A participé à plusieurs initiatives visant l’amélioration de sa posture technologique et de sa cybersécurité, notamment avec IN-SEC-M ainsi que diverses formations. | Départements: TI | Valeur contrats: 817.59 | Rentabilité: Rentable (309 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: SAT, l'ajout de l'IA. Relation: Tres belle relation. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 21,
    "ddcActive": true
  },
  {
    "clientName": "Équipements de Levage Girard inc.",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Belle relation, aucun enjeux. Prime vendeur: 2. Risque de perte: 7.",
    "recommendedAngle": "Stabilisé leur entente , Ajout de L'IA et SAT",
    "riskOrCondition": "Risque déclaré: 7. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Trouve que leur cout son trop cher, Plusieurs pépin avec le service. Gros enjeux au niveau des droit d'accès on été donner a tous. Quelques enjeux également avec la téléphonie | Stabilisé leur entente , Ajout de L'IA et SAT",
    "comments": "En discution présentement | Départements: TI, Cyber | Valeur contrats: 4909.41 | Rentabilité: Rentable (341 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Stabilisé leur entente , Ajout de L'IA et SAT. Relation: Belle relation, aucun enjeux. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 22,
    "ddcActive": true
  },
  {
    "clientName": "Excusions Jacques Cartier",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: N/A. Prime vendeur: N/A. Risque de perte: N/A.",
    "recommendedAngle": "N/A",
    "riskOrCondition": "Risque déclaré: N/A. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "N/A | N/A",
    "comments": "Toujours en attente du reférencement de l'effet monstre | Départements: N/A | Valeur contrats: N/A",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: N/A. Relation: N/A. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 23,
    "ddcActive": true
  },
  {
    "clientName": "Extal",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, aucun enjeux. Prime vendeur: 2. Risque de perte: 3.",
    "recommendedAngle": "Renouvellement juillet 2026, Changement du Sonicwall pour un Forti50G, SAT, BOT",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Extrèmement dur a rejoindre | Renouvellement juillet 2026, Changement du Sonicwall pour un Forti50G, SAT, BOT",
    "comments": "Départements: TI | Valeur contrats: 2662.8 | Rentabilité: Rentable (906 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Renouvellement juillet 2026, Changement du Sonicwall pour un Forti50G, SAT, BOT. Relation: Bonne, aucun enjeux. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 24,
    "ddcActive": true
  },
  {
    "clientName": "Fernandez relations publiques",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, aucun enjeux. Prime vendeur: 1. Risque de perte: 10.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 10. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Il sont en fermeture, il nous reste seulement les licences et sauvegarde, aucun service TI depuis le 1er juillet 2025 | Départements: TI | Valeur contrats: 116.6 | Rentabilité: Rentable (1268 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Élevé",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: à préciser. Relation: Bonne, aucun enjeux. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 25,
    "ddcActive": true
  },
  {
    "clientName": "Garderie Le Monde des Petits Pieds",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, aucun enjeux. Prime vendeur: 1. Risque de perte: 5.",
    "recommendedAngle": "Revoir la rentabilité du client et les opportunités d’optimisation du compte.",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Très peu de moyen financier | Revoir la rentabilité du client et les opportunités d’optimisation du compte.",
    "comments": "Ancienne garderie d'Émilie, prix très bas | Départements: TI, Télécom | Valeur contrats: 243.96 | Rentabilité: Rentable (1083 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Revoir la rentabilité du client et les opportunités d’optimisation du compte.. Relation: Bonne, aucun enjeux. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 26,
    "ddcActive": true
  },
  {
    "clientName": "Gestil inc.",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, aucun enjeux. Prime vendeur: 2. Risque de perte: 3.",
    "recommendedAngle": "Renouvellement juillet 2026. SAT, BOT",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Très difficile a rejoindre, n'a jamais le temps de discuter | Renouvellement juillet 2026. SAT, BOT",
    "comments": "Plomberie Jonathan Actil | Départements: TI | Valeur contrats: 276.8 | Rentabilité: Rentable (501 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Renouvellement juillet 2026. SAT, BOT. Relation: Bonne, aucun enjeux. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 27,
    "ddcActive": true
  },
  {
    "clientName": "Gestion 2505 inc.",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, aucun enjeux. Prime vendeur: 1. Risque de perte: 4.",
    "recommendedAngle": "Mise à jour des serveurs Windows. Retrait de Maestro, qui génère des problèmes sur les serveurs et n’est plus utilisé. Ajout de SAT et BOT",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Ont une équipe complete avec le Massif | Mise à jour des serveurs Windows. Retrait de Maestro, qui génère des problèmes sur les serveurs et n’est plus utilisé. Ajout de SAT et BOT",
    "comments": "Présentement en stratégie global | Départements: TI | Valeur contrats: 1864.66 | Rentabilité: Rentable (2197 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Mise à jour des serveurs Windows. Retrait de Maestro, qui génère des problèmes sur les serveurs et n’est plus utilisé. Ajout de SAT et BOT. Relation: Bonne, aucun enjeux. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 28,
    "ddcActive": true
  },
  {
    "clientName": "Grader's Pro",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, aucun enjeux. Prime vendeur: 2. Risque de perte: 4.",
    "recommendedAngle": "Membre du CA seulement. Les besoins en cybersécurité et en IA sont déjà couverts par les entreprises respectives des membres du conseil.",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Membre du CA seulement. Les besoins en cybersécurité et en IA sont déjà couverts par les entreprises respectives des membres du conseil.",
    "comments": "Il s'agit d'une entreprise composer seulement de CA. Aucun employer actif | Départements: TI | Valeur contrats: 836.49 | Rentabilité: Moyen (171 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Moyenne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Membre du CA seulement. Les besoins en cybersécurité et en IA sont déjà couverts par les entreprises respectives des membres du conseil.. Relation: Bonne, aucun enjeux. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 29,
    "ddcActive": true
  },
  {
    "clientName": "Groupe MACH",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, aucun enjeux. Prime vendeur: 3. Risque de perte: 2.",
    "recommendedAngle": "Audit de sécurité, Ajout le service géré pour leur parc immomarketing a qc. Tourner des installation réseaux",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Gestionnaire immobilier avec plusieurs installations. Bureau principal situé à Montréal, qui assure actuellement la gestion des licences, des logiciels et des enjeux informatiques pour l’ensemble de l’organisation. | Audit de sécurité, Ajout le service géré pour leur parc immomarketing a qc. Tourner des installation réseaux",
    "comments": "Accès service avec sauvegarde . Plusieurs établissement a gérer séparément , Nouveau DG | Départements: TI",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Audit de sécurité, Ajout le service géré pour leur parc immomarketing a qc. Tourner des installation réseaux. Relation: Bonne, aucun enjeux. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 30,
    "ddcActive": true
  },
  {
    "clientName": "H&R Block Canada inc.",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Peux parlé. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Prévoir une rencontre avec un technicien afin de bien comprendre leur environnement technologique actuel et d’identifier les opportunités d’optimisation, tant au niveau des processus que de l’infrastructure.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Prévoir une rencontre avec un technicien afin de bien comprendre leur environnement technologique actuel et d’identifier les opportunités d’optimisation, tant au niveau des processus que de l’infrastructure.",
    "comments": "Cloud seulement | Départements: TI | Valeur contrats: 685.1 | Rentabilité: Rentable (826 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Prévoir une rencontre avec un technicien afin de bien comprendre leur environnement technologique actuel et d’identifier les opportunités d’optimisation, tant au niveau des processus que de l’infrastructure.. Relation: Peux parlé. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 31,
    "ddcActive": true
  },
  {
    "clientName": "Habitation Construction Matane (1986) inc.",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Jamais parlé au client. Prime vendeur: 1. Risque de perte: 5.",
    "recommendedAngle": "N/A",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Entente avec Informidata | N/A",
    "comments": "Client d'informidata, les ajouts de service doivent passer par Jean-Francois | Départements: Cloud | Valeur contrats: 778.98",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: N/A. Relation: Jamais parlé au client. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 32,
    "ddcActive": true
  },
  {
    "clientName": "Héritage S.E.C.",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, aucun enjeux. Prime vendeur: 3. Risque de perte: à valider.",
    "recommendedAngle": "Structure SharePoint et renouvellement des postes déjà entamés. En attente d’un retour du client pour finaliser le tout. Recommandation d’ajouter des solutions d’IA ainsi que SAT.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Très difficile à joindre depuis quelques mois. Ne répond pas à nos appels ni à nos courriels, ce qui limite les possibilités de suivi. | Structure SharePoint et renouvellement des postes déjà entamés. En attente d’un retour du client pour finaliser le tout. Recommandation d’ajouter des solutions d’IA ainsi que SAT.",
    "comments": "Départements: TI | Valeur contrats: 2912.12 | Rentabilité: Rentable (284 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Structure SharePoint et renouvellement des postes déjà entamés. En attente d’un retour du client pour finaliser le tout. Recommandation d’ajouter des solutions d’IA ainsi que SAT.. Relation: Bonne, aucun enjeux. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 33,
    "ddcActive": true
  },
  {
    "clientName": "Hôtel Cap-aux-Pierres",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, aucun enjeux. Prime vendeur: 3. Risque de perte: à valider.",
    "recommendedAngle": "Présenter le plan directeur à la nouvelle DG. remplacement des switches, ajout de SAT et BOT, et réalisation d’un audit TI.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Seulement ouvert l'été | Présenter le plan directeur à la nouvelle DG. remplacement des switches, ajout de SAT et BOT, et réalisation d’un audit TI.",
    "comments": "Changement de direction | Départements: TI | Valeur contrats: 1911.5 | Rentabilité: Rentable (558 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Présenter le plan directeur à la nouvelle DG. remplacement des switches, ajout de SAT et BOT, et réalisation d’un audit TI.. Relation: Bonne, aucun enjeux. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 34,
    "ddcActive": true
  },
  {
    "clientName": "Immeubles Place Hochelaga",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Meme client que Atelier Martin Pêcheur | Départements: TI | Valeur contrats: 295.22 | Rentabilité: Rentable (3202 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 35,
    "ddcActive": true
  },
  {
    "clientName": "Immomarketing Inc.",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: N/A. Prime vendeur: N/A. Risque de perte: N/A.",
    "recommendedAngle": "N/A",
    "riskOrCondition": "Risque déclaré: N/A. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "N/A | N/A",
    "comments": "Groupe MACH | Départements: TI | Valeur contrats: 618.58 | Rentabilité: Rentable (aucune heure consommée)",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: N/A. Relation: N/A. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 36,
    "ddcActive": true
  },
  {
    "clientName": "Informidata",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Tres bonne. Prime vendeur: N/A. Risque de perte: N/A.",
    "recommendedAngle": "Clarifier les services à revendre, Mettre en place des outils simple pour l'aider a revendre nos services",
    "riskOrCondition": "Risque déclaré: N/A. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Clarifier les services à revendre, Mettre en place des outils simple pour l'aider a revendre nos services",
    "comments": "Revendeur de services BZ | Départements: N/A | Valeur contrats: 126.86",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Clarifier les services à revendre, Mettre en place des outils simple pour l'aider a revendre nos services. Relation: Tres bonne. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 37,
    "ddcActive": true
  },
  {
    "clientName": "Institut de gouvernance numérique",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Client a quitter en avril 2026 | Départements: TI | Valeur contrats: 209.17 | Rentabilité: Rentable (639 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 38,
    "ddcActive": true
  },
  {
    "clientName": "L2 Marketing inc.",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, aucun enjeux. Prime vendeur: 1. Risque de perte: 6.",
    "recommendedAngle": "Ne veulent pas payer pour rien.",
    "riskOrCondition": "Risque déclaré: 6. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Ne veulent pas payer pour rien.",
    "comments": "N'est plus client Prog | Départements: TI, Programmation | Valeur contrats: 319.37 | Rentabilité: Rentable (259 $/h)",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Moyenne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Ne veulent pas payer pour rien.. Relation: Bonne, aucun enjeux. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 39,
    "ddcActive": true
  },
  {
    "clientName": "La Popote Roulante Ste-Foy inc.",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, aucun enjeux. Prime vendeur: 3. Risque de perte: à valider.",
    "recommendedAngle": "OBNL. Toutes les décisions doivent passer par le CA, ce qui entraîne des délais plus importants dans les prises de décision et l’avancement des projets.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "OBNL. Toutes les décisions doivent passer par le CA, ce qui entraîne des délais plus importants dans les prises de décision et l’avancement des projets.",
    "comments": "Départements: TI | Valeur contrats: 160.86 | Rentabilité: Moyen (193 $/h)",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Moyenne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: OBNL. Toutes les décisions doivent passer par le CA, ce qui entraîne des délais plus importants dans les prises de décision et l’avancement des projets.. Relation: Bonne, aucun enjeux. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 40,
    "ddcActive": true
  },
  {
    "clientName": "Les restaurants McDonald's de Sept-Iles et Port-Cartier",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Belle relation, EH le connais bien. Prime vendeur: 2. Risque de perte: à valider.",
    "recommendedAngle": "Ne prend aucune décision concernant son environnement technologique. L’ensemble des choix, des licences et de la gestion informatique est centralisé et administré par McDonald’s.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Ne prend aucune décision concernant son environnement technologique. L’ensemble des choix, des licences et de la gestion informatique est centralisé et administré par McDonald’s.",
    "comments": "Infrastructure 100 % infonuagique. Dossier complexe en raison de la gestion centralisée par McDonald's. EH connaît bien ce client. Plusieurs avenues ont été analysées, mais les contraintes de leur environnement ne permettent pas d'apporter les changements souhaités. | Valeur contrats: 305.96",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Moyenne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Ne prend aucune décision concernant son environnement technologique. L’ensemble des choix, des licences et de la gestion informatique est centralisé et administré par McDonald’s.. Relation: Belle relation, EH le connais bien. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 41,
    "ddcActive": true
  },
  {
    "clientName": "Louise Jacques Avocats inc.",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Correct. Prime vendeur: 3. Risque de perte: 5.",
    "recommendedAngle": "Très axé sur la réduction des coûts. Considère les dépenses technologiques comme des coûts obligatoires plutôt que comme des investissements à valeur ajoutée.",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Très axé sur la réduction des coûts. Considère les dépenses technologiques comme des coûts obligatoires plutôt que comme des investissements à valeur ajoutée.",
    "comments": "Communications parfois difficiles et approche exigeante. Certains échanges avec l’équipe technique ont été perçus comme un manque de respect. | Départements: TI | Valeur contrats: 153.05 | Rentabilité: Rentable (408 $/h)",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Moyenne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Très axé sur la réduction des coûts. Considère les dépenses technologiques comme des coûts obligatoires plutôt que comme des investissements à valeur ajoutée.. Relation: Correct. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 42,
    "ddcActive": true
  },
  {
    "clientName": "Luc Fortin ( 9004-5519 Québec inc. )",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Location de portable seulement | Départements: TI | Valeur contrats: 166.4 | Rentabilité: Moyen (200 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 43,
    "ddcActive": true
  },
  {
    "clientName": "Maison diocésaine de formation",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, aucun enjeux. Prime vendeur: 3. Risque de perte: 2.",
    "recommendedAngle": "SAT, l'ajout de l'IA",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "OBNL | SAT, l'ajout de l'IA",
    "comments": "Départements: TI | Valeur contrats: 783.33 | Rentabilité: Rentable (1092 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: SAT, l'ajout de l'IA. Relation: Bonne, aucun enjeux. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 44,
    "ddcActive": true
  },
  {
    "clientName": "Manoir du Verger",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, aucun enjeux. Prime vendeur: 3. Risque de perte: 2.",
    "recommendedAngle": "Plan directeur, SAT et IA",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Plan directeur, SAT et IA",
    "comments": "Départements: TI | Valeur contrats: 1138.5 | Rentabilité: Rentable (227 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Plan directeur, SAT et IA. Relation: Bonne, aucun enjeux. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 45,
    "ddcActive": true
  },
  {
    "clientName": "Marché Jean-Talon",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: N/A. Prime vendeur: N/A. Risque de perte: N/A.",
    "recommendedAngle": "N/A",
    "riskOrCondition": "Risque déclaré: N/A. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "N/A | N/A",
    "comments": "Aucun DDC associé - Aucun contrat Ti seul un forti | Départements: N/A | Valeur contrats: 25",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: N/A. Relation: N/A. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 46,
    "ddcActive": true
  },
  {
    "clientName": "Marlène Jobin CPA inc.",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, aucun enjeux. Prime vendeur: 2. Risque de perte: 2.",
    "recommendedAngle": "Ne sait pas combien de temps il lui reste et ne veux pas vraiment de technologie supplémentaire",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Ne sait pas combien de temps il lui reste et ne veux pas vraiment de technologie supplémentaire",
    "comments": "1 seul user, nous utilise seulement pour ses petits pépin | Départements: TI | Valeur contrats: 249.01 | Rentabilité: Rentable (531 $/h)",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Moyenne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Ne sait pas combien de temps il lui reste et ne veux pas vraiment de technologie supplémentaire. Relation: Bonne, aucun enjeux. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 47,
    "ddcActive": true
  },
  {
    "clientName": "Martel Automation inc.",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, aucun enjeux. Prime vendeur: 2. Risque de perte: 3.",
    "recommendedAngle": "Plan directeur, SAT et IA, Audit de sécurité",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Tres difficile a rejoindre | Plan directeur, SAT et IA, Audit de sécurité",
    "comments": "Départements: TI | Valeur contrats: 1846.37 | Rentabilité: Rentable (316 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Plan directeur, SAT et IA, Audit de sécurité. Relation: Bonne, aucun enjeux. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 48,
    "ddcActive": true
  },
  {
    "clientName": "Métafab 1996",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, aucun enjeux. Prime vendeur: 2. Risque de perte: 2.",
    "recommendedAngle": "Dîner planifié avec le client. Remplacement du routeur, nouvelle salle des serveurs et ajout du câblage. La salle actuelle est difficilement accessible. Présentation de SAT, des solutions d’IA et d’un audit de sécurité.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Dîner planifié avec le client. Remplacement du routeur, nouvelle salle des serveurs et ajout du câblage. La salle actuelle est difficilement accessible. Présentation de SAT, des solutions d’IA et d’un audit de sécurité.",
    "comments": "Départements: TI | Valeur contrats: 1816.28 | Rentabilité: Rentable (347 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Dîner planifié avec le client. Remplacement du routeur, nouvelle salle des serveurs et ajout du câblage. La salle actuelle est difficilement accessible. Présentation de SAT, des solutions d’IA et d’un audit de sécurité.. Relation: Bonne, aucun enjeux. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 49,
    "ddcActive": true
  },
  {
    "clientName": "MF Alain CPA",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, aucun enjeux. Je ne lui est pas parlé souvent. Prime vendeur: 1. Risque de perte: 3.",
    "recommendedAngle": "L'ajout de l'IA",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "L'ajout de l'IA",
    "comments": "1 seul user = Cloud | Départements: TI | Valeur contrats: 279.95 | Rentabilité: Rentable (275 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: L'ajout de l'IA. Relation: Bonne, aucun enjeux. Je ne lui est pas parlé souvent. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 50,
    "ddcActive": true
  },
  {
    "clientName": "Novaco Construction",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, aucun enjeux. Prime vendeur: 2. Risque de perte: 2.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "1 seul user, seul dans sa maison + Cloud | Départements: TI | Valeur contrats: 333.59 | Rentabilité: Rentable (294 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: à préciser. Relation: Bonne, aucun enjeux. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 51,
    "ddcActive": true
  },
  {
    "clientName": "Numérix",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: N/A. Prime vendeur: N/A. Risque de perte: N/A.",
    "recommendedAngle": "N/A",
    "riskOrCondition": "Risque déclaré: N/A. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "N/A | N/A",
    "comments": "Entente en négociation actuellement",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: N/A. Relation: N/A. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 52,
    "ddcActive": true
  },
  {
    "clientName": "Patrick Barbeau",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Belle relation. Prime vendeur: 2. Risque de perte: 1.",
    "recommendedAngle": "L'ajout de l'IA",
    "riskOrCondition": "Risque déclaré: 1. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "L'ajout de l'IA",
    "comments": "Ami de DB, tarif amical | Départements: TI | Valeur contrats: 72.44 | Rentabilité: Faible (84 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: L'ajout de l'IA. Relation: Belle relation. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 53,
    "ddcActive": true
  },
  {
    "clientName": "Rénovation MDR",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Très belle relation. Prime vendeur: 3. Risque de perte: 2.",
    "recommendedAngle": "Migré vers Premium",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Contraintes budgétaires importantes. Indique ne pas avoir les moyens financiers d’aller plus loin et demeure sur des licences standard pour le moment. | Migré vers Premium",
    "comments": "Client tres gentil et peu demandant | Départements: TI | Valeur contrats: 219.97 | Rentabilité: Rentable (247 $/h)",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Migré vers Premium. Relation: Très belle relation. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 54,
    "ddcActive": true
  },
  {
    "clientName": "Sébastien Lapointe, CPA inc.",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Très belle relation. Prime vendeur: 5. Risque de perte: 1.",
    "recommendedAngle": "Dejas tres intéresser par un BOT, Audit de sécurité",
    "riskOrCondition": "Risque déclaré: 1. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Est en reflexion sur la vente de son entreprise | Dejas tres intéresser par un BOT, Audit de sécurité",
    "comments": "Extrêmement réceptif à nos recommandations et très ouvert à l’amélioration continue de son environnement technologique. | Départements: TI, Cyber | Valeur contrats: 2100.68 | Rentabilité: Rentable (271 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Dejas tres intéresser par un BOT, Audit de sécurité. Relation: Très belle relation. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 55,
    "ddcActive": true
  },
  {
    "clientName": "Services Santé International SSI inc.",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Tres belle relation. Prime vendeur: 5. Risque de perte: 9.",
    "recommendedAngle": "Tres peu de moyen financier",
    "riskOrCondition": "Risque déclaré: 9. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Tres peu de moyen financier",
    "comments": "Client tres difficile avec les paiements, ne veux pas abandonner mais a le minimum des services | Valeur contrats: 80.76",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Moyenne",
    "ddcRiskLevel": "Élevé",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Tres peu de moyen financier. Relation: Tres belle relation. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 56,
    "ddcActive": true
  },
  {
    "clientName": "Sigma Devtech",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Je n'ai eu la chance de leur parlé encore, dossier ma été transferer peu avant mon congé | Départements: TI | Valeur contrats: 945.75 | Rentabilité: Rentable (457 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 57,
    "ddcActive": true
  },
  {
    "clientName": "Société Immobilière Rock Dupont inc.",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Discussion sur l’IA et les opportunités d’intégration au sein de l’organisation.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Discussion sur l’IA et les opportunités d’intégration au sein de l’organisation.",
    "comments": "Cloud seulement | Valeur contrats: 214.37",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Discussion sur l’IA et les opportunités d’intégration au sein de l’organisation.. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 58,
    "ddcActive": true
  },
  {
    "clientName": "Solution Infomedia",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Correct mais sans plus. Prime vendeur: 1. Risque de perte: à valider.",
    "recommendedAngle": "Le convaincre de ventre nos autres services",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Très difficile à rejoindre. J’ai tenté à plusieurs reprises de le sensibiliser à nos autres services, notamment en cybersécurité, mais il préfère généralement se tourner vers d’autres fournisseurs pour répondre à ces besoins. | Le convaincre de ventre nos autres services",
    "comments": "Partenaire de service cloud seulemet | Valeur contrats: 7653.92",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Le convaincre de ventre nos autres services. Relation: Correct mais sans plus. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 59,
    "ddcActive": true
  },
  {
    "clientName": "Solutions Services CPA",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: N/A. Prime vendeur: N/A. Risque de perte: N/A.",
    "recommendedAngle": "N/A",
    "riskOrCondition": "Risque déclaré: N/A. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "N/A | N/A",
    "comments": "Entente en négociation actuellement",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: N/A. Relation: N/A. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 60,
    "ddcActive": true
  },
  {
    "clientName": "Ventilation C.F Inc",
    "accountManager": "Jessica Pratt",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Belle relation, nouveau client. Prime vendeur: 4. Risque de perte: 1.",
    "recommendedAngle": "Finaliser la migration et valider la satisfaction du client. À l’automne, amorcer des discussions sur la cybersécurité et l’intelligence artificielle.",
    "riskOrCondition": "Risque déclaré: 1. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Finaliser la migration et valider la satisfaction du client. À l’automne, amorcer des discussions sur la cybersécurité et l’intelligence artificielle.",
    "comments": "Nouveau client, en migration actuellement | Départements: TI | Valeur contrats: 3900.99 | Rentabilité: Moyen (176 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Jessica Pratt). Priorités/enjeux: Finaliser la migration et valider la satisfaction du client. À l’automne, amorcer des discussions sur la cybersécurité et l’intelligence artificielle.. Relation: Belle relation, nouveau client. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Jessica Pratt",
    "sourceRow": 61,
    "ddcActive": true
  },
  {
    "clientName": "3DRPD inc.",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Très bonne mais depuis le départ d'Éric Fortin EH est plus proche que moi avec Éric Caron.. Prime vendeur: 9. Risque de perte: 1.",
    "recommendedAngle": "Plus de proactivité. Établir des rencontre périodique.",
    "riskOrCondition": "Risque déclaré: 1. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Ils veulent prévenir les pannes et que nous gerions la direction TI. | Plus de proactivité. Établir des rencontre périodique.",
    "comments": "Renouvellement en cours avec ajout Cyber | Départements: TI, Programmation | Valeur contrats: 9910.63 | Rentabilité: Rentable (737 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Plus de proactivité. Établir des rencontre périodique.. Relation: Très bonne mais depuis le départ d'Éric Fortin EH est plus proche que moi avec Éric Caron.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 2,
    "ddcActive": true
  },
  {
    "clientName": "Abrasifs JJS inc.",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Je me suis raprocher d'Isabelle qui gère les budget mais le contact Hugues gère un projet à la fois et ne répond pas vite.. Prime vendeur: 7. Risque de perte: 2.",
    "recommendedAngle": "Mettre le SAT en place et continuer en cyber à la fin de l'entente pour la loi 25",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Dois relancer souvent | Mettre le SAT en place et continuer en cyber à la fin de l'entente pour la loi 25",
    "comments": "Plan direteur déposé il y a quelques semaines | Départements: TI, Cyber | Valeur contrats: 10541.33 | Rentabilité: Rentable (519 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Mettre le SAT en place et continuer en cyber à la fin de l'entente pour la loi 25. Relation: Je me suis raprocher d'Isabelle qui gère les budget mais le contact Hugues gère un projet à la fois et ne répond pas vite.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 3,
    "ddcActive": true
  },
  {
    "clientName": "Aigles de Trois-Rivières",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Pas encore rencontré. Prime vendeur: NA. Risque de perte: NA.",
    "recommendedAngle": "Les signer à l'automne",
    "riskOrCondition": "Risque déclaré: NA. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "NA | Les signer à l'automne",
    "comments": "Prospect lié aux Capitales | Départements: NA | Valeur contrats: NA",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Les signer à l'automne. Relation: Pas encore rencontré. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 4,
    "ddcActive": true
  },
  {
    "clientName": "Airmedic",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Lié à Dessercom | Valeur contrats: 244",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 5,
    "ddcActive": true
  },
  {
    "clientName": "Ambioner",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Très bonne et avec l'implantation des comités TI suite à l'embauche de Gabriel, les projets avances biens.. Prime vendeur: 9. Risque de perte: 1.",
    "recommendedAngle": "définir la suite en cyber/SA à l'automne.",
    "riskOrCondition": "Risque déclaré: 1. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "définir la suite en cyber/SA à l'automne.",
    "comments": "Départements: TI, Cyber, Programmation | Valeur contrats: 12071.12 | Rentabilité: Rentable (939 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Moyenne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: définir la suite en cyber/SA à l'automne.. Relation: Très bonne et avec l'implantation des comités TI suite à l'embauche de Gabriel, les projets avances biens.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 6,
    "ddcActive": true
  },
  {
    "clientName": "Arbois",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: NA. Prime vendeur: NA. Risque de perte: NA.",
    "recommendedAngle": "NA",
    "riskOrCondition": "Risque déclaré: NA. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "NA | NA",
    "comments": "Prospect rencontrer lors d'un déjeuner résautage mais jamais eu de nouvelle. | Départements: NA | Valeur contrats: NA",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: NA. Relation: NA. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 7,
    "ddcActive": true
  },
  {
    "clientName": "Atlantis Pompe",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne relation malgré la situation qui perdure avec les principaux gestionnaires.. Prime vendeur: 6. Risque de perte: 5.",
    "recommendedAngle": "Régler pour de bon les problème avec SAP dans le cloud BZ. Renouveller le contrat cyber en février mais ce sera difficile de garder la mensualité qui est très élevé.",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Lenteur cloud, surtout SAP. | Régler pour de bon les problème avec SAP dans le cloud BZ. Renouveller le contrat cyber en février mais ce sera difficile de garder la mensualité qui est très élevé.",
    "comments": "Très gros enjeux de performances dans le cloud, le client est très échaudé et ce sent coincé. | Départements: TI, Cyber | Valeur contrats: 28406.9 | Rentabilité: Rentable (494 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Régler pour de bon les problème avec SAP dans le cloud BZ. Renouveller le contrat cyber en février mais ce sera difficile de garder la mensualité qui est très élevé.. Relation: Bonne relation malgré la situation qui perdure avec les principaux gestionnaires.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 8,
    "ddcActive": true
  },
  {
    "clientName": "Bomat",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: NA. Prime vendeur: NA. Risque de perte: NA.",
    "recommendedAngle": "NA",
    "riskOrCondition": "Risque déclaré: NA. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "NA | NA",
    "comments": "Prospect froid référé à Talamus mais lors du dernier suivi avec Bernard le client n'avait pas donnée suite. | Départements: NA | Valeur contrats: NA",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: NA. Relation: NA. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 9,
    "ddcActive": true
  },
  {
    "clientName": "Capitales de Québec",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Bonne mais pas de communication régulière.. Prime vendeur: 8. Risque de perte: 2.",
    "recommendedAngle": "Ramasser une plus grande part pour la gestion du réseau. Implanter de la cyber/SA/IA. Signer les Aigles.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Rien actuellement à ma connaisance. Ils font affaire avec d'autres partenaires pour leurs TI | Ramasser une plus grande part pour la gestion du réseau. Implanter de la cyber/SA/IA. Signer les Aigles.",
    "comments": "Nouvellement à ma charge, bonne relation avec le DG et l'assistant. Lié à LOB et Vertdure que nous avons perdu. À travailler à la fin de la saison. Nous les commenditons. | Départements: TI | Valeur contrats: 1136.7 | Rentabilité: Rentable (918 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Ramasser une plus grande part pour la gestion du réseau. Implanter de la cyber/SA/IA. Signer les Aigles.. Relation: Bonne mais pas de communication régulière.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 10,
    "ddcActive": true
  },
  {
    "clientName": "Centre Massicotte inc. (Club Piscine)",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Excellente depuis longtemps.. Prime vendeur: 9. Risque de perte: 1.",
    "recommendedAngle": "Leur trouver des solutions centralisé pour leurs besoins. Richard serait une bonne porte pour refaire un logiciel à jour avec IA.",
    "riskOrCondition": "Risque déclaré: 1. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Logiciel principal vieillisant mais très éfficace. Le siège scocial force pour qu'ils utilisent leurs outils et leurs services mais n'y arrive pas. | Leur trouver des solutions centralisé pour leurs besoins. Richard serait une bonne porte pour refaire un logiciel à jour avec IA.",
    "comments": "Jeff plus difficile à travailler mais excellente relation. Richard qui est à la semi retraite est très auvert au changement et à l'IA qu'il utilise vraiment beaucoup. | Départements: TI | Valeur contrats: 5232.07",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Leur trouver des solutions centralisé pour leurs besoins. Richard serait une bonne porte pour refaire un logiciel à jour avec IA.. Relation: Excellente depuis longtemps.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 11,
    "ddcActive": true
  },
  {
    "clientName": "Centre Psycho-Pédagogique de Québec inc. (CPPQ)",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Excellente depuis longtemps et nous soutenons leur cause.. Prime vendeur: 9. Risque de perte: 2.",
    "recommendedAngle": "Remplacer les MAC par des PC, sensibilisation à la cyber, disscusion sur l'IA",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Changement de garde donc s'assurer de rester proche et de bien les accompagner. | Remplacer les MAC par des PC, sensibilisation à la cyber, disscusion sur l'IA",
    "comments": "Nouvelle directrice et mon contact Christian part à la retraite. | Départements: TI | Valeur contrats: 1782.44",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Remplacer les MAC par des PC, sensibilisation à la cyber, disscusion sur l'IA. Relation: Excellente depuis longtemps et nous soutenons leur cause.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 12,
    "ddcActive": true
  },
  {
    "clientName": "Clinique du sommeil Lessard",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Bon voisinage. Prime vendeur: NA. Risque de perte: NA.",
    "recommendedAngle": "NA",
    "riskOrCondition": "Risque déclaré: NA. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "NA | NA",
    "comments": "Prospect ma voisine, long terme mais entreprise en croissance | Départements: NA | Valeur contrats: NA",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: NA. Relation: Bon voisinage. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 13,
    "ddcActive": true
  },
  {
    "clientName": "Conseil de la Nation Wendat",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Excellente. Prime vendeur: 10. Risque de perte: 1.",
    "recommendedAngle": "Vendre des postes à la place d'infounik. Rester à l'écoute pour les besoins en IA et cyber.",
    "riskOrCondition": "Risque déclaré: 1. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "RAS, tout vas très vite là-bas donc garder une bonne communication | Vendre des postes à la place d'infounik. Rester à l'écoute pour les besoins en IA et cyber.",
    "comments": "Nous nous adptons à leur besoin mais très grosse équipe TI | Départements: TI, Programmation | Valeur contrats: 46824.53 | Rentabilité: Rentable (1039 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Vendre des postes à la place d'infounik. Rester à l'écoute pour les besoins en IA et cyber.. Relation: Excellente. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 14,
    "ddcActive": true
  },
  {
    "clientName": "Dentistes pour enfants de Québec (DPE)",
    "accountManager": "Michael Roy",
    "primaryContact": "Contacts VIP / décideurs Servo2: Véronique Lacoste (VIP, Responsable TI, Présidente), Anne-Sophie Fortin-Pagé (VIP), Anne-Sophie Fortin Pagé - hotmail (VIP) et Véronique Lacoste - mac (VIP).",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC + Servo2. Relation: Très bonne, mais certains manquements de l'équipe TI dans les derniers mois et un manque de suivi ont dérangé beaucoup les actionnaires. Prime vendeur / représentant Servo2: Michael Roy. Note prime vendeur DDC: 7. Prime tech Servo2: Maxime Gariépy et Youssouf Kane. Revenu mensuel global Servo2/DDC: 1 966,92 $. Revenu mensuel Service TI: à recalculer depuis la table Servo2 `c-srv-ti`. Risque de perte: 6.",
    "recommendedAngle": "Optimiser la communication et simplifier les processus pour le service TI.",
    "riskOrCondition": "Risque déclaré: 6. Raison mauvais service: manquements TI récents et manque de suivi ayant dérangé les actionnaires; Servo2 montre aussi 193 billets TI sur les 12 derniers mois, plusieurs tâches de départ client au 30-09-2026 et un billet de transfert vers un nouveau fournisseur. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles, les décideurs et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Beaucoup d'appels de service, difficile à rentabiliser. Optimiser la communication, le suivi et les processus de service TI. Données Servo2: client actif id 1391, services cloud_tel et cloud_tech actifs, 193 billets Service TI sur 12 mois.",
    "comments": "Servo2: id_client 1391; alias Clinique dentaire pour enfants; client actif. Prime vendeur: Michael Roy. Prime tech: Maxime Gariépy, Youssouf Kane. Contacts VIP/décideurs: Véronique Lacoste (VIP, Responsable TI, Présidente), Anne-Sophie Fortin-Pagé (VIP). Revenu mensuel global: 1 966,92 $. Revenu mensuel Service TI: à recalculer depuis `c-srv-ti`. Mauvais service: manquements TI récents + manque de suivi, impact actionnaires; billets récents incluent départ client 30-09-2026 et rencontre transfert/nouveau fournisseur. | Départements: TI | Valeur contrats: 1966.92 | Rentabilité: Rentable (225 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy) enrichie avec Servo2. Priorités/enjeux: optimiser la communication et simplifier les processus de service TI. Relation très bonne, mais manquements TI récents et manque de suivi ont dérangé les actionnaires. Servo2 confirme un volume élevé de billets TI (193 sur 12 mois), des contacts VIP/décideurs identifiés et des signaux de départ/transfert fournisseur. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx + Servo2 ERP",
    "sourceSheet": "Michael Roy / Servo2 id_client 1391",
    "sourceRow": 15,
    "ddcActive": true
  },
  {
    "clientName": "Dessercom",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Nul, très difficile de leur parler.. Prime vendeur: 2. Risque de perte: 7.",
    "recommendedAngle": "Resigner une entente adapter à leurs besoin et instaurer des comité TI afin d'optimiser la relation.",
    "riskOrCondition": "Risque déclaré: 7. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Ils ont une équipe TI avec Airmedic et nous contact juste quand ils ont des besoins. | Resigner une entente adapter à leurs besoin et instaurer des comité TI afin d'optimiser la relation.",
    "comments": "Reste juste pour avoir accès à VB | Départements: TI | Valeur contrats: 12369.49 | Rentabilité: Rentable (1068 $/h)",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Resigner une entente adapter à leurs besoin et instaurer des comité TI afin d'optimiser la relation.. Relation: Nul, très difficile de leur parler.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 16,
    "ddcActive": true
  },
  {
    "clientName": "Distribution O-Max et W.C.S",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Excellente avec Anik, bonne avec Steve. Prime vendeur: 10. Risque de perte: 2.",
    "recommendedAngle": "Possibilité de croissance, nouveaux logiciel en implentation, pousser IA et cyber et aller visiter le client.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "RAS | Possibilité de croissance, nouveaux logiciel en implentation, pousser IA et cyber et aller visiter le client.",
    "comments": "Passe à SAP et client région de Montréal | Départements: TI | Valeur contrats: 3060.55 | Rentabilité: Rentable (325 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Possibilité de croissance, nouveaux logiciel en implentation, pousser IA et cyber et aller visiter le client.. Relation: Excellente avec Anik, bonne avec Steve. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 17,
    "ddcActive": true
  },
  {
    "clientName": "EGL Construction",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, j'ai des amis communs avec Benoit. Beaucoup brassé dans les dernières années car ils n'étaient pas rentable.. Prime vendeur: 7. Risque de perte: 3.",
    "recommendedAngle": "Ajouter services Cyber en plus du SAT, rencontre IA.",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Vienne de migrer Mastro web, délaisse un peu Copilot | Ajouter services Cyber en plus du SAT, rencontre IA.",
    "comments": "Bon client qui nous solicite quand ils ont des besoins | Départements: TI | Valeur contrats: 3018.2 | Rentabilité: Moyen (138 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Ajouter services Cyber en plus du SAT, rencontre IA.. Relation: Bonne, j'ai des amis communs avec Benoit. Beaucoup brassé dans les dernières années car ils n'étaient pas rentable.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 18,
    "ddcActive": true
  },
  {
    "clientName": "EGR",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Bonne relation avec les TI mais plus difficile d'atteindre la direction. Marc-André semble plus ouvert qu'Alex l'était.. Prime vendeur: 8. Risque de perte: 2.",
    "recommendedAngle": "Ce positionner pour les aider en IA. Vendre la téléphonie. Rester la référence pour les opérations et les projets TI.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Virage IA en cours. | Ce positionner pour les aider en IA. Vendre la téléphonie. Rester la référence pour les opérations et les projets TI.",
    "comments": "ODS de télphonie en attente | Départements: TI | Valeur contrats: 12337.02 | Rentabilité: Moyen (159 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Ce positionner pour les aider en IA. Vendre la téléphonie. Rester la référence pour les opérations et les projets TI.. Relation: Bonne relation avec les TI mais plus difficile d'atteindre la direction. Marc-André semble plus ouvert qu'Alex l'était.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 19,
    "ddcActive": true
  },
  {
    "clientName": "Eric Fortin",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Très bonne mais plus vraiement de contact. Prime vendeur: 10. Risque de perte: 2.",
    "recommendedAngle": "Avoir une discusion sur ses projets.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Avoir une discusion sur ses projets.",
    "comments": "Service de base | Départements: TI | Valeur contrats: 222.89 | Rentabilité: Rentable (975 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Avoir une discusion sur ses projets.. Relation: Très bonne mais plus vraiement de contact. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 20,
    "ddcActive": true
  },
  {
    "clientName": "Etincelle",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Bonne. Prime vendeur: 9. Risque de perte: 4.",
    "recommendedAngle": "Aller diner pour parler des elignements et d'IA/développement web",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Client modeste | Aller diner pour parler des elignements et d'IA/développement web",
    "comments": "Patenaire référenceur | Départements: TI | Valeur contrats: 1144.06 | Rentabilité: Rentable (292 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Aller diner pour parler des elignements et d'IA/développement web. Relation: Bonne. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 21,
    "ddcActive": true
  },
  {
    "clientName": "Excellente Gestion inc. (École de conduite Tecnic)",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne. Prime vendeur: 8. Risque de perte: 4.",
    "recommendedAngle": "Voir comment se positionner pour continuer à les accompagner.",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Nous allons perdrent les licences M365 et probablement le cloud | Voir comment se positionner pour continuer à les accompagner.",
    "comments": "Sera bientôt obligé de passer les solutions du franchiseur | Départements: TI | Valeur contrats: 3822.23 | Rentabilité: Rentable (573 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Voir comment se positionner pour continuer à les accompagner.. Relation: Bonne. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 22,
    "ddcActive": true
  },
  {
    "clientName": "Flyscan",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne. Prime vendeur: 8. Risque de perte: 2.",
    "recommendedAngle": "Prendre l'hébergement Azure.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Renouvellement TI et cyber début 2027 | Prendre l'hébergement Azure.",
    "comments": "Azure $$$ | Départements: TI, Cyber | Valeur contrats: 12109.29 | Rentabilité: Rentable (323 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Prendre l'hébergement Azure.. Relation: Bonne. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 23,
    "ddcActive": true
  },
  {
    "clientName": "Gaignard",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: NA. Prime vendeur: NA. Risque de perte: NA.",
    "recommendedAngle": "NA",
    "riskOrCondition": "Risque déclaré: NA. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "NA | NA",
    "comments": "Prospect long terme | Départements: NA | Valeur contrats: NA",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: NA. Relation: NA. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 24,
    "ddcActive": true
  },
  {
    "clientName": "Gaévan Hino Québec",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Bonne malgré tout. Prime vendeur: 6. Risque de perte: 4.",
    "recommendedAngle": "Comité TI et contact plus fréquent",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Voit les TI comme une dépense | Comité TI et contact plus fréquent",
    "comments": "Peut de contact sauf pour des problèmes | Départements: TI | Valeur contrats: 2739.66 | Rentabilité: Rentable (451 $/h)",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Comité TI et contact plus fréquent. Relation: Bonne malgré tout. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 25,
    "ddcActive": true
  },
  {
    "clientName": "Gestion Immobilière Lafrance et Mathieu",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Très bonne avec Guillaume. Prime vendeur: 9. Risque de perte: 2.",
    "recommendedAngle": "Plus de rigueur sur les projets, maintenir et ajouter des services cyber, SA et IA.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Challenge souvent les frais | Plus de rigueur sur les projets, maintenir et ajouter des services cyber, SA et IA.",
    "comments": "Client de longue date | Départements: TI, Cyber | Valeur contrats: 11410.81 | Rentabilité: Rentable (245 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Plus de rigueur sur les projets, maintenir et ajouter des services cyber, SA et IA.. Relation: Très bonne avec Guillaume. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 26,
    "ddcActive": true
  },
  {
    "clientName": "Globco",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne mais client très occupé. Prime vendeur: 7. Risque de perte: 2.",
    "recommendedAngle": "ODS de cyber envoyé, client très ouvert. Projet prog pour remplacer Front.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Faire avancer les dossiers… | ODS de cyber envoyé, client très ouvert. Projet prog pour remplacer Front.",
    "comments": "Nouvellement dans le dossier | Départements: TI | Valeur contrats: 9820 | Rentabilité: Rentable (426 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: ODS de cyber envoyé, client très ouvert. Projet prog pour remplacer Front.. Relation: Bonne mais client très occupé. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 27,
    "ddcActive": true
  },
  {
    "clientName": "GM Développement inc.",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne mais dur à contacté à part Andrée. Prime vendeur: 6. Risque de perte: 2.",
    "recommendedAngle": "Passer la cyber et faire avancé les projets.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Très lent à bouger | Passer la cyber et faire avancé les projets.",
    "comments": "Comité TI vienne de commencer | Départements: TI | Valeur contrats: 5926.31 | Rentabilité: Moyen (195 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Passer la cyber et faire avancé les projets.. Relation: Bonne mais dur à contacté à part Andrée. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 28,
    "ddcActive": true
  },
  {
    "clientName": "Groupe Guilbault",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Pratiquement nul. Prime vendeur: 1. Risque de perte: 8.",
    "recommendedAngle": "Trouver une façon de les garder sur le long terme. Comité TI et accompagnement projet? IA?",
    "riskOrCondition": "Risque déclaré: 8. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Contrat démesuré pour ce qu'on fait. | Trouver une façon de les garder sur le long terme. Comité TI et accompagnement projet? IA?",
    "comments": "Parle juste avec VB | Départements: TI | Valeur contrats: 6721.06 | Rentabilité: Rentable (3942 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Élevé",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Trouver une façon de les garder sur le long terme. Comité TI et accompagnement projet? IA?. Relation: Pratiquement nul. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 29,
    "ddcActive": true
  },
  {
    "clientName": "Groupe J.L. Leclerc",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: En développement mais bonne. Prime vendeur: 6. Risque de perte: 2.",
    "recommendedAngle": "Projet prog et cyber.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "TI adressés l'année passée avec des visites périodiques | Projet prog et cyber.",
    "comments": "Nouvellement dans le dossier | Départements: TI | Valeur contrats: 10984.03 | Rentabilité: Rentable (269 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Projet prog et cyber.. Relation: En développement mais bonne. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 30,
    "ddcActive": true
  },
  {
    "clientName": "Groupe Vertdure",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Restez proche au besoin. Prime vendeur: NA. Risque de perte: NA.",
    "recommendedAngle": "NA",
    "riskOrCondition": "Risque déclaré: NA. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "NA | NA",
    "comments": "Plus client reste juste des licences jusqu'à l'échéance. | Départements: Licences | Valeur contrats: 1427.16",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: NA. Relation: Restez proche au besoin. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 31,
    "ddcActive": true
  },
  {
    "clientName": "HCL",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: En développement mais bonne. Prime vendeur: 7. Risque de perte: 2.",
    "recommendedAngle": "Signer long terme",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Technicalité de contrat en cours | Signer long terme",
    "comments": "Renouvellement en cours | Départements: Cloud",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Signer long terme. Relation: En développement mais bonne. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 32,
    "ddcActive": true
  },
  {
    "clientName": "Hôtel Château Laurier Québec",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Très bonne. Prime vendeur: 8. Risque de perte: 2.",
    "recommendedAngle": "Tout va bien",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Renouvellement | Tout va bien",
    "comments": "Toute les entitées | Départements: TI, Cyber | Valeur contrats: 14927.38 | Rentabilité: Faible (119 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Tout va bien. Relation: Très bonne. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 33,
    "ddcActive": true
  },
  {
    "clientName": "Immeubles Jacques Robitaille (Hôtel Must)",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne. Prime vendeur: 8. Risque de perte: 2.",
    "recommendedAngle": "Implanter la cyber ODS présenté",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Projets avances très lentement et les Robitaille difficile d'accès | Implanter la cyber ODS présenté",
    "comments": "Client de longue date | Départements: TI | Valeur contrats: 13115.25 | Rentabilité: Rentable (1856 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Implanter la cyber ODS présenté. Relation: Bonne. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 34,
    "ddcActive": true
  },
  {
    "clientName": "L'Intendant",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Correct mais professionnel. Prime vendeur: 5. Risque de perte: 3.",
    "recommendedAngle": "Implanter la cyber",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Plus JMC le contact | Implanter la cyber",
    "comments": "Relation en dent de scie | Départements: TI | Valeur contrats: 10848.55 | Rentabilité: Moyen (167 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Implanter la cyber. Relation: Correct mais professionnel. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 35,
    "ddcActive": true
  },
  {
    "clientName": "Les Services JAG inc (Procam) (Veilleux Transit)",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Mieux dernièrement mais le tech Julien très très spécial. Bonne avec le DG mais homme de peu de mots. Prime vendeur: 6. Risque de perte: 8.",
    "recommendedAngle": "Rester le plus longtemps possible et coopérer avec les TI de TFI",
    "riskOrCondition": "Risque déclaré: 8. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Audi en cours et implentation du SAT. Aussi plusieurs outils de sécurité mis en place avec TFI | Rester le plus longtemps possible et coopérer avec les TI de TFI",
    "comments": "Suite à un incident cyber, TFI commence à prendre le contrôle | Départements: TI | Valeur contrats: 9947.95 | Rentabilité: Rentable (496 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Élevé",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Rester le plus longtemps possible et coopérer avec les TI de TFI. Relation: Mieux dernièrement mais le tech Julien très très spécial. Bonne avec le DG mais homme de peu de mots. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 36,
    "ddcActive": true
  },
  {
    "clientName": "Liquide à Poudre",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Voir Smak | Départements: TI | Valeur contrats: 305.28 | Rentabilité: Rentable (242 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 37,
    "ddcActive": true
  },
  {
    "clientName": "Macpek",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Très bonne avec Steven et Matthew. Prime vendeur: 9. Risque de perte: 2.",
    "recommendedAngle": "Essayer de leur vendre des postes car plusieurs à remplacer, ajout de cyber et intéressé par l'IA.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Surtout les budget mais nous tirons bien notre épeingle du jeux, surtout avec l'ajout de la prog | Essayer de leur vendre des postes car plusieurs à remplacer, ajout de cyber et intéressé par l'IA.",
    "comments": "Plusieurs changements récents, ventes de division roue et changement de propriétaire pour Macpek | Départements: TI, Programmation | Valeur contrats: 12828.28 | Rentabilité: Rentable (293 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Essayer de leur vendre des postes car plusieurs à remplacer, ajout de cyber et intéressé par l'IA.. Relation: Très bonne avec Steven et Matthew. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 38,
    "ddcActive": true
  },
  {
    "clientName": "Marc Bellemare avocat",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Jamais parlé",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 39,
    "ddcActive": true
  },
  {
    "clientName": "MV Express inc",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Bonne malgré les événement avec Mélanie la TI et Patrice le nouveau gestionnaire. Prime vendeur: 8. Risque de perte: 2.",
    "recommendedAngle": "Implenter comité TI, instaurer de la cyber, discuter d'IA.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Refaire un plan directeur maintenant que la tempête interne est passé | Implenter comité TI, instaurer de la cyber, discuter d'IA.",
    "comments": "Il y a eu beaucoup d'action dans la dernière année et changement au niveau de la direction | Départements: TI | Valeur contrats: 5997.53 | Rentabilité: Moyen (172 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Implenter comité TI, instaurer de la cyber, discuter d'IA.. Relation: Bonne malgré les événement avec Mélanie la TI et Patrice le nouveau gestionnaire. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 40,
    "ddcActive": true
  },
  {
    "clientName": "Pierre Boily Électrique",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Excellente. Prime vendeur: 8. Risque de perte: 2.",
    "recommendedAngle": "Téléphonie, Philippe intéressé par l'IA mais pense utiliser Claude, rentrer de la cyber.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Relancer les projets discutés et finir par les migrer dans le cloud BZ. | Téléphonie, Philippe intéressé par l'IA mais pense utiliser Claude, rentrer de la cyber.",
    "comments": "Contact principal Mireille en congé de maternité | Départements: TI | Valeur contrats: 2772.8 | Rentabilité: Rentable (377 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Téléphonie, Philippe intéressé par l'IA mais pense utiliser Claude, rentrer de la cyber.. Relation: Excellente. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 41,
    "ddcActive": true
  },
  {
    "clientName": "PMM Wendake",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Rare rencontre mais bonne. Prime vendeur: 7. Risque de perte: 2.",
    "recommendedAngle": "Écoute nos conseils mais veulent le minimum",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Écoute nos conseils mais veulent le minimum",
    "comments": "Petit client besoin de base | Départements: TI | Valeur contrats: 516.07 | Rentabilité: Rentable (236 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Moyenne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Écoute nos conseils mais veulent le minimum. Relation: Rare rencontre mais bonne. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 42,
    "ddcActive": true
  },
  {
    "clientName": "Radio Communautaire Huronne Wyandot",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Rare rencontre mais bonne. Prime vendeur: 6. Risque de perte: 1.",
    "recommendedAngle": "Il y a eu du mouvement entre la radio et le bingo. Réévaluer les besoins pour parler aux bonnes personnes et aussi travaux en lien avec le conseil déjà en cours.",
    "riskOrCondition": "Risque déclaré: 1. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "On retiré la cyber car jugeait plus nécessaire | Il y a eu du mouvement entre la radio et le bingo. Réévaluer les besoins pour parler aux bonnes personnes et aussi travaux en lien avec le conseil déjà en cours.",
    "comments": "Pas beaucoup de contact | Départements: TI | Valeur contrats: 3529.81 | Rentabilité: Rentable (10805 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Il y a eu du mouvement entre la radio et le bingo. Réévaluer les besoins pour parler aux bonnes personnes et aussi travaux en lien avec le conseil déjà en cours.. Relation: Rare rencontre mais bonne. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 43,
    "ddcActive": true
  },
  {
    "clientName": "RSSW",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Au besoin mais eu un bon fit avec le directeur TI au départ. Prime vendeur: 2. Risque de perte: 10.",
    "recommendedAngle": "Il vont quitter quand la migration sera terminé.",
    "riskOrCondition": "Risque déclaré: 10. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Il vont quitter quand la migration sera terminé.",
    "comments": "Client temporaire (Unimax) qui on racheté à Macpek. | Départements: Cloud | Valeur contrats: 2100.89",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Moyenne",
    "ddcRiskLevel": "Élevé",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Il vont quitter quand la migration sera terminé.. Relation: Au besoin mais eu un bon fit avec le directeur TI au départ. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 44,
    "ddcActive": true
  },
  {
    "clientName": "Service Policier de Wendake",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Très bonne. Prime vendeur: 10. Risque de perte: 1.",
    "recommendedAngle": "Contrat trop cher car ce sont les techs du conseil qui les gèrent maintenant",
    "riskOrCondition": "Risque déclaré: 1. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Contrat trop cher car ce sont les techs du conseil qui les gèrent maintenant",
    "comments": "Géré avec la Nation Wendat | Départements: TI, Programmation | Valeur contrats: 1262.36 | Rentabilité: Rentable (332 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Moyenne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Contrat trop cher car ce sont les techs du conseil qui les gèrent maintenant. Relation: Très bonne. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 45,
    "ddcActive": true
  },
  {
    "clientName": "Services Comptables de Québec inc.",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Bonne relation mais toujours difficile quand ça parle de sous.. Prime vendeur: 8. Risque de perte: 2.",
    "recommendedAngle": "Discuté IA et cyber",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Pas d'enjeux | Discuté IA et cyber",
    "comments": "Bien avancé avec la prog. Ils ont recemment accepté de migrer leur dernière apps externe avec nous. | Départements: TI | Valeur contrats: 6924.95 | Rentabilité: Rentable (631 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Discuté IA et cyber. Relation: Bonne relation mais toujours difficile quand ça parle de sous.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 46,
    "ddcActive": true
  },
  {
    "clientName": "Services Financiers Rudy Blondeau",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Très bonne. Prime vendeur: 9. Risque de perte: 5.",
    "recommendedAngle": "Garder le contact car il a aussi un espace 365 et un support avec Industriel alliance il me semble.",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Pas d'enjeux | Garder le contact car il a aussi un espace 365 et un support avec Industriel alliance il me semble.",
    "comments": "Besoin de base | Départements: TI | Valeur contrats: 179.76 | Rentabilité: Rentable (777 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Garder le contact car il a aussi un espace 365 et un support avec Industriel alliance il me semble.. Relation: Très bonne. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 47,
    "ddcActive": true
  },
  {
    "clientName": "SieBert",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Prospect automne",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 48,
    "ddcActive": true
  },
  {
    "clientName": "Signé MMB",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Juste des backups | Valeur contrats: 4",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 49,
    "ddcActive": true
  },
  {
    "clientName": "Smak Design",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Très bonne mais Julein est particulié. Prime vendeur: 8. Risque de perte: 2.",
    "recommendedAngle": "Avoir une rencontre pour l'IA, pousser pour de la cyber",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Situation stable depuis quelques temps | Avoir une rencontre pour l'IA, pousser pour de la cyber",
    "comments": "Pas eu de contacts récents | Départements: TI | Valeur contrats: 2890.64 | Rentabilité: Rentable (231 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Avoir une rencontre pour l'IA, pousser pour de la cyber. Relation: Très bonne mais Julein est particulié. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 50,
    "ddcActive": true
  },
  {
    "clientName": "Société de crédit commercial autochtone",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Quand même bonne mais c'est dégradé depuis l'arrivé du TI externe. Prime vendeur: 6. Risque de perte: 4.",
    "recommendedAngle": "Rencontre IA car interpelé par les nouvelles menaces en lien avec Mytos pi toute.",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Difficile la communication avec le service et les demandes souvent urgentes | Rencontre IA car interpelé par les nouvelles menaces en lien avec Mytos pi toute.",
    "comments": "Directeur TI externe assez rigide | Départements: TI | Valeur contrats: 3562.1 | Rentabilité: Rentable (358 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Rencontre IA car interpelé par les nouvelles menaces en lien avec Mytos pi toute.. Relation: Quand même bonne mais c'est dégradé depuis l'arrivé du TI externe. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 51,
    "ddcActive": true
  },
  {
    "clientName": "Société immobilière du Regroupement des centres d'amitié autochtones du Québec (SIRCAAQ)",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Changé de représentente à relancer.. Prime vendeur: NA. Risque de perte: NA.",
    "recommendedAngle": "Signé en TI et cyber",
    "riskOrCondition": "Risque déclaré: NA. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "NA | Signé en TI et cyber",
    "comments": "Prospect long terme qui va déménager dans les nouvelles batisses de Wendake. | Départements: NA",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Signé en TI et cyber. Relation: Changé de représentente à relancer.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 52,
    "ddcActive": true
  },
  {
    "clientName": "Solaris Québec Portes et Fenêtres inc.",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne. Prime vendeur: 5. Risque de perte: 4.",
    "recommendedAngle": "Planifier une rencontre IA",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Rester à l'écoute car il travail en solo | Planifier une rencontre IA",
    "comments": "Travail en loner et nous utilise rarement | Départements: TI | Valeur contrats: 2989.17 | Rentabilité: Rentable (3533 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Planifier une rencontre IA. Relation: Bonne. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 53,
    "ddcActive": true
  },
  {
    "clientName": "Soucy Aquatik",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Bonne. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Projet de prog n'a pas été accepté. Garder dan la loop pour les TI",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Projet de prog n'a pas été accepté. Garder dan la loop pour les TI",
    "comments": "Prospect",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Moyenne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Projet de prog n'a pas été accepté. Garder dan la loop pour les TI. Relation: Bonne. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 54,
    "ddcActive": true
  },
  {
    "clientName": "Steinlex inc.",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Récente, peu fréquente mais bonne. Prime vendeur: 6. Risque de perte: 6.",
    "recommendedAngle": "S'assurer de garder une bonne comminication pour leur partager notre expertise et garder notre valeur.",
    "riskOrCondition": "Risque déclaré: 6. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Angle cyber et IA plus que TI pour l'avenir | S'assurer de garder une bonne comminication pour leur partager notre expertise et garder notre valeur.",
    "comments": "Retire des services de plus en plus | Départements: TI, Cyber | Valeur contrats: 6680 | Rentabilité: Rentable (704 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: S'assurer de garder une bonne comminication pour leur partager notre expertise et garder notre valeur.. Relation: Récente, peu fréquente mais bonne. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 55,
    "ddcActive": true
  },
  {
    "clientName": "Tassé Bertrand Barabé Avocats inc.",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Correct mais professionnel. Prime vendeur: 5. Risque de perte: 2.",
    "recommendedAngle": "Faire avancer les dossiers, renouvellement cyber, pousser Convoflo",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Francis qui gère pas mal les dossiers | Faire avancer les dossiers, renouvellement cyber, pousser Convoflo",
    "comments": "Enjeux de facturation récemment et difficulté à faire avancer les projets | Départements: TI, Cyber | Valeur contrats: 7973.55 | Rentabilité: Moyen (190 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Faire avancer les dossiers, renouvellement cyber, pousser Convoflo. Relation: Correct mais professionnel. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 56,
    "ddcActive": true
  },
  {
    "clientName": "Tibo",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Encore en développeement mais excellente. Prime vendeur: 8. Risque de perte: 2.",
    "recommendedAngle": "Rester à l'affut pour les bot et l'accompagnement. Projet Purview.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Très techno et équipe à l'interne. Le nouveau TI Matthieu très compétent. Ils ont des besoins IA exprimé dans la rencontre avec Dany qui sont complexent. | Rester à l'affut pour les bot et l'accompagnement. Projet Purview.",
    "comments": "Très satisfait jusqu'à maintenant | Départements: TI, SA | Valeur contrats: 1389.67",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Rester à l'affut pour les bot et l'accompagnement. Projet Purview.. Relation: Encore en développeement mais excellente. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 57,
    "ddcActive": true
  },
  {
    "clientName": "Toitures R. Martin",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Pas trop de proximité. Prime vendeur: 3. Risque de perte: 4.",
    "recommendedAngle": "Aller diner et leurs expliquer ce qu'on peu faire pour eux via un plan directeur et autre.",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Prendre du temps pour établir une bonne relation et pas juste gérer les opérations. | Aller diner et leurs expliquer ce qu'on peu faire pour eux via un plan directeur et autre.",
    "comments": "Client oldschool qui a mal commencé mais stable depuis quelques mois suite à une discusion avec le boss. | Départements: TI | Valeur contrats: 2378.52 | Rentabilité: Moyen (134 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Aller diner et leurs expliquer ce qu'on peu faire pour eux via un plan directeur et autre.. Relation: Pas trop de proximité. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 58,
    "ddcActive": true
  },
  {
    "clientName": "Transport Lavoie",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bon fit avec Martin Lavoie. Il sait ce qu'il veut.. Prime vendeur: 6. Risque de perte: 2.",
    "recommendedAngle": "Implenter des comité TI, Prisme et disucté d'IA comme ils ont quelques solutions pour la gestions des camions et autres.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Nous sommes en mode opération et peu de contact. | Implenter des comité TI, Prisme et disucté d'IA comme ils ont quelques solutions pour la gestions des camions et autres.",
    "comments": "J'en entend pas parler donc je présume que tout va bien | Départements: TI | Valeur contrats: 5973.67 | Rentabilité: Rentable (350 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Implenter des comité TI, Prisme et disucté d'IA comme ils ont quelques solutions pour la gestions des camions et autres.. Relation: Bon fit avec Martin Lavoie. Il sait ce qu'il veut.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 59,
    "ddcActive": true
  },
  {
    "clientName": "Unipêche MDM Ltée",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Très bonne avec Maxime. Prime vendeur: 8. Risque de perte: 1.",
    "recommendedAngle": "Implantation de bot, avancer en cyber.",
    "riskOrCondition": "Risque déclaré: 1. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Implantation de bot proposé et direction TI plus haut niveau | Implantation de bot, avancer en cyber.",
    "comments": "Bon client fidèle mais ils sont souvent débordé | Départements: TI, Cyber | Valeur contrats: 16284.33 | Rentabilité: Rentable (416 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Implantation de bot, avancer en cyber.. Relation: Très bonne avec Maxime. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 60,
    "ddcActive": true
  },
  {
    "clientName": "Yandata",
    "accountManager": "Michael Roy",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Contact peu fréquents. Prime vendeur: 5. Risque de perte: 3.",
    "recommendedAngle": "Nous faisons juste la gestion des courriels 365, ils passe par une autre organisation pour leurs TI",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Nous faisons juste la gestion des courriels 365, ils passe par une autre organisation pour leurs TI",
    "comments": "En lien avec la Nation huronne, interventions facturables. | Départements: TI | Valeur contrats: 192.15",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Moyenne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Michael Roy). Priorités/enjeux: Nous faisons juste la gestion des courriels 365, ils passe par une autre organisation pour leurs TI. Relation: Contact peu fréquents. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Michael Roy",
    "sourceRow": 61,
    "ddcActive": true
  },
  {
    "clientName": "Acoustico inc",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: elle aime bien bz, très bonne relation. Pas demandante. Prime vendeur: 9. Risque de perte: 2.",
    "recommendedAngle": "SAT",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "SAT",
    "comments": "Pas d'enjeux | Départements: TI | Valeur contrats: 351.27 | Rentabilité: Rentable (670 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: SAT. Relation: elle aime bien bz, très bonne relation. Pas demandante. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 2,
    "ddcActive": true
  },
  {
    "clientName": "Agence de communications Unik Inc.",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Assez distants. Prime vendeur: 7. Risque de perte: 4.",
    "recommendedAngle": "IA, Cyber. Client à relancer. Attaquer télécom",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "IA, Cyber. Client à relancer. Attaquer télécom",
    "comments": "changement de chaise interne, faire suivi. Proposer Bot et MAJ Cyber | Départements: TI, Cyber | Valeur contrats: 6033.28 | Rentabilité: Moyen (140 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: IA, Cyber. Client à relancer. Attaquer télécom. Relation: Assez distants. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 3,
    "ddcActive": true
  },
  {
    "clientName": "Armateurs du St-Laurent",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, on a du s'ajuster et faire ménage licences. Client content de l'économie trouvée. Prime vendeur: 8. Risque de perte: 4.",
    "recommendedAngle": "attaquer IA, cyber",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "attaquer IA et cyber | attaquer IA, cyber",
    "comments": "Confiance installée, ménaghe licences fait, rappel effectué avant la date anniversaire des Premium | Départements: TI,Telecom | Valeur contrats: 740.28 | Rentabilité: Rentable (276 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: attaquer IA, cyber. Relation: Bonne, on a du s'ajuster et faire ménage licences. Client content de l'économie trouvée. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 4,
    "ddcActive": true
  },
  {
    "clientName": "Association Bénévole de l'Île d'Orléans",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Très bonne.. Prime vendeur: 9. Risque de perte: 2.",
    "recommendedAngle": "rien",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Budget restreint | rien",
    "comments": "Copilot renouvellées. BZ présents à l'ile, commandite pour le festival de L'ile en musique | Départements: TI, Télécom | Valeur contrats: 849.45 | Rentabilité: Rentable (403 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: rien. Relation: Très bonne.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 5,
    "ddcActive": true
  },
  {
    "clientName": "Association des directeurs municipaux du Québec",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Très bonne confiance, transparence. Prime vendeur: 9. Risque de perte: 5.",
    "recommendedAngle": "mettre équipe admin en basic avec service mobile. Cyber, téléphonie. Faire attention au budget Trouver le tour de sorir les MRC des muni dans la gestion des TI. Rendre client plus rentable",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Enjeux de budget. Equipe admin de 8-9 travaillent en gmail. Ont des bugs avec Zeedrive à cause de leur logiciel x | mettre équipe admin en basic avec service mobile. Cyber, téléphonie. Faire attention au budget Trouver le tour de sorir les MRC des muni dans la gestion des TI. Rendre client plus rentable",
    "comments": "BZ présents au salon ADMQ. Plusieurs oppotunités. | Départements: TI, Telecom | Valeur contrats: 1996.84 | Rentabilité: Moyen (138 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: mettre équipe admin en basic avec service mobile. Cyber, téléphonie. Faire attention au budget Trouver le tour de sorir les MRC des muni dans la gestion des TI. Rendre client plus rentable. Relation: Très bonne confiance, transparence. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 6,
    "ddcActive": true
  },
  {
    "clientName": "Atelier de préparation à l’emploi (A.P.E.) Inc.",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Très bonne relation de confiance. Gros travail de fait avec le client. Prime vendeur: 10. Risque de perte: 1.",
    "recommendedAngle": "Rencontre IA planifiée. Implanter agent pour les 22 intervenantes. Automatiser résumé de rencontre virtuel ou présentiel. Envoi de documents clients, automatiser tâches redondantes",
    "riskOrCondition": "Risque déclaré: 1. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Renou cyber sept | Rencontre IA planifiée. Implanter agent pour les 22 intervenantes. Automatiser résumé de rencontre virtuel ou présentiel. Envoi de documents clients, automatiser tâches redondantes",
    "comments": "contrat TI renouvellé. Nouveau client télécom. Changement pare-feu acceptés. Rdv Bot planifié en sept et instauré plan directeur et comité TI avec JM | Départements: TI, Cyber,télécom | Valeur contrats: 4706.43 | Rentabilité: Moyen (199 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: Rencontre IA planifiée. Implanter agent pour les 22 intervenantes. Automatiser résumé de rencontre virtuel ou présentiel. Envoi de documents clients, automatiser tâches redondantes. Relation: Très bonne relation de confiance. Gros travail de fait avec le client. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 7,
    "ddcActive": true
  },
  {
    "clientName": "Aviseo Conseil",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne depuis la nouvelle DG. J'étais inquiète au début mai sa renouvellé en annuelles. Lien de confiance s'installe mais cliente a des bons contacts en ti. On reste proche!. Prime vendeur: 8. Risque de perte: 5.",
    "recommendedAngle": "Cyber/IA. Automatisation. Grosse organisation, 47 Copilot",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "ont décidé de ne pas se conformer au SOC 2 mais cyber en cours | Cyber/IA. Automatisation. Grosse organisation, 47 Copilot",
    "comments": "Nouvelle DG techno. Vient de renouveller ses 47 Copilot. Vien de passer ses Premiums en annuelles. N'iront pas de l'Avant avec la conformité du SOC mais cyber en cours, évaluation qui puisse répondre à leurs enjeux et leurs besoins | Départements: TI, Cyber | Valeur contrats: 10178.1 | Rentabilité: Rentable (411 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: Cyber/IA. Automatisation. Grosse organisation, 47 Copilot. Relation: Bonne depuis la nouvelle DG. J'étais inquiète au début mai sa renouvellé en annuelles. Lien de confiance s'installe mais cliente a des bons contacts en ti. On reste proche!. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 8,
    "ddcActive": true
  },
  {
    "clientName": "Bernier Beaudry",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 9,
    "ddcActive": true
  },
  {
    "clientName": "Bédard Poulin Avocats (BP Avocats)",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: à relancer. Prime vendeur: 6. Risque de perte: 5.",
    "recommendedAngle": "renouveller le contrat cyber.attaquer télécom et parler d'IA selon les enjeux du client. Prog ++",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "? | renouveller le contrat cyber.attaquer télécom et parler d'IA selon les enjeux du client. Prog ++",
    "comments": "Difficile d'avoir un retour. Client stable. Attaquer télécom | Départements: TI | Valeur contrats: 1147.76 | Rentabilité: Moyen (173 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: renouveller le contrat cyber.attaquer télécom et parler d'IA selon les enjeux du client. Prog ++. Relation: à relancer. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 10,
    "ddcActive": true
  },
  {
    "clientName": "Cabinet Langlois et associés",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Associé ami Mel- très gros cabinet",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 11,
    "ddcActive": true
  },
  {
    "clientName": "Chabot Carrosserie inc.",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Très bonne confiance, transparence. Prime vendeur: 9. Risque de perte: 1.",
    "recommendedAngle": "Prog ++ Automatiser ++ . renou cyber automne. Attaquer téléphonie?",
    "riskOrCondition": "Risque déclaré: 1. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "lenteurs ts avec Acomba, Sébastien là-dessus. Uniformiser les 3 usines | Prog ++ Automatiser ++ . renou cyber automne. Attaquer téléphonie?",
    "comments": "Entreprises grandissante- pleins d'opportunités cyber- IA etc. Près du client. Bcp de prog en cours | Départements: TI, Programmation,,Cyber,télécom | Valeur contrats: 11537.51 | Rentabilité: Rentable (212 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: Prog ++ Automatiser ++ . renou cyber automne. Attaquer téléphonie?. Relation: Très bonne confiance, transparence. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 12,
    "ddcActive": true
  },
  {
    "clientName": "Cité importation inc ( coifferie.com)",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 13,
    "ddcActive": true
  },
  {
    "clientName": "Compo Orléans",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Pas très bonne depuis prise en charge. Prime vendeur: 2. Risque de perte: 9.",
    "recommendedAngle": "Rétablir confiance",
    "riskOrCondition": "Risque déclaré: 9. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Voulait sortir de M365 me semble | Rétablir confiance",
    "comments": "Ishh. Ça pu. Ils se tiennent loin et songe à sortir de M365. on leur a offert de partir si ca fait pas. Eu rencontre avec antoine. Client à relancer | Départements: TI | Valeur contrats: 1037.01 | Rentabilité: Rentable (281 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Élevé",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: Rétablir confiance. Relation: Pas très bonne depuis prise en charge. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 14,
    "ddcActive": true
  },
  {
    "clientName": "Comptalia",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Bien, confiance. Prime vendeur: 9. Risque de perte: 3.",
    "recommendedAngle": "Intérêt sat et loi 25. Assurance cyber en cours. Client à relancer",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Renou cyber assurances en cours. ODS envoyée | Intérêt sat et loi 25. Assurance cyber en cours. Client à relancer",
    "comments": "Bien! Opportunités de cyber en cours. Loi 25. Copilot oui! | Départements: TI, Télécom | Valeur contrats: 567.18 | Rentabilité: Rentable (230 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: Intérêt sat et loi 25. Assurance cyber en cours. Client à relancer. Relation: Bien, confiance. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 15,
    "ddcActive": true
  },
  {
    "clientName": "Concept C Shop",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Good, confiance installée.relation facile et respectueuse. Prime vendeur: 8. Risque de perte: 3.",
    "recommendedAngle": "Intéret I.A. template envoyé me revient après ses vacances",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "pas d'enjeux | Intéret I.A. template envoyé me revient après ses vacances",
    "comments": "Intérêt IA, Template envoyé. En vacance. Copilot oui. Ménage licence fait. Belle proximité | Départements: TI,télécom | Valeur contrats: 2656.98 | Rentabilité: Rentable (240 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: Intéret I.A. template envoyé me revient après ses vacances. Relation: Good, confiance installée.relation facile et respectueuse. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 16,
    "ddcActive": true
  },
  {
    "clientName": "Conseil Québécois des Services de Garde Éducatifs",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, aurait voulu des formation Copilot gratuites. Prime vendeur: 7. Risque de perte: 3.",
    "recommendedAngle": "maximiser connaissance de Copilot. Je dois Attaquer pour intégrer IA. enjeux de budget",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "aurait voulu des formation Copilot gratuites | maximiser connaissance de Copilot. Je dois Attaquer pour intégrer IA. enjeux de budget",
    "comments": "Copilot oui. Intérêt pour IA serait à attaquer. Pas facile de les rejoindre | Départements: TI, Télécom | Valeur contrats: 1226.55 | Rentabilité: Rentable (582 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: maximiser connaissance de Copilot. Je dois Attaquer pour intégrer IA. enjeux de budget. Relation: Bonne, aurait voulu des formation Copilot gratuites. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 17,
    "ddcActive": true
  },
  {
    "clientName": "Coop. La Seigneurie",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Good. Prime vendeur: 9. Risque de perte: 2.",
    "recommendedAngle": "intérêt pour SAT. Mel doit monter un ODS SAT. Client revient de vacances. Intérêt pour intégrer IA à planifier plus tard à la demande du client. Client bon contact chez Microâge mais me dit qu'il n'a pas d'enjeux avec bz et que les prix sont ok.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "mettre en pla cyber SAT, vendu copilot. Trouvait pas ça wow. Talamus formation envoyée. | intérêt pour SAT. Mel doit monter un ODS SAT. Client revient de vacances. Intérêt pour intégrer IA à planifier plus tard à la demande du client. Client bon contact chez Microâge mais me dit qu'il n'a pas d'enjeux avec bz et que les prix sont ok.",
    "comments": "Beau diner. Automatisation télécom en cours. Intérêt SAT en cours. | Départements: TI, Telecom",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: intérêt pour SAT. Mel doit monter un ODS SAT. Client revient de vacances. Intérêt pour intégrer IA à planifier plus tard à la demande du client. Client bon contact chez Microâge mais me dit qu'il n'a pas d'enjeux avec bz et que les prix sont ok.. Relation: Good. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 18,
    "ddcActive": true
  },
  {
    "clientName": "CPE aux deux Pignons",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne. Prime vendeur: 9. Risque de perte: 3.",
    "recommendedAngle": "cyber/Sat",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "cyber/Sat",
    "comments": "Belle proximité de confiance. Attaquer télécom | Départements: TI | Valeur contrats: 1006.93 | Rentabilité: Moyen (195 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Moyenne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: cyber/Sat. Relation: Bonne. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 19,
    "ddcActive": true
  },
  {
    "clientName": "CPE des Cantons de Riviere-Du-Loup",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Très bonne. Prime vendeur: 9. Risque de perte: 3.",
    "recommendedAngle": "avait de l'intérêt poiurCopilot mais manque de budget.Attaquer cyber",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "enjeux de budget. Créer adresse éducatrice pour les 50 éduc. Travaillent en perso. Soumission 5 token en cours | avait de l'intérêt poiurCopilot mais manque de budget.Attaquer cyber",
    "comments": "Confiance installée, ménage licences fait, | Départements: TI | Valeur contrats: 471.35 | Rentabilité: Rentable (533 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: avait de l'intérêt poiurCopilot mais manque de budget.Attaquer cyber. Relation: Très bonne. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 20,
    "ddcActive": true
  },
  {
    "clientName": "CPE La découverte",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, nouvelle DG peureuse et craintive mais je me tiens proche.. Dit qu'on est cher. On a limité les couts dernièrement. Prime vendeur: 9. Risque de perte: 4.",
    "recommendedAngle": "Fermer serveur physique et passer dans le cloud. Parler de SAT. Attaquer télécom",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Budget restreint | Fermer serveur physique et passer dans le cloud. Parler de SAT. Attaquer télécom",
    "comments": "Viennent de signer Cloud BZ, fermeture du serveur local. Nouvelle DG | Départements: TI | Valeur contrats: 535.2 | Rentabilité: Moyen (186 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: Fermer serveur physique et passer dans le cloud. Parler de SAT. Attaquer télécom. Relation: Bonne, nouvelle DG peureuse et craintive mais je me tiens proche.. Dit qu'on est cher. On a limité les couts dernièrement. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 21,
    "ddcActive": true
  },
  {
    "clientName": "CPE La petite grenouille",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 22,
    "ddcActive": true
  },
  {
    "clientName": "CPE Mille Fleurs Inc",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: bonne mais enjeux de budget. Me dit qu'ils magasinent ailleurs. Prime vendeur: 9. Risque de perte: 5.",
    "recommendedAngle": "Remplacer switch avant que tout pète. Je ne pense pas arriver à vendre de cyber ni de prog chez ce client. Je ne force pas",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "budget restreint. Switch à changer | Remplacer switch avant que tout pète. Je ne pense pas arriver à vendre de cyber ni de prog chez ce client. Je ne force pas",
    "comments": "Enjeux budget.Mel connait bien l'adjointe dir. Maman hockey. Switch à changer. Télécom oui | Départements: TI, télécom | Valeur contrats: 504.26 | Rentabilité: Rentable (238 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: Remplacer switch avant que tout pète. Je ne pense pas arriver à vendre de cyber ni de prog chez ce client. Je ne force pas. Relation: bonne mais enjeux de budget. Me dit qu'ils magasinent ailleurs. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 23,
    "ddcActive": true
  },
  {
    "clientName": "CQ3E",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: pas été facile au début mais confiance établie. Prime vendeur: 7. Risque de perte: 4.",
    "recommendedAngle": "télécom-cyber-ia",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "télécom-cyber-ia",
    "comments": "client pas facile mais confiance établie, ménage licence fait | Départements: TI | Valeur contrats: 341.39 | Rentabilité: Rentable (254 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: télécom-cyber-ia. Relation: pas été facile au début mais confiance établie. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 24,
    "ddcActive": true
  },
  {
    "clientName": "Dubé et Associés",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: diner planifié- connais pas encore. Prime vendeur: 7. Risque de perte: 2.",
    "recommendedAngle": "à voir",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "à voir",
    "comments": "renou à faire, à relancer. Diner planifié | Départements: Ti,telecom | Valeur contrats: 779.46 | Rentabilité: Rentable (347 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Moyenne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à voir. Relation: diner planifié- connais pas encore. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 25,
    "ddcActive": true
  },
  {
    "clientName": "E3 Électricité",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Bien, confiance. Prime vendeur: 8. Risque de perte: 3.",
    "recommendedAngle": "Cyber/IA. Automatisation. Grosse organisation, 47 Copilot",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Cyber/IA. Automatisation. Grosse organisation, 47 Copilot",
    "comments": "proprio frère du chum à ma cousine. Pas demandant , satisfait | Départements: ti,telecom | Valeur contrats: 698.95 | Rentabilité: Rentable (397 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: Cyber/IA. Automatisation. Grosse organisation, 47 Copilot. Relation: Bien, confiance. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 26,
    "ddcActive": true
  },
  {
    "clientName": "Exactus",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "changement DDC, content. Ménage licence fait. Débarasser serveur local. Hacké en mai. Projet cyber en cours",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 27,
    "ddcActive": true
  },
  {
    "clientName": "Exactus, avocats d'affaires inc.",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: très bien. Prime vendeur: 8. Risque de perte: 3.",
    "recommendedAngle": "cyber, IA",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Se sont fait hacké- rencontre planifiée | cyber, IA",
    "comments": "changement DDC, content. Ménage licence fait. Débarasser serveur local. Hacké en mai. Projet cyber en cours | Départements: TI,telecom | Valeur contrats: 1336.06 | Rentabilité: Rentable (374 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: cyber, IA. Relation: très bien. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 28,
    "ddcActive": true
  },
  {
    "clientName": "Eximm-Complexe de Ville inc.",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: bien. Prime vendeur: 8. Risque de perte: 3.",
    "recommendedAngle": "Client à relancer. Pas eu de retour de mon dernier message. ODS SAT en pending. Attaquer avec IA",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Client à relancer. Pas eu de retour de mon dernier message. ODS SAT en pending. Attaquer avec IA",
    "comments": "intérêt pour webinaire. Proposer SAT. En attente. Belle confiance | Départements: TI, Télécom | Valeur contrats: 2609.13 | Rentabilité: Rentable (421 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: Client à relancer. Pas eu de retour de mon dernier message. ODS SAT en pending. Attaquer avec IA. Relation: bien. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 29,
    "ddcActive": true
  },
  {
    "clientName": "FDJUL",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: excellente. Prime vendeur: 9. Risque de perte: 2.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "pas d'enjeux, confiance installée. Client stable mais pas de grandes opportunités | Départements: TI,telecom | Valeur contrats: 2125.29 | Rentabilité: Rentable (625 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: excellente. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 30,
    "ddcActive": true
  },
  {
    "clientName": "Fiducie Rockmont",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Discrète mais de confiance. À relancer cet automne pour changements internes. Prime vendeur: 8. Risque de perte: 3.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Projet d'Agrandissement en cours. Dans tunnel. A relancer. Attaquer Télécom | Départements: TI | Valeur contrats: 312.69 | Rentabilité: Rentable (421 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: Discrète mais de confiance. À relancer cet automne pour changements internes. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 31,
    "ddcActive": true
  },
  {
    "clientName": "Fédération des transporteurs par autobus",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "ODS télécom envoyée. À relancer. Bon niveau de confiance",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 32,
    "ddcActive": true
  },
  {
    "clientName": "Gallienne CPA",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: 9. Risque de perte: 2.",
    "recommendedAngle": "Cyber",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "conformité ordre CPA en cours/ loi 25/cyber | Cyber",
    "comments": "Proposer SAT, loi 25, nouveau client TI et télécom | Départements: TI, Télécom | Valeur contrats: 351.77 | Rentabilité: Faible (41 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: Cyber. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 33,
    "ddcActive": true
  },
  {
    "clientName": "Gestion Complan",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne complicité et bonne confiance. Prime vendeur: à valider. Risque de perte: 3.",
    "recommendedAngle": "AI, attaquer télécom, cyber et réussir a fixer rencontre IA avec Cargo architecte de leur propriété. Attaquer télécom aussi, SAT",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "vont vendre bientôt.Claude aimerait nous référer aux potentiels acheteurs | AI, attaquer télécom, cyber et réussir a fixer rencontre IA avec Cargo architecte de leur propriété. Attaquer télécom aussi, SAT",
    "comments": "Belle proximité, confiance. Lead à faire avec Cargo architectes. IA, Télécom. Vont vendre la bâtisse bientôt et me dit qu'ils vont référer à nous le potentiel acheteur | Départements: TI,telecom | Valeur contrats: 383.63 | Rentabilité: Faible (121 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: AI, attaquer télécom, cyber et réussir a fixer rencontre IA avec Cargo architecte de leur propriété. Attaquer télécom aussi, SAT. Relation: Bonne complicité et bonne confiance. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 34,
    "ddcActive": true
  },
  {
    "clientName": "Gestion de Patrimoine Normen Bouchard inc.",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Très bonne. Prime vendeur: 9. Risque de perte: 2.",
    "recommendedAngle": "cyber, attaquer IA",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "cyber, | cyber, attaquer IA",
    "comments": "Viennent de déménager. Changement forti, switch et possible fermeture du serveur local. Télécom oui | Départements: TI,telecom | Valeur contrats: 1142.51 | Rentabilité: Faible (96 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: cyber, attaquer IA. Relation: Très bonne. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 35,
    "ddcActive": true
  },
  {
    "clientName": "Gestock",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: excellente. Prime vendeur: 10. Risque de perte: 1.",
    "recommendedAngle": "cyber, télécom automatisation Fidélio, agent pour gestion courriel",
    "riskOrCondition": "Risque déclaré: 1. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Télécom insatisfait du fournisseur actuel, bug de facture- ods envoyées/relancer pour cyber et IA/automatisation. Travaillent avec Fidelio. Ils manquent de temps au quotidien | cyber, télécom automatisation Fidélio, agent pour gestion courriel",
    "comments": "Nouveau client . Ami de Mel et nouveau fournisseur articles coorpo. Opportunités de cyber, téléphonie, IA et prog. Utilisnet Fidelio | Départements: TI | Valeur contrats: 3335.7 | Rentabilité: Moyen (176 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: cyber, télécom automatisation Fidélio, agent pour gestion courriel. Relation: excellente. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 36,
    "ddcActive": true
  },
  {
    "clientName": "GFPD",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Nouvelle DG, Belle relation avec ancienne DG. Ods Sat et téléphonie en cours",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 37,
    "ddcActive": true
  },
  {
    "clientName": "Groupe Femmes, Politique et Démocratique",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Excellente mais changement DG, Joliette quitte. Prime vendeur: 9. Risque de perte: 3.",
    "recommendedAngle": "ODS sat envoyée, ODS telecom envoyée.Proposer IA mais pas tout de suite. Trop de changements",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "cybersécurité. Logiciel pour membres.Nous avons discuté de prog avec FM mais manque de budget | ODS sat envoyée, ODS telecom envoyée.Proposer IA mais pas tout de suite. Trop de changements",
    "comments": "Nouvelle DG, Belle relation avec ancienne DG. Ods Sat et téléphonie en cours. Se sont fait haché solide récemment | Départements: TI | Valeur contrats: 1293.3 | Rentabilité: Moyen (150 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: ODS sat envoyée, ODS telecom envoyée.Proposer IA mais pas tout de suite. Trop de changements. Relation: Excellente mais changement DG, Joliette quitte. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 38,
    "ddcActive": true
  },
  {
    "clientName": "Hickson Noonan Avocats",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: 8. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "attaqer télécom. Plus distante dernièrement | Départements: TI | Valeur contrats: 1206.58 | Rentabilité: Rentable (289 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 39,
    "ddcActive": true
  },
  {
    "clientName": "hkd",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 40,
    "ddcActive": true
  },
  {
    "clientName": "HKD Snowmakers",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Bonne mais client qui challenge bcp. Grateux. Glisse toujours sur nos recommandations. Prime vendeur: 8. Risque de perte: 4.",
    "recommendedAngle": "télécom. Attaquer IA. Prendre en charge les 10 users au USA en premium.",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "pas de sauvegardes, bcp de changements interne. Ne croit pas bcp aux automatisation, IA. À attaquer. Cout important config postes users USA | télécom. Attaquer IA. Prendre en charge les 10 users au USA en premium.",
    "comments": "Vienne d'acheter nouveua serveur avec BZ. Pas de garantie. Téléphonie pas encore. Contrat en cours. Toujours difficile, challenge, pas d'Argent mais bon lien de confiance. Vienne d'être racheté par grosse firme Italienne. Pas de départ bz à court terme | Départements: TI | Valeur contrats: 4469.14 | Rentabilité: Rentable (229 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: télécom. Attaquer IA. Prendre en charge les 10 users au USA en premium.. Relation: Bonne mais client qui challenge bcp. Grateux. Glisse toujours sur nos recommandations. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 41,
    "ddcActive": true
  },
  {
    "clientName": "Icosa",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Bien, client téteux un peu. Transparent. Prime vendeur: 9. Risque de perte: 3.",
    "recommendedAngle": "attaquer télécom et sat. Gars très techno. Attaquer IA plus tard",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "rien pour le moment | attaquer télécom et sat. Gars très techno. Attaquer IA plus tard",
    "comments": "Nouveau client. Peut être déménagement à prévoir. Entreprise grandissante. Vient d'acheter une tour station en guise de serveur | Départements: TI | Valeur contrats: 404.48 | Rentabilité: Faible (14 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: attaquer télécom et sat. Gars très techno. Attaquer IA plus tard. Relation: Bien, client téteux un peu. Transparent. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 42,
    "ddcActive": true
  },
  {
    "clientName": "Idéal en Gros/ Wholesale.inc",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: 8. Risque de perte: 3.",
    "recommendedAngle": "Cyber-Téléphonie",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "système téléphonique désuet et non automatisé | Cyber-Téléphonie",
    "comments": "attaue t`l`com à relancer. Beau lien de confiance. Pas exigeant | Valeur contrats: 990.92",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: Cyber-Téléphonie. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 43,
    "ddcActive": true
  },
  {
    "clientName": "Joan Matheson CPA inc",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: elle aime bcp bz. Prime vendeur: 9. Risque de perte: 2.",
    "recommendedAngle": "Déménagement- forti, sécurité réseau",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Déménage dans nouveux bureau- besoin d'un forti- cablâge? | Déménagement- forti, sécurité réseau",
    "comments": "Déménage dans nouveua bureau. Projet préretraite. Aura besoin d'un Forti. Aucun enjeux. Très belle relation | Départements: TI,telecom | Valeur contrats: 501.03 | Rentabilité: Rentable (363 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: Déménagement- forti, sécurité réseau. Relation: elle aime bcp bz. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 44,
    "ddcActive": true
  },
  {
    "clientName": "La Maison des Femmes de Québec",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne. Prime vendeur: 8. Risque de perte: à valider.",
    "recommendedAngle": "attaquer télécom, cyber",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "attaquer télécom, cyber",
    "comments": "Pasd'enjeux. Client satisfait et pas demandant | Départements: TI | Valeur contrats: 843.15 | Rentabilité: Rentable (335 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Moyenne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: attaquer télécom, cyber. Relation: Bonne. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 45,
    "ddcActive": true
  },
  {
    "clientName": "La Seigneurie Coopérative Funéraire",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: excellente, confiance. Prime vendeur: 9. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Belle rencontre!- ajout Copilot- septembre pour SAT | Départements: TI,telecom | Valeur contrats: 2156.22 | Rentabilité: Rentable (702 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: excellente, confiance. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 46,
    "ddcActive": true
  },
  {
    "clientName": "Laforest Avocats",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: bonne transparente, mais insatisfaite car manque toujours de temps, retours difficiles. On instaure les comités TI. Prime vendeur: 8. Risque de perte: 3.",
    "recommendedAngle": "Très bonne candidate pour agents IA",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "manque de temps. Bug télécom avec répertoire. Ne donne pas suite à steven. Son # de fax est encore inactif. Pas de retour du fournisseur externe | Très bonne candidate pour agents IA",
    "comments": "nouveau client TI et télécom. Instauration plan directeur et comité TI pour meilleure comm. Prospect IA.clietne insatisfaite masi manque de temps. Réunion planifiée avec FM. Nouveau directeur TI | Départements: TI,telecom | Valeur contrats: 1604.62 | Rentabilité: Moyen (171 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: Très bonne candidate pour agents IA. Relation: bonne transparente, mais insatisfaite car manque toujours de temps, retours difficiles. On instaure les comités TI. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 47,
    "ddcActive": true
  },
  {
    "clientName": "Lamco Société en commandite",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: 3. Risque de perte: 9.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 9. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Départements: TI | Valeur contrats: 800.13 | Rentabilité: Rentable (831 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Élevé",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 48,
    "ddcActive": true
  },
  {
    "clientName": "Le Cosmos",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: 9. Risque de perte: 2.",
    "recommendedAngle": "travailler pour les avoir en TI mais ils sont pauvres",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Sauvegardes qnap journalières. Pas de budget. Pas d'intérêt pour la cyber en ce moment. Nouveau projet à l'UL. Proche du client | travailler pour les avoir en TI mais ils sont pauvres",
    "comments": "Bosn amis. Pas d'enjeux. Attaque TI. Pas de budget | Départements: Télécom",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: travailler pour les avoir en TI mais ils sont pauvres. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 49,
    "ddcActive": true
  },
  {
    "clientName": "Le Versant du Nord",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "ami,Prospect un peu pauvre/Pas en M365 encore",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 50,
    "ddcActive": true
  },
  {
    "clientName": "Les céramiques Bonamigo inc.",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Prospect TI",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 51,
    "ddcActive": true
  },
  {
    "clientName": "Maison des ainées- voisin du CPE",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 52,
    "ddcActive": true
  },
  {
    "clientName": "Maison des jeunes de Valleyfield",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Mort",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 53,
    "ddcActive": true
  },
  {
    "clientName": "Marotech",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: moyen, connait pas tant mais j'ai vendu du cloud et on ferme le serveur local. Prime vendeur: 3. Risque de perte: 3.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Viennent de fermer serveur local pour BZ cloud | Départements: TI | Valeur contrats: 2153.34 | Rentabilité: Rentable (255 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: moyen, connait pas tant mais j'ai vendu du cloud et on ferme le serveur local. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 55,
    "ddcActive": true
  },
  {
    "clientName": "Michaud LeBel S.E.N.C.R.L",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Très bonne. Échange en cours sur clause contrat challenge. Prime vendeur: 9. Risque de perte: 3.",
    "recommendedAngle": "Intérêt pou ragent IA/prog pour automatiser et sauver du temps. Rencontre planifiée avec dudu",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Engagé télécom jusqu'en 2030. contrat renou pas signé. | Intérêt pou ragent IA/prog pour automatiser et sauver du temps. Rencontre planifiée avec dudu",
    "comments": "Viennent de renou TI/intérêt SAT et rencontre IA. Prévue | Départements: TI | Valeur contrats: 1953.12 | Rentabilité: Moyen (151 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: Intérêt pou ragent IA/prog pour automatiser et sauver du temps. Rencontre planifiée avec dudu. Relation: Très bonne. Échange en cours sur clause contrat challenge. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 56,
    "ddcActive": true
  },
  {
    "clientName": "Monde des bières",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "à relancer",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 57,
    "ddcActive": true
  },
  {
    "clientName": "Mory inc.",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: excellente. Confiance. Prime vendeur: 9. Risque de perte: 2.",
    "recommendedAngle": "signatures contrat, enjeux clauses",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Ont déjà été client télécom . À relancer | signatures contrat, enjeux clauses",
    "comments": "Vienne de renouveller TI. Vendu un bot et probablement d'autres. Grand intérêt à automatiser | Départements: TI, Cyber,IA | Valeur contrats: 2326.56 | Rentabilité: Rentable (342 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: signatures contrat, enjeux clauses. Relation: excellente. Confiance. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 58,
    "ddcActive": true
  },
  {
    "clientName": "MRC de l'Islet",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Planifier diner avec Brenda pour plan de match pour attaquer les muni et tasser les mrc des muni dans l agestion des TI",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 59,
    "ddcActive": true
  },
  {
    "clientName": "Municipalité de Saint-Jean-de-l’île-d’Orléans",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: 8. Risque de perte: 2.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Valeur contrats: 1024.51",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 60,
    "ddcActive": true
  },
  {
    "clientName": "Municipalité de Saint-Laurent-de-l'Île-d'orléans",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: 8. Risque de perte: 2.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Départements: TI, télécom | Valeur contrats: 1174.79 | Rentabilité: Rentable (309 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 61,
    "ddcActive": true
  },
  {
    "clientName": "Oxygaz",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: 8. Risque de perte: 3.",
    "recommendedAngle": "téléphonie- cyber",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Intérêt pour téléphonie mais doit garder son fax physique. Ont éét hacké avant | téléphonie- cyber",
    "comments": "Nouveau client TI. Sympa mais pas souvent dispo | Départements: TI | Valeur contrats: 1262.95 | Rentabilité: Moyen (155 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: téléphonie- cyber. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 62,
    "ddcActive": true
  },
  {
    "clientName": "P.E. Pageau",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Très bonne relationde confiance. Prime vendeur: à valider. Risque de perte: 2.",
    "recommendedAngle": "fermer serveur et passer dans le cloud mais régler souci légal FTP",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Clietn travaille avec IA avec ? À attaquer avec nos agent mais sa solution est plus économique et il se débrouille lui-même. à relancer et rester proche | fermer serveur et passer dans le cloud mais régler souci légal FTP",
    "comments": "ils fermes leur serveur et s'en viennent dans le cloud | Départements: TI | Valeur contrats: 1968.3 | Rentabilité: Rentable (205 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: fermer serveur et passer dans le cloud mais régler souci légal FTP. Relation: Très bonne relationde confiance. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 63,
    "ddcActive": true
  },
  {
    "clientName": "PE Pageau",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 64,
    "ddcActive": true
  },
  {
    "clientName": "PG Arpentage",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bien!. Prime vendeur: à valider. Risque de perte: 3.",
    "recommendedAngle": "Enjeux d'employés. Besoin d'automatiser appels réception. Référé à Dudu qui réfère à Carrier. Je dois reparler aux gars et attaquer client avec agent I.A",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Enjeux d'employés. Besoin d'automatiser appels réception. Référé à Dudu qui réfère à Carrier. Je dois reparler aux gars et attaquer client avec agent I.A",
    "comments": "Nouveau client télécom. Ne pas attaquer TI. Référé à nous par Adocrat. Attaquer sa deuxième compagnie en ontario une fois lien de confiance bien établi",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Moyenne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: Enjeux d'employés. Besoin d'automatiser appels réception. Référé à Dudu qui réfère à Carrier. Je dois reparler aux gars et attaquer client avec agent I.A. Relation: Bien!. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 65,
    "ddcActive": true
  },
  {
    "clientName": "PMA Architectes",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Very good!Vendu 2 bots Implantation du comité TI et plan directeur en cours.. Prime vendeur: 8. Risque de perte: 1.",
    "recommendedAngle": "instaurer 2 bot- ajouter agents pour les architectes- vendre sat. Rentrer télécom mais sont engagé pour 5 ans",
    "riskOrCondition": "Risque déclaré: 1. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "pas de cyber- enjeux avec gestion boite projet et Pierre. Achchivage, projet IA en cours | instaurer 2 bot- ajouter agents pour les architectes- vendre sat. Rentrer télécom mais sont engagé pour 5 ans",
    "comments": "Départements: TI | Valeur contrats: 4108.38 | Rentabilité: Rentable (284 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: instaurer 2 bot- ajouter agents pour les architectes- vendre sat. Rentrer télécom mais sont engagé pour 5 ans. Relation: Very good!Vendu 2 bots Implantation du comité TI et plan directeur en cours.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 66,
    "ddcActive": true
  },
  {
    "clientName": "Pompe MC",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 67,
    "ddcActive": true
  },
  {
    "clientName": "Produits Capital",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Départements: TI | Valeur contrats: 1673.04 | Rentabilité: Rentable (874 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 68,
    "ddcActive": true
  },
  {
    "clientName": "Produits de Pâtisserie Michaud inc.",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: était supervbe avec brenda, bien avec Sophie. Dernièrement c'est Mario le pres. Qui semble avoir prit en charge certains dossiers. Prime vendeur: 8. Risque de perte: 2.",
    "recommendedAngle": "signer ODS cyber",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "manque de ressources à l'interne. Ont l'air débordé | signer ODS cyber",
    "comments": "Départements: TI,telecom | Valeur contrats: 2539.37 | Rentabilité: Faible (122 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: signer ODS cyber. Relation: était supervbe avec brenda, bien avec Sophie. Dernièrement c'est Mario le pres. Qui semble avoir prit en charge certains dossiers. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 69,
    "ddcActive": true
  },
  {
    "clientName": "Prostho-Québec - Dr Nancy Dubois",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Départements: TI | Valeur contrats: 1968.34 | Rentabilité: Rentable (443 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 70,
    "ddcActive": true
  },
  {
    "clientName": "Pâtisserie Michaud",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: excellente avec Brenda, contacter DG pour instaurer comité ti. Prime vendeur: 8. Risque de perte: 2.",
    "recommendedAngle": "signer Sat, proposer dir. Ti, plan dir.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "enjeux de staffs? Belinda pas bonne comme brenda. TI laissé allé. Proposer dir Ti | signer Sat, proposer dir. Ti, plan dir.",
    "comments": "Brenda a quitté. Enjeux de staff au TI. J'ai demandé à EH de mettre en planc tech prime pour les aider. Je me tiens proche. | Départements: TI",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: signer Sat, proposer dir. Ti, plan dir.. Relation: excellente avec Brenda, contacter DG pour instaurer comité ti. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 71,
    "ddcActive": true
  },
  {
    "clientName": "rampe Gardex",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 72,
    "ddcActive": true
  },
  {
    "clientName": "Rampes Gardex",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Était très bonne avec Eric et Suzanne. Bonne avec nouveuax DG mais ont un peu tassé bz pour la prog. Rester proche. Proposé intégration plan Dir.+ plan budget. Refusé. Préfère des rencontre au besoin. Prime vendeur: 8. Risque de perte: 4.",
    "recommendedAngle": "arriver à collaborer avec eux pour automatiser- entrer IA- convaincre de mettre en place plan directeur- comité TI. Garder le client et présenter prisme. Client dans le jus",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "doit payer 3 mensu de 500$ pour résilition projet prog du stagiaire. Offert de réinvestir en agent, refusé pour le moment. Planifier rencontre pour Prisme. Client pas fermé | arriver à collaborer avec eux pour automatiser- entrer IA- convaincre de mettre en place plan directeur- comité TI. Garder le client et présenter prisme. Client dans le jus",
    "comments": "Gardez vendu. Proche du nouveau DG. Implante power automate mais a tassé bz bien qu'Mil demande conseil. Pas prêt à un agent. A mis fin au projet de prog du stagiaire et recommence à zéro de son bord | Départements: TI | Valeur contrats: 2962.88 | Rentabilité: Rentable (214 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: arriver à collaborer avec eux pour automatiser- entrer IA- convaincre de mettre en place plan directeur- comité TI. Garder le client et présenter prisme. Client dans le jus. Relation: Était très bonne avec Eric et Suzanne. Bonne avec nouveuax DG mais ont un peu tassé bz pour la prog. Rester proche. Proposé intégration plan Dir.+ plan budget. Refusé. Préfère des rencontre au besoin. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 73,
    "ddcActive": true
  },
  {
    "clientName": "SERQ",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 74,
    "ddcActive": true
  },
  {
    "clientName": "Services agricoles Létourneau inc.",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Antoine Letourno chialeux mais belle relation. Diner planifié cet été. Prime vendeur: à valider. Risque de perte: 2.",
    "recommendedAngle": "diner planifié- à suivre",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "diner planifié- à suivre",
    "comments": "Diner planifié | Départements: TI | Valeur contrats: 2446.27 | Rentabilité: Rentable (3850 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Moyenne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: diner planifié- à suivre. Relation: Antoine Letourno chialeux mais belle relation. Diner planifié cet été. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 75,
    "ddcActive": true
  },
  {
    "clientName": "Société de développement économique du Saint-Laurent",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bien mais discret. Sera à contacter. Prime vendeur: 8. Risque de perte: 4.",
    "recommendedAngle": "?",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "? | ?",
    "comments": "Départements: TI | Valeur contrats: 780.42 | Rentabilité: Rentable (304 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: ?. Relation: Bien mais discret. Sera à contacter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 76,
    "ddcActive": true
  },
  {
    "clientName": "Syndicat de l'enseignement de la région de Québec",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Très bonne mais cliente diffficile, pas rentable, vieillissante.. Prime vendeur: 9. Risque de perte: 2.",
    "recommendedAngle": "Fermer serveur et s'en venir dans le cloud. Téléphonie",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Serveru à changer- pare feu dernière année, veut venir en télécom chez nous, rencontre planifiée.Pas de budget | Fermer serveur et s'en venir dans le cloud. Téléphonie",
    "comments": "Sacrée Nathalie. Tire bcp de jus. Pas très rentable. Serveur vieux. On travaille pour les mettre dans le cloud. Intérêt pour téléphonie quand arrive à échéance. Rencontre planifiée | Départements: TI | Valeur contrats: 3098.79 | Rentabilité: Faible (92 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: Fermer serveur et s'en venir dans le cloud. Téléphonie. Relation: Très bonne mais cliente diffficile, pas rentable, vieillissante.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 77,
    "ddcActive": true
  },
  {
    "clientName": "Séminaire de Québec",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Très bonne avec Jérome et M. Cantin. Prime vendeur: 9. Risque de perte: 2.",
    "recommendedAngle": "Vieux système téléphonique mais mon ODS est plus que le double. Pending avant que tout pète. Forti va être à remplacer en 2026. Réduire dépense annuelle de 14k en cartouche d'encre!",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Vieux système téléphonique mais mon ODS est plus que le double. Pending avant que tout pète. Forti va être à remplacer en 2026. Réduire dépense annuelle de 14k en cartouche d'encre!",
    "comments": "Fait plan directeur. Prog en cours et 3 ième phase planifiée. Formation loi 25 fait. Attaquer le petit séminaire avec support ti et premium | Départements: TI, Cyber.prog | Valeur contrats: 3964.84 | Rentabilité: Moyen (156 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Moyenne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: Vieux système téléphonique mais mon ODS est plus que le double. Pending avant que tout pète. Forti va être à remplacer en 2026. Réduire dépense annuelle de 14k en cartouche d'encre!. Relation: Très bonne avec Jérome et M. Cantin. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 78,
    "ddcActive": true
  },
  {
    "clientName": "Verdon",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Très bonne avec Sophie. Je dois la relancer pour télécom et planifier rencontre pour agent IA. Sophie trippe sur Copilot!|. Prime vendeur: 9. Risque de perte: 2.",
    "recommendedAngle": "IA-Télécom-programmation",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "automatisation | IA-Télécom-programmation",
    "comments": "Bonne relantion de confiance. Attaquer Télécom. Sophie intérêt et attaquer pour agent IA | Départements: Ti",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: IA-Télécom-programmation. Relation: Très bonne avec Sophie. Je dois la relancer pour télécom et planifier rencontre pour agent IA. Sophie trippe sur Copilot!|. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 79,
    "ddcActive": true
  },
  {
    "clientName": "Ville de Baie-Saint-Paul",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 80,
    "ddcActive": true
  },
  {
    "clientName": "Externat St-Jean-Berchmans",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne mais pas d'Mooprtunité ti à cours terme. Viennent de renouveler.Client cyber qui arrivent à échéance. Relancer dg l'école est finie. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Relancer téléphonie- relancer cyber",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Relancer téléphonie- relancer cyber",
    "comments": "Ont un tech interne vieillissant. Vieux système téléphonique qui sera à changer. Ods télécom envoyée | Départements: Cyber | Valeur contrats: 333.32",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: Relancer téléphonie- relancer cyber. Relation: Bonne mais pas d'Mooprtunité ti à cours terme. Viennent de renouveler.Client cyber qui arrivent à échéance. Relancer dg l'école est finie. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 81,
    "ddcActive": true
  },
  {
    "clientName": "Municipalité de Scott. Beauce",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Départements: Ti, SAT",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 83,
    "ddcActive": true
  },
  {
    "clientName": "Municipalité de Amqui",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Départements: TI, SAT",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 85,
    "ddcActive": true
  },
  {
    "clientName": "Municipalité de ST-Joseph de Lepage",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Départements: Ti, SAT",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 87,
    "ddcActive": true
  },
  {
    "clientName": "76:7681:88H4181:8882:8883:8882:88",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 88,
    "ddcActive": true
  },
  {
    "clientName": "Cargo architecte",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Associcé de Complan.",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 89,
    "ddcActive": true
  },
  {
    "clientName": "#VALUE!",
    "accountManager": "Mélissa Morency",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: #VALUE!. Prime vendeur: #VALUE!. Risque de perte: #VALUE!.",
    "recommendedAngle": "#VALUE!",
    "riskOrCondition": "Risque déclaré: #VALUE!. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "#VALUE! | #VALUE!",
    "comments": "#VALUE! | Départements: #VALUE! | Valeur contrats: #VALUE! | Rentabilité: #VALUE!",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Mélissa Morency). Priorités/enjeux: #VALUE!. Relation: #VALUE!. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Mélissa Morency",
    "sourceRow": 104,
    "ddcActive": true
  },
  {
    "clientName": "10e Ave Productions Inc.",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, réactif quand ils ont des demandes donc apprécié de leur part. Le renouvellement s'est fait rapidement, pas d'enjeu sur le prix. Prime vendeur: 6. Risque de perte: 3.",
    "recommendedAngle": "Roulement de personnel selon les phases, IA éthique sans toucher à la portion créativité",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Roulement de personnel selon les phases, IA éthique sans toucher à la portion créativité",
    "comments": "On et off selon les rush de productions. Parfois plusieurs demandes en pe de temps, ça se calme ensuite. Ne veulent pas que l'IA embarque dans leur processus créatif, sont \"ok\" avec la portion administrative. Déjà avec Copilot pour plusieurs utilisateurs | Départements: TI | Valeur contrats: 2890.16 | Rentabilité: Faible (122 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Moyenne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Roulement de personnel selon les phases, IA éthique sans toucher à la portion créativité. Relation: Bonne, réactif quand ils ont des demandes donc apprécié de leur part. Le renouvellement s'est fait rapidement, pas d'enjeu sur le prix. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 2,
    "ddcActive": true
  },
  {
    "clientName": "9443-4347 Québec inc.",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: Inexistant. Prime vendeur: 1. Risque de perte: 9.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 9. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Départements: TI | Valeur contrats: 563.92 | Rentabilité: Rentable (1088 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Élevé",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: Inexistant. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 3,
    "ddcActive": true
  },
  {
    "clientName": "Alveo Dentaire",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: /. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Prospect",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: /. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 4,
    "ddcActive": true
  },
  {
    "clientName": "Archer",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, comité TI en place. Satisfait des avancées mais veut toujours aller plus vite. Prime vendeur: 7. Risque de perte: 3.",
    "recommendedAngle": "Migration vers SharePoint, adoption du cloud, amélioration de la conformité Loi 25, documentation des procédures TI. Voir directeur TI / PRIsME.",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Modernisation de l’environnement TI, réduction de la dépendance aux serveurs locaux, amélioration de la cybersécurité, conformité Loi 25, structuration de la gouvernance TI. Voir directeur TI / PRIsME | Migration vers SharePoint, adoption du cloud, amélioration de la conformité Loi 25, documentation des procédures TI. Voir directeur TI / PRIsME.",
    "comments": "Client qui a le potentiel d'embarquer dans l'IA. Mais, des gens des \"pros\" qui veulent sentir l'expertise avant de dire \"oui\" | Départements: TI | Valeur contrats: 7331.09 | Rentabilité: Rentable (387 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Migration vers SharePoint, adoption du cloud, amélioration de la conformité Loi 25, documentation des procédures TI. Voir directeur TI / PRIsME.. Relation: Bonne, comité TI en place. Satisfait des avancées mais veut toujours aller plus vite. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 5,
    "ddcActive": true
  },
  {
    "clientName": "Association de la Construction du Québec",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Excellente. Partenaire de choix. Prime vendeur: 10. Risque de perte: 2.",
    "recommendedAngle": "Optimisation des processus, faciliter la vie aux membres",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Optimisation des processus, faciliter la vie aux membres",
    "comments": "Moyen limité, mais les gens en place veulent accélérer leurs processus. Implantation d'un nouvel ERP à l'été 2026 | Départements: TI, Cyber | Valeur contrats: 1335.46 | Rentabilité: Faible (58 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Moyenne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Optimisation des processus, faciliter la vie aux membres. Relation: Excellente. Partenaire de choix. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 6,
    "ddcActive": true
  },
  {
    "clientName": "Assurance Mutuelle des Fabriques de Québec",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: DDC depuis peu, mais embarqué dans PRIsME et confiance forte envers BZ. Relation sympathique. Prime vendeur: 2. Risque de perte: 2.",
    "recommendedAngle": "Voir directeur TI / PRISME",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Voir directeur TI / PRISME | Voir directeur TI / PRISME",
    "comments": "Déjà dans PRIsME avec Éric Hains comme directeur TI | Départements: TI, Cyber, Télécom | Valeur contrats: 2984.75 | Rentabilité: Rentable (221 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Voir directeur TI / PRISME. Relation: DDC depuis peu, mais embarqué dans PRIsME et confiance forte envers BZ. Relation sympathique. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 7,
    "ddcActive": true
  },
  {
    "clientName": "Assurances Michel Bertrand & Associés",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne. Communication rare, mais toujours cordiale. Ils sont satisfaits des services. Prime vendeur: 5. Risque de perte: 5.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Intérêt léger pour Copilot, donc on peut projeter plus | Départements: TI | Valeur contrats: 1114.16 | Rentabilité: Moyen (161 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: Bonne. Communication rare, mais toujours cordiale. Ils sont satisfaits des services. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 8,
    "ddcActive": true
  },
  {
    "clientName": "Beau site Excavation",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: Aucune. Prime vendeur: 1. Risque de perte: 5.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Départements: TI | Valeur contrats: 1087.05 | Rentabilité: Rentable (507 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: Aucune. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 9,
    "ddcActive": true
  },
  {
    "clientName": "Beaudin Groupe Conseil inc.",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: Aucune. Prime vendeur: 1. Risque de perte: 5.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Départements: TI | Valeur contrats: 442.34 | Rentabilité: Rentable (804 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: Aucune. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 10,
    "ddcActive": true
  },
  {
    "clientName": "Buffet St-Emile",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: Acheté par Équilibre Traiteur, ne pas considérer. Prime vendeur: /. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Acheté par Équilibre Traiteur, ne pas considérer | Départements: TI | Valeur contrats: 1058.77 | Rentabilité: Rentable (280 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: Acheté par Équilibre Traiteur, ne pas considérer. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 11,
    "ddcActive": true
  },
  {
    "clientName": "Caramels FAA",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Ça semble en selle avec la nouvelle direction. Leurs dernières demandes ont passé par moi, ils semblent satisfaits. Prime vendeur: 7. Risque de perte: 7.",
    "recommendedAngle": "Limiter les coûts, efficacité M365",
    "riskOrCondition": "Risque déclaré: 7. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "S'ajuster suite à une nouvelle direction | Limiter les coûts, efficacité M365",
    "comments": "Changement de direction, Se questionne sur le prix \"élevé\" de BZ (vs leurs besoins). | Départements: TI | Valeur contrats: 788.73 | Rentabilité: Rentable (266 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Limiter les coûts, efficacité M365. Relation: Ça semble en selle avec la nouvelle direction. Leurs dernières demandes ont passé par moi, ils semblent satisfaits. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 12,
    "ddcActive": true
  },
  {
    "clientName": "Centre des glaces",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: /. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Prospect",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: /. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 13,
    "ddcActive": true
  },
  {
    "clientName": "Chemco inc.",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: /. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Prospect",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: /. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 14,
    "ddcActive": true
  },
  {
    "clientName": "CHUK FM",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Moyen. Les travaux trainent en longueur et la satisfaction est moyenne. Prime vendeur: 8. Risque de perte: 7.",
    "recommendedAngle": "Changer les postes critiques, Changer le serveur, mettre en place un tenant M365",
    "riskOrCondition": "Risque déclaré: 7. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Budget, Infrastructure très désuète, gestion des projets de subvention | Changer les postes critiques, Changer le serveur, mettre en place un tenant M365",
    "comments": "Peu de moyen. Espère des subventions pour faire progresser leur infra et leurs processus | Valeur contrats: 817.72",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Changer les postes critiques, Changer le serveur, mettre en place un tenant M365. Relation: Moyen. Les travaux trainent en longueur et la satisfaction est moyenne. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 15,
    "ddcActive": true
  },
  {
    "clientName": "Compro Communications",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Très bonne. Référenceur. Prime vendeur: 9. Risque de perte: 3.",
    "recommendedAngle": "Application pour la rédaction, Garder le \"contrôle\" sur les messages produits malgré la téléphonie IP",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Rester \"pertinent\" à l'ère de l'IA, se distinguer, trouver de nouvelles façons d'optmimiser le travail | Application pour la rédaction, Garder le \"contrôle\" sur les messages produits malgré la téléphonie IP",
    "comments": "Déjà en programmation/IA avec BZ. Partenaire | Départements: TI | Valeur contrats: 2057.78 | Rentabilité: Faible (106 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Application pour la rédaction, Garder le \"contrôle\" sur les messages produits malgré la téléphonie IP. Relation: Très bonne. Référenceur. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 16,
    "ddcActive": true
  },
  {
    "clientName": "Compta DS inc.",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: Presque inexsitant. Pas d'intérêt envers la technologie, se garde au minimum. Prime vendeur: 2. Risque de perte: 7.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 7. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Peu intéressée à l'IA, mais l'automatisation des tâches pourrait la faire changer d'idée | Départements: TI | Valeur contrats: 428.47 | Rentabilité: Rentable (302 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: Presque inexsitant. Pas d'intérêt envers la technologie, se garde au minimum. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 17,
    "ddcActive": true
  },
  {
    "clientName": "Conrad Dussault",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: Peu de contacts. Prime vendeur: 2. Risque de perte: 5.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Départements: TI | Valeur contrats: 442.72 | Rentabilité: Rentable (392 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: Peu de contacts. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 18,
    "ddcActive": true
  },
  {
    "clientName": "Consortium de recherche et d’innovation en bioprocédés industriels au Québec",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Très bonne relation. Avec BZ depuis peu, mais les dossiers ont été bien gérés avec eux. Leur retour est toujours positif. Prime vendeur: 8. Risque de perte: 4.",
    "recommendedAngle": "Nouveau client, à voir",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Nouveau client, à voir | Nouveau client, à voir",
    "comments": "Aime beaucoup les méta-données. Client avec un potentiel à aimer la structure et l'automatisation | Départements: TI, Cyber | Valeur contrats: 1211.31 | Rentabilité: Faible (44 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Nouveau client, à voir. Relation: Très bonne relation. Avec BZ depuis peu, mais les dossiers ont été bien gérés avec eux. Leur retour est toujours positif. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 19,
    "ddcActive": true
  },
  {
    "clientName": "Construction LFG",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Prospect (Loi 25 seulement. Prime vendeur: /. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: Prospect (Loi 25 seulement. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 20,
    "ddcActive": true
  },
  {
    "clientName": "Construction Stoïk Design",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne relation humaine, mais relation d'affaire plus difficile. Paiements longs, peu de feedback de leur côté. Prime vendeur: 7. Risque de perte: 8.",
    "recommendedAngle": "S'assurer que les adresses courriel sont toutes fonctionnelles",
    "riskOrCondition": "Risque déclaré: 8. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Budget, Faire plus avec moins | S'assurer que les adresses courriel sont toutes fonctionnelles",
    "comments": "Payeur peu fiable. Pas beaucoup de moyen. Situation familiale qui les empêchera de développer de nouveaux projets d'ici début 2027. | Valeur contrats: 294.02",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Élevé",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: S'assurer que les adresses courriel sont toutes fonctionnelles. Relation: Bonne relation humaine, mais relation d'affaire plus difficile. Paiements longs, peu de feedback de leur côté. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 21,
    "ddcActive": true
  },
  {
    "clientName": "Constructions Ensemble",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Bonne relation. Intérêt pour la TI faible, veulent seulement que \"ça fonctionne\". Très sympatiques. Prime vendeur: 6. Risque de perte: 5.",
    "recommendedAngle": "Nouveau client, à voir",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Nouveau client, à voir | Nouveau client, à voir",
    "comments": "Très gentils, veulent simplement que \"ça marche\". Peu de potentiel à l'IA | Départements: TI | Valeur contrats: 348.09 | Rentabilité: Faible (33 $/h)",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Nouveau client, à voir. Relation: Bonne relation. Intérêt pour la TI faible, veulent seulement que \"ça fonctionne\". Très sympatiques. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 22,
    "ddcActive": true
  },
  {
    "clientName": "Consultant SOCAM",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: /. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: /. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 23,
    "ddcActive": true
  },
  {
    "clientName": "CPE la Ribambelle",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Bonne. Serré côté budget, mais confiance envers BZ. Prime vendeur: 7. Risque de perte: 4.",
    "recommendedAngle": "Rotation des postes, Mettre en place une politique de cybersécurité pour gérer ce qui est fait par les employées",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Gérer le budget, Protection des données personnelles | Rotation des postes, Mettre en place une politique de cybersécurité pour gérer ce qui est fait par les employées",
    "comments": "Moyens très limités, chaque dollard dépensé est réfléchi. Questionnement de l'IA vs les informations personnelles des enfants sous leur garde. | Départements: TI | Valeur contrats: 1409.84 | Rentabilité: Rentable (279 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Rotation des postes, Mettre en place une politique de cybersécurité pour gérer ce qui est fait par les employées. Relation: Bonne. Serré côté budget, mais confiance envers BZ. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 24,
    "ddcActive": true
  },
  {
    "clientName": "CTAC",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Professionnelle. Toujours agréable de leur parler, mais pas trop d'intérêt de leur côté. Prime vendeur: 5. Risque de perte: 6.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 6. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Copilot, mais on n'en sait pas plus | Départements: TI, Cyber | Valeur contrats: 1676.73 | Rentabilité: Moyen (160 $/h)",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: Professionnelle. Toujours agréable de leur parler, mais pas trop d'intérêt de leur côté. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 25,
    "ddcActive": true
  },
  {
    "clientName": "Desco inc.",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: /. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: /. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 26,
    "ddcActive": true
  },
  {
    "clientName": "Distribution Bo-Fruits",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: Faible. Peu d'intérêt pour la TI en général. Prime vendeur: 2. Risque de perte: 6.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 6. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Départements: TI | Valeur contrats: 1571.94 | Rentabilité: Moyen (169 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: Faible. Peu d'intérêt pour la TI en général. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 27,
    "ddcActive": true
  },
  {
    "clientName": "Dolbec International",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: /. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: /. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 28,
    "ddcActive": true
  },
  {
    "clientName": "Domaine Charlevoix",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: /. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: /. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 29,
    "ddcActive": true
  },
  {
    "clientName": "Dup Distribution",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Excellente relation. Bons humains qui aiment discuter de TI, mais de plusieurs autres sujets lors des rencontres. Très bonne confiance envers BZ. Prime vendeur: 6. Risque de perte: 4.",
    "recommendedAngle": "Implantation du nouvel ERP",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Embaucher de la main-d'œuvre (junior), Gestion des scans (appareils) | Implantation du nouvel ERP",
    "comments": "Implantation d'un nouvel ERP pour septembre 2026, c'est donc le projet principal cette année. Après le go live et l'adaptation des employés, intéressé à voir comment l'IA pourrait les aider à automatiser des tâches et faciliter le travail. | Valeur contrats: 1845.67",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Implantation du nouvel ERP. Relation: Excellente relation. Bons humains qui aiment discuter de TI, mais de plusieurs autres sujets lors des rencontres. Très bonne confiance envers BZ. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 30,
    "ddcActive": true
  },
  {
    "clientName": "Entreprise Ribeau",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: Pas de lien.. Prime vendeur: 1. Risque de perte: 5.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Gros projet de programmation en cours avec BZ | Départements: TI, Programmation | Valeur contrats: 3750.75 | Rentabilité: Rentable (209 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: Pas de lien.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 31,
    "ddcActive": true
  },
  {
    "clientName": "Evident Scientific",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: /. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: /. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 32,
    "ddcActive": true
  },
  {
    "clientName": "Fabrique, à déterminer",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: /. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: /. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 33,
    "ddcActive": true
  },
  {
    "clientName": "Fastco",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: /. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: /. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 34,
    "ddcActive": true
  },
  {
    "clientName": "Forcedev",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: /. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Départements: TI | Valeur contrats: 526.32 | Rentabilité: Rentable (953 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: /. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 35,
    "ddcActive": true
  },
  {
    "clientName": "Gestion Alain Drolet inc.",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: Aucune. Prime vendeur: 2. Risque de perte: 8.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 8. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Valeur contrats: 24.69",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Élevé",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: Aucune. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 36,
    "ddcActive": true
  },
  {
    "clientName": "GLCRM architectes inc.",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: /. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: /. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 37,
    "ddcActive": true
  },
  {
    "clientName": "Groupe Céramique l'Entrepôt inc.",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne, malgré quelques dossiers épineux dans la dernière année, bonne communication avec leur responsable TI. Prime vendeur: 7. Risque de perte: 4.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Confiance écorchée envers BZ. Attendre de regagner avant de proposer. | Départements: TI, Cyber | Valeur contrats: 2960.97 | Rentabilité: Moyen (196 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: Bonne, malgré quelques dossiers épineux dans la dernière année, bonne communication avec leur responsable TI. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 38,
    "ddcActive": true
  },
  {
    "clientName": "Groupe GR Immobilier",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: Pas de communication encore, nouveau client pour PLF. Prime vendeur: 1. Risque de perte: 5.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Valeur contrats: 66.4",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: Pas de communication encore, nouveau client pour PLF. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 39,
    "ddcActive": true
  },
  {
    "clientName": "Groupe Lignarex",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: /. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: /. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 40,
    "ddcActive": true
  },
  {
    "clientName": "Groupe MCL inc",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: /. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: /. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 41,
    "ddcActive": true
  },
  {
    "clientName": "Helitowcart",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: /. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: /. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 42,
    "ddcActive": true
  },
  {
    "clientName": "Immigration Primo",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Relation correcte, quelques rencontres mais peu d'intérêt réel à optimiser ses processus. Prime vendeur: 3. Risque de perte: 5.",
    "recommendedAngle": "Amélioration de la gestion documentaire SharePoint et OneDrive, renforcement de la cybersécurité et de la protection des identités",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Gestion documentaire hybride et enjeux d'accès aux documents, évolution de l'environnement Microsoft 365, protection des données sensibles liées à l'immigration, amélioration de l'expérience utilisateur, modernisation de la gouvernance TI et cybersécurité. | Amélioration de la gestion documentaire SharePoint et OneDrive, renforcement de la cybersécurité et de la protection des identités",
    "comments": "Rencontre faite à propos de Copilot, mais intérêt mitigé. Plusieurs questionnements par rapport à la souveraineté des données. Lors d'une rencontre ponctuelle, plusieurs idées proposées mais pas de suivi de leur côté | Départements: TI | Valeur contrats: 604.19 | Rentabilité: Rentable (913 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Amélioration de la gestion documentaire SharePoint et OneDrive, renforcement de la cybersécurité et de la protection des identités. Relation: Relation correcte, quelques rencontres mais peu d'intérêt réel à optimiser ses processus. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 43,
    "ddcActive": true
  },
  {
    "clientName": "IPNQ",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne relation, Bonne confiance envers BZ, Pas de désir de pousser ses technologies. Prime vendeur: 6. Risque de perte: 3.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Départements: TI | Valeur contrats: 626.8 | Rentabilité: Faible (45 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: Bonne relation, Bonne confiance envers BZ, Pas de désir de pousser ses technologies. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 44,
    "ddcActive": true
  },
  {
    "clientName": "J.G.G. LABBÉE & ASSOCIÉS INC.",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: Pratiquement nulle. Prime vendeur: 1. Risque de perte: 2.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Départements: TI | Valeur contrats: 18.18 | Rentabilité: Moyen (155 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: Pratiquement nulle. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 45,
    "ddcActive": true
  },
  {
    "clientName": "Jardin Scarpro Inc.",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Cordial, faible intérêt envers ce que BZ peut proposer. Prime vendeur: 2. Risque de perte: 6.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 6. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Départements: TI | Valeur contrats: 1565.27 | Rentabilité: Rentable (1133 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: Cordial, faible intérêt envers ce que BZ peut proposer. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 46,
    "ddcActive": true
  },
  {
    "clientName": "Josée Tremblay, CA",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: Inexistant. Prime vendeur: 1. Risque de perte: 5.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Départements: TI | Valeur contrats: 58.22 | Rentabilité: Rentable (1148 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: Inexistant. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 47,
    "ddcActive": true
  },
  {
    "clientName": "K2D Assurances",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Excellente relation, confiance en BZ et référenceurs forts dans la dernière année. Prime vendeur: 7. Risque de perte: 2.",
    "recommendedAngle": "Accompagnement pour déménagement (matériel, conseil).",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Déménagement, Gestion de la croissance | Accompagnement pour déménagement (matériel, conseil).",
    "comments": "Derek est déjà en train de se monter des agents qui font des tâches répétitives. Veulent collaborer avec BZ, mais pas à tout prix. | Départements: TI, Cyber | Valeur contrats: 1947.88 | Rentabilité: Rentable (333 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Accompagnement pour déménagement (matériel, conseil).. Relation: Excellente relation, confiance en BZ et référenceurs forts dans la dernière année. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 48,
    "ddcActive": true
  },
  {
    "clientName": "kwatroe",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: /. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: /. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 49,
    "ddcActive": true
  },
  {
    "clientName": "La Financière Transcapitale",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: Inexistant. Prime vendeur: 2. Risque de perte: 5.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Départements: TI | Valeur contrats: 1153.17 | Rentabilité: Rentable (573 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: Inexistant. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 50,
    "ddcActive": true
  },
  {
    "clientName": "Leclerc Communication",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Malgré un contrat atyique (facturable), confiance envoers BZ et travail complémentaire de ce qui est fait à l'interne. Prime vendeur: 5. Risque de perte: 4.",
    "recommendedAngle": "Intégration ATC-WideOrbit, automatisation des ventes, centralisation des données, développement applicatif sur mesure, optimisation des processus d’affaires.",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Processus administratifs manuels, doubles saisies entre systèmes, dépendance à Excel, risques d’erreurs opérationnelles, besoins liés à la croissance. | Intégration ATC-WideOrbit, automatisation des ventes, centralisation des données, développement applicatif sur mesure, optimisation des processus d’affaires.",
    "comments": "Projet de programmation en cours avec BZ, à voir pour la suite | Départements: TI | Valeur contrats: 1686.33 | Rentabilité: Rentable (2947 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Intégration ATC-WideOrbit, automatisation des ventes, centralisation des données, développement applicatif sur mesure, optimisation des processus d’affaires.. Relation: Malgré un contrat atyique (facturable), confiance envoers BZ et travail complémentaire de ce qui est fait à l'interne. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 51,
    "ddcActive": true
  },
  {
    "clientName": "Les attaches Fastco inc.",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: Inexistante, malgré plusieurs tentatives. Pas de désir à collaborer avec nous pour le moment. Prime vendeur: 1. Risque de perte: 5.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Aucun retour de courriel pour organiser des rencontres pour les aider à améliorer leurs TI | Départements: TI | Valeur contrats: 2678.22 | Rentabilité: Rentable (2203 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: Inexistante, malgré plusieurs tentatives. Pas de désir à collaborer avec nous pour le moment. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 52,
    "ddcActive": true
  },
  {
    "clientName": "Lexsa Avocats",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Relation plutôt difficile, plusieurs demandes dans des délais serrés, mais peu de collaboration.. Prime vendeur: 4. Risque de perte: 7.",
    "recommendedAngle": "Finaliser SharePoint, corriger les structures documentaires, optimiser la synchronisation, évaluer iManage, améliorer la gestion documentaire.",
    "riskOrCondition": "Risque déclaré: 7. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Finaliser SharePoint, corriger les structures documentaires, optimiser la synchronisation, évaluer iManage, améliorer la gestion documentaire. | Finaliser SharePoint, corriger les structures documentaires, optimiser la synchronisation, évaluer iManage, améliorer la gestion documentaire.",
    "comments": "Plusieurs demandes quand ils ont du temps libres, puis disparaissent quand ils ont du travail, laissant les projets en cours traîner à notre équipe technique. | Départements: TI | Valeur contrats: 564.21 | Rentabilité: Moyen (133 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Finaliser SharePoint, corriger les structures documentaires, optimiser la synchronisation, évaluer iManage, améliorer la gestion documentaire.. Relation: Relation plutôt difficile, plusieurs demandes dans des délais serrés, mais peu de collaboration.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 53,
    "ddcActive": true
  },
  {
    "clientName": "MG2",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: /. Prime vendeur: /. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: /. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 54,
    "ddcActive": true
  },
  {
    "clientName": "MG2 Énergie",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Excellente relation. Pier-Luc Moreau est un ambassadeur pour BZ. Cependant, quelques situations dernièrement où BZ n'a pas été au standard les amène à se questionner. Prime vendeur: 9. Risque de perte: 3.",
    "recommendedAngle": "Migration SharePoint, amélioration des TS, déploiement du 2FA, structuration documentaire, adoption de Copilot et de l’IA.",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Performance du Terminal Server, transition vers le cloud, gestion documentaire dispersée, besoins grandissants en IA, amélioration de la sécurité. | Migration SharePoint, amélioration des TS, déploiement du 2FA, structuration documentaire, adoption de Copilot et de l’IA.",
    "comments": "Client demandant mais généralement sympathique. Intérêt moyen en cyber et IA, mais de démontrer le ROI pourrait les faire changer d'Avis | Départements: TI | Valeur contrats: 4854.1 | Rentabilité: Moyen (161 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Migration SharePoint, amélioration des TS, déploiement du 2FA, structuration documentaire, adoption de Copilot et de l’IA.. Relation: Excellente relation. Pier-Luc Moreau est un ambassadeur pour BZ. Cependant, quelques situations dernièrement où BZ n'a pas été au standard les amène à se questionner. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 55,
    "ddcActive": true
  },
  {
    "clientName": "Mobilier M.E.Q. Ltée ***Projet en cours***",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Relation positive avec les dirigeants (entreprise familiale). Client Cloud pour le moment seulement, infogérance à venir à moyen terme. Prime vendeur: 5. Risque de perte: 5.",
    "recommendedAngle": "Nouvel ERP, Déploiement Microsoft 365 Premium, sauvegardes Microsoft 365, migration vers le cloud, mise en place du support TI géré",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Modernisation de l’environnement TI, amélioration de la sécurité, standardisation des outils, migration vers Microsoft 365, évolution de l’infrastructure. | Nouvel ERP, Déploiement Microsoft 365 Premium, sauvegardes Microsoft 365, migration vers le cloud, mise en place du support TI géré",
    "comments": "Cloud seulement pour le moment. En implantation d'ERP jusqu'à 2027, donc projet principal pour le moment. | Départements: TI | Valeur contrats: 1845.19 | Rentabilité: Rentable (752 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Nouvel ERP, Déploiement Microsoft 365 Premium, sauvegardes Microsoft 365, migration vers le cloud, mise en place du support TI géré. Relation: Relation positive avec les dirigeants (entreprise familiale). Client Cloud pour le moment seulement, infogérance à venir à moyen terme. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 56,
    "ddcActive": true
  },
  {
    "clientName": "Nouveau JD",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne relation dans les derniers mois, début dans PRIsME mais focus principal sur l'IA/Automatisation de la \"shop\". Prime vendeur: 5. Risque de perte: 5.",
    "recommendedAngle": "Voir directeur TI / PRISME",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Voir directeur TI / PRISME | Voir directeur TI / PRISME",
    "comments": "Déjà dans PRIsME avec Éric Hains comme directeur TI | Départements: TI, Cyber | Valeur contrats: 7867.92 | Rentabilité: Rentable (282 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Voir directeur TI / PRISME. Relation: Bonne relation dans les derniers mois, début dans PRIsME mais focus principal sur l'IA/Automatisation de la \"shop\". Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 57,
    "ddcActive": true
  },
  {
    "clientName": "Nova Clinique vétérinaire",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Début de relation, à déterminer. Déjà quelques irritants avec les délais des interventtions techniques. Prime vendeur: 7. Risque de perte: 6.",
    "recommendedAngle": "Optimisation des licences Microsoft 365, structuration SharePoint et Teams, sauvegardes Microsoft 365, amélioration de la sécurité, accompagnement TI plus proactif.",
    "riskOrCondition": "Risque déclaré: 6. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Insatisfaction envers le fournisseur TI actuel, enjeux de support, gestion des accès, efficacité opérationnelle à améliorer, sécurité des données. | Optimisation des licences Microsoft 365, structuration SharePoint et Teams, sauvegardes Microsoft 365, amélioration de la sécurité, accompagnement TI plus proactif.",
    "comments": "Peu portés sur la technologies, mais pourrait bénéficier de l'IA pour la structuration du travail à peu de frais | Départements: TI | Valeur contrats: 1043.57 | Rentabilité: Faible (45 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Optimisation des licences Microsoft 365, structuration SharePoint et Teams, sauvegardes Microsoft 365, amélioration de la sécurité, accompagnement TI plus proactif.. Relation: Début de relation, à déterminer. Déjà quelques irritants avec les délais des interventtions techniques. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 58,
    "ddcActive": true
  },
  {
    "clientName": "Nyx Hemera Technologies inc.",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Relation difficile. Beaucoup de demandes et de reproches, mais accepte les explications. Toujours sur la corde raide. Prime vendeur: 5. Risque de perte: 8.",
    "recommendedAngle": "Voir directeur TI / PRISME",
    "riskOrCondition": "Risque déclaré: 8. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Voir directeur TI / PRISME | Voir directeur TI / PRISME",
    "comments": "Ont l'impression de connaître tout plus que tout le monde, comité TI très difficiles et peu productifs en raisons de plusieurs questions par Pierre Samson qui ne sont pas à l'ordre du jour. | Départements: TI | Valeur contrats: 5180.55 | Rentabilité: Rentable (201 $/h)",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Élevé",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Voir directeur TI / PRISME. Relation: Relation difficile. Beaucoup de demandes et de reproches, mais accepte les explications. Toujours sur la corde raide. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 59,
    "ddcActive": true
  },
  {
    "clientName": "Paré Ouellet Bigaouette et Associés, Huissiers inc.",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Excellente relation. POB est un client de BZ de la première heure et leur confiance envers nous est excessivement forte. Prime vendeur: 5. Risque de perte: 1.",
    "recommendedAngle": "Voir directeur TI / PRISME",
    "riskOrCondition": "Risque déclaré: 1. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Voir directeur TI / PRISME | Voir directeur TI / PRISME",
    "comments": "Client de BZ depuis longtemps, plusieurs contacts à l'interne et niveau de confiance élevé. Déjà impliqué dans l'IA de BZ via Dany. | Départements: TI, Cyber | Valeur contrats: 5274.1 | Rentabilité: Rentable (446 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Voir directeur TI / PRISME. Relation: Excellente relation. POB est un client de BZ de la première heure et leur confiance envers nous est excessivement forte. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 60,
    "ddcActive": true
  },
  {
    "clientName": "Piercon Ltée",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Cordial, client en cyber (SAT). Prime vendeur: 1. Risque de perte: 8.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 8. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Départements: Cyber | Valeur contrats: 277.5",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Élevé",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: Cordial, client en cyber (SAT). Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 61,
    "ddcActive": true
  },
  {
    "clientName": "Poudrier Bradet Avocats",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: PBA et BZ se connaisse depuis longtemps, mais nouveau DDC depuis le printemps et peu de contact. Par contre, les quelques discussion ont été positives.. Prime vendeur: 3. Risque de perte: 2.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Comtié IA prévu pour être mis en place cet été, mais difficile de trouver des disponibilités avec les décideurs (Sophie) | Départements: TI | Valeur contrats: 11838.76 | Rentabilité: Rentable (474 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: PBA et BZ se connaisse depuis longtemps, mais nouveau DDC depuis le printemps et peu de contact. Par contre, les quelques discussion ont été positives.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 62,
    "ddcActive": true
  },
  {
    "clientName": "Prêts Relais Capital inc.",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Relation difficile, plusieurs enjeux de délai de réponse de techniciens ont amené plusieurs problèmes entre PRC et BZ. Plus léger dernièrement cependant. Prime vendeur: 5. Risque de perte: 7.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 7. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Souvent déçus des réponses au SAC, se tourne vers le DDC pour obtenir de la clarté. | Départements: TI | Valeur contrats: 789.39 | Rentabilité: Rentable (274 $/h)",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: Relation difficile, plusieurs enjeux de délai de réponse de techniciens ont amené plusieurs problèmes entre PRC et BZ. Plus léger dernièrement cependant. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 63,
    "ddcActive": true
  },
  {
    "clientName": "Québec Fruits et Légumes",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: /. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: /. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 64,
    "ddcActive": true
  },
  {
    "clientName": "Ressources Robex inc.",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: Relation distante, client Cloud qui utilise peu les services de BZ. Intérêt faible à développer avec nous.. Prime vendeur: 1. Risque de perte: 6.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 6. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Cloud seulement, rien de plus. Leur siège social est miantenant en Australie. | Départements: TI | Valeur contrats: 3511.25 | Rentabilité: Rentable (3908 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: Relation distante, client Cloud qui utilise peu les services de BZ. Intérêt faible à développer avec nous.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 65,
    "ddcActive": true
  },
  {
    "clientName": "RMB inc.",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Nouveau DG depuis moins d'un an, une nouvelle relation d'affaire créée dans les derniers mois qui est excellente pour le moment. Prime vendeur: 7. Risque de perte: 3.",
    "recommendedAngle": "Utiliser davantage le services d'infogérance de BZ pour alléger à l'interne, s'assurer que les logiciels ne sont pas stockés dans des dossiers personnels, Se conformer à la Loi 25. Mise en place de comité TI",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Structure interne, formations aux employés, Conformité Loi 25 | Utiliser davantage le services d'infogérance de BZ pour alléger à l'interne, s'assurer que les logiciels ne sont pas stockés dans des dossiers personnels, Se conformer à la Loi 25. Mise en place de comité TI",
    "comments": "Désir de structurer l'entreprise, nouveau DG, communication facile, Sur la liste pour nouveau PRIsME, Plan directeur en juin 2026, intérêt IA mais veut régler d'autres dossiers avant. Projet de programmation avec une firme locale en ce moment. | Départements: TI | Valeur contrats: 3988.29 | Rentabilité: Rentable (499 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Utiliser davantage le services d'infogérance de BZ pour alléger à l'interne, s'assurer que les logiciels ne sont pas stockés dans des dossiers personnels, Se conformer à la Loi 25. Mise en place de comité TI. Relation: Nouveau DG depuis moins d'un an, une nouvelle relation d'affaire créée dans les derniers mois qui est excellente pour le moment. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 66,
    "ddcActive": true
  },
  {
    "clientName": "Safari Condo",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Client peu demandant, mais difficile d'accès.. Prime vendeur: 3. Risque de perte: 4.",
    "recommendedAngle": "Mise en place de comité TI/ PRisME",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Bonifier le lien avec le client | Mise en place de comité TI/ PRisME",
    "comments": "Peu d'intérêt à faire du chemin avec BZ. Peut-être que l'IA sera la façon de les rapprocher. Pas donné suite au courriel d'intro de PRIsME d'Éric Hains | Départements: TI | Valeur contrats: 6733.08 | Rentabilité: Rentable (278 $/h)",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Mise en place de comité TI/ PRisME. Relation: Client peu demandant, mais difficile d'accès.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 67,
    "ddcActive": true
  },
  {
    "clientName": "SD Horizon Assurances Inc",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: Nouveau client, mais sympathique et facile d'approche. Prime vendeur: 3. Risque de perte: 4.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Nouveau client | Valeur contrats: 475.32",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: Nouveau client, mais sympathique et facile d'approche. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 68,
    "ddcActive": true
  },
  {
    "clientName": "Services comptables MSA",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Plusieurs demandes en lien avec les coûts, mais sympathique et compréhensif.. Prime vendeur: 8. Risque de perte: 5.",
    "recommendedAngle": "Modernisation de l’infrastructure, migration vers le cloud, automatisation des processus comptables, amélioration des sauvegardes, préparation à la croissance future.",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Infrastructure limitée par un serveur local, télétravail important, enjeux de performance VPN, forte croissance anticipée, sécurité des données. | Modernisation de l’infrastructure, migration vers le cloud, automatisation des processus comptables, amélioration des sauvegardes, préparation à la croissance future.",
    "comments": "Client qui prévoit une croissance d'ici 1-2 ans. | Valeur contrats: 645.63",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Modernisation de l’infrastructure, migration vers le cloud, automatisation des processus comptables, amélioration des sauvegardes, préparation à la croissance future.. Relation: Plusieurs demandes en lien avec les coûts, mais sympathique et compréhensif.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 69,
    "ddcActive": true
  },
  {
    "clientName": "Services Conseils Pragam Coaching Inc.",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Coridale. Prime vendeur: 5. Risque de perte: 5.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Départements: TI | Valeur contrats: 137.6 | Rentabilité: Rentable (274 $/h)",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: Coridale. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 70,
    "ddcActive": true
  },
  {
    "clientName": "Services financiers Alexi Cordiano",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: /. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: /. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 71,
    "ddcActive": true
  },
  {
    "clientName": "Signature 4G",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Bonne relation car connaissance extérieure, mais difficile de mettre la main dessus pour lui parler. Prime vendeur: 4. Risque de perte: 6.",
    "recommendedAngle": "Peu de contact, à déterminer",
    "riskOrCondition": "Risque déclaré: 6. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Peu de contact, à déterminer | Peu de contact, à déterminer",
    "comments": "Difficile d'accès, peu exigeant | Départements: TI | Valeur contrats: 375.47 | Rentabilité: Faible (25 $/h)",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Peu de contact, à déterminer. Relation: Bonne relation car connaissance extérieure, mais difficile de mettre la main dessus pour lui parler. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 72,
    "ddcActive": true
  },
  {
    "clientName": "SOCAM",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Très bonne relation. Client référenceur. Prime vendeur: 9. Risque de perte: 2.",
    "recommendedAngle": "Performance des outils pour la diffusion, changement de logiciel de diffusion",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Performance des outils pour la diffusion, changement de logiciel de diffusion",
    "comments": "Planifient ouvrir un centre de formation destiné aux communications/journalisme autochtone et veulent impliquer BZ dans ce projet | Départements: TI | Valeur contrats: 1166.31 | Rentabilité: Faible (124 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Moyenne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Performance des outils pour la diffusion, changement de logiciel de diffusion. Relation: Très bonne relation. Client référenceur. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 73,
    "ddcActive": true
  },
  {
    "clientName": "Sport Excellence Corporation",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Relation houleuse.. Prime vendeur: 7. Risque de perte: 6.",
    "recommendedAngle": "Rencontre avec la direction pendant l'été pour clarifier les options Cloud",
    "riskOrCondition": "Risque déclaré: 6. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Choix du Cloud | Rencontre avec la direction pendant l'été pour clarifier les options Cloud",
    "comments": "Le choix du Cloud (BZ vs Azure) est une discussion mensuelle. La confiance de la direction envers BZ est présente, mais pas au niveau de leur technicien. | Valeur contrats: 2306.39",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Rencontre avec la direction pendant l'été pour clarifier les options Cloud. Relation: Relation houleuse.. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 74,
    "ddcActive": true
  },
  {
    "clientName": "STC Manufacturier",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: /. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: /. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 75,
    "ddcActive": true
  },
  {
    "clientName": "Support SP inc.",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "Intéressé mais ne sait pas par où commencer",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Excellente relation, connaissance extérieure. Confiance envers BZ ++. Prime vendeur: 7. Risque de perte: 3.",
    "recommendedAngle": "Remplacement d’Access, développement d’une application moderne, automatisation des processus, portail concessionnaires, amélioration de la fiabilité des opérations.",
    "riskOrCondition": "Risque déclaré: 3. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Processus reposant sur Access, besoins d’automatisation, modernisation applicative, efficacité opérationnelle, évolution des outils internes. | Remplacement d’Access, développement d’une application moderne, automatisation des processus, portail concessionnaires, amélioration de la fiabilité des opérations.",
    "comments": "Relation amicale, Sébastien nous écrit dès qu'il a un souci et est satisfait du résultat. Projet de programmation en cours avec BZ | Départements: TI | Valeur contrats: 729.17 | Rentabilité: Rentable (459 $/h)",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Remplacement d’Access, développement d’une application moderne, automatisation des processus, portail concessionnaires, amélioration de la fiabilité des opérations.. Relation: Excellente relation, connaissance extérieure. Confiance envers BZ ++. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 76,
    "ddcActive": true
  },
  {
    "clientName": "SV Avocats",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Client cyber, potentiel infogérance. Bonne relation avec l'adjointe administrative, relation de confiance avec l'associé principal. Prime vendeur: 8. Risque de perte: à valider.",
    "recommendedAngle": "S'assurer d'une cybersécurité plus robuste, former les gens à l'interne de la réalité des technologies",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "S'assurer d'une cybersécurité plus robuste, former les gens à l'interne de la réalité des technologies",
    "comments": "Fusion prévue n'a pas eu lieu. En train d'examiner l'option de venir avec BZ pour leur infogérance.",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Moyenne",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: S'assurer d'une cybersécurité plus robuste, former les gens à l'interne de la réalité des technologies. Relation: Client cyber, potentiel infogérance. Bonne relation avec l'adjointe administrative, relation de confiance avec l'associé principal. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 77,
    "ddcActive": true
  },
  {
    "clientName": "TB4 Ronam inc.",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Relation très difficile, beaucoup de demandes et de reproches, peu de collaboration. Prime vendeur: 4. Risque de perte: 9.",
    "recommendedAngle": "Établir clairement avec BZ qui fait quoi",
    "riskOrCondition": "Risque déclaré: 9. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Gestion de la croissance, Décider une orientation concernant les choix stratégiques en technologies | Établir clairement avec BZ qui fait quoi",
    "comments": "Beaucoup d'ajouts du côté de TB4 Ronam pour la technologie (technicien, directrice de l'innovation). Voit BZ comme un complément, non un partenaire. Le contrat se termine en décembre 2026, de bonnes chances qu'il n'y ai pas de renouvellement. | Départements: TI | Valeur contrats: 7991.9 | Rentabilité: Rentable (308 $/h)",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Élevé",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Établir clairement avec BZ qui fait quoi. Relation: Relation très difficile, beaucoup de demandes et de reproches, peu de collaboration. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 78,
    "ddcActive": true
  },
  {
    "clientName": "Version III Design inc.",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne relation avec la propriétaire, intérêt pour l'IA, mais peu de moyens. Prime vendeur: 3. Risque de perte: 5.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: 5. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Katia a un intérêt pour Copilot, je lui ai donné une formation. Je ne sais pas si plus ? | Départements: TI | Valeur contrats: 326.82 | Rentabilité: Rentable (288 $/h)",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: à préciser. Relation: Bonne relation avec la propriétaire, intérêt pour l'IA, mais peu de moyens. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 79,
    "ddcActive": true
  },
  {
    "clientName": "W, Brindamour Inc.",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Élevé",
    "approachPriority": "Priorité 1 - approche rapide",
    "expertAssessment": "Source Excel DDC. Relation: Nouveau client, mais référencé de Beauvais Truchon, donc relation de confiance déjà en place. Quelques irritants suite à la migration en lien avec des petites tâches pas de suivis, mais apporté gentilment. Prime vendeur: 8. Risque de perte: 4.",
    "recommendedAngle": "Migration d’Acomba et Veridem vers le cloud, abandon des serveurs locaux, infogérance proactive, Mise en place de caméra de surveillance (installées, mais pas foncitonnelles)",
    "riskOrCondition": "Risque déclaré: 4. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Infrastructure vieillissante, dépendance aux serveurs locaux, manque de proactivité (ancien fournisseur)TI, cybersécurité à optimiser, multiplication des fournisseurs. | Migration d’Acomba et Veridem vers le cloud, abandon des serveurs locaux, infogérance proactive, Mise en place de caméra de surveillance (installées, mais pas foncitonnelles)",
    "comments": "Nouveau client, intérêt à devenir plus efficace. | Valeur contrats: 1952.97",
    "ddcScore": "A - opportunité prioritaire",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Migration d’Acomba et Veridem vers le cloud, abandon des serveurs locaux, infogérance proactive, Mise en place de caméra de surveillance (installées, mais pas foncitonnelles). Relation: Nouveau client, mais référencé de Beauvais Truchon, donc relation de confiance déjà en place. Quelques irritants suite à la migration en lien avec des petites tâches pas de suivis, mais apporté gentilment. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 80,
    "ddcActive": true
  },
  {
    "clientName": "Épices du Guerrier",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Relation difficile. Mauvais payeur et peu compréhensif avec le service à la clientèle. Prime vendeur: 2. Risque de perte: 8.",
    "recommendedAngle": "Implantation du nouvel ERP",
    "riskOrCondition": "Risque déclaré: 8. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Implantation du nouvel ERP | Implantation du nouvel ERP",
    "comments": "Implantation d'un nouvel ERP en cours, peu de temps pour parler avec BZ. Préfère les courriels à une visite ou un dîner. | Départements: TI | Valeur contrats: 1396.93 | Rentabilité: Rentable (3132 $/h)",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Élevé",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Implantation du nouvel ERP. Relation: Relation difficile. Mauvais payeur et peu compréhensif avec le service à la clientèle. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 81,
    "ddcActive": true
  },
  {
    "clientName": "Équilibre Traiteur",
    "accountManager": "Pierre-Luc Fortin",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Priorité 3 - opportunité à surveiller",
    "expertAssessment": "Source Excel DDC. Relation: Relation correcte. Forte croissance donc beaucoup de demande et peu de patience. \"Fair\" avec les services de BZ. Prime vendeur: 6. Risque de perte: 7.",
    "recommendedAngle": "Regrouper les tenants, trouver une façon efficace pour que les nouveaux employés travaillent ensemble sur le plan TI",
    "riskOrCondition": "Risque déclaré: 7. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Gestion de la croissance | Regrouper les tenants, trouver une façon efficace pour que les nouveaux employés travaillent ensemble sur le plan TI",
    "comments": "Grosse croissance (acquisition) depuis la dernière année, ils en sont un peu dépassé. Peu satisfaits du service dernièrement. | Départements: TI | Valeur contrats: 1849.08 | Rentabilité: Rentable (202 $/h)",
    "ddcScore": "C - à maturer",
    "ddcBusinessImpact": "Moyenne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Bonne",
    "ddcRiskLevel": "Moyen",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Pierre-Luc Fortin). Priorités/enjeux: Regrouper les tenants, trouver une façon efficace pour que les nouveaux employés travaillent ensemble sur le plan TI. Relation: Relation correcte. Forte croissance donc beaucoup de demande et peu de patience. \"Fair\" avec les services de BZ. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Pierre-Luc Fortin",
    "sourceRow": 82,
    "ddcActive": true
  },
  {
    "clientName": "ACI World Services",
    "accountManager": "Sans vendeur",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Valeur contrats: 101.45",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Sans vendeur). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Sans vendeur",
    "sourceRow": 2,
    "ddcActive": true
  },
  {
    "clientName": "Agence Martin Gravel",
    "accountManager": "Sans vendeur",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Sans vendeur). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Sans vendeur",
    "sourceRow": 3,
    "ddcActive": true
  },
  {
    "clientName": "Audrey Drolet",
    "accountManager": "Sans vendeur",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Départements: TI | Valeur contrats: 17.85 | Rentabilité: Faible (6 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Sans vendeur). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Sans vendeur",
    "sourceRow": 4,
    "ddcActive": true
  },
  {
    "clientName": "BZ Télécom",
    "accountManager": "Sans vendeur",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Départements: Programmation | Valeur contrats: 10321.22",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Sans vendeur). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Sans vendeur",
    "sourceRow": 5,
    "ddcActive": true
  },
  {
    "clientName": "Datadis",
    "accountManager": "Sans vendeur",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "Moyen",
    "approachPriority": "Priorité 2 - approche planifiée",
    "expertAssessment": "Source Excel DDC. Relation: Bonne. Prime vendeur: 9. Risque de perte: 2.",
    "recommendedAngle": "Entente à finaliser",
    "riskOrCondition": "Risque déclaré: 2. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "Entente à finaliser",
    "comments": "Partenaire | Départements: Partenariat à venir",
    "ddcScore": "B - potentiel intéressant",
    "ddcBusinessImpact": "Bonne",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "Bonne",
    "ddcUseCaseClarity": "Moyenne",
    "ddcRiskLevel": "Faible",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Sans vendeur). Priorités/enjeux: Entente à finaliser. Relation: Bonne. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Sans vendeur",
    "sourceRow": 6,
    "ddcActive": true
  },
  {
    "clientName": "Dolbec Y Logistique International",
    "accountManager": "Sans vendeur",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Valeur contrats: 300",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Sans vendeur). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Sans vendeur",
    "sourceRow": 7,
    "ddcActive": true
  },
  {
    "clientName": "Germain Nissan",
    "accountManager": "Sans vendeur",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Sans vendeur). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Sans vendeur",
    "sourceRow": 8,
    "ddcActive": true
  },
  {
    "clientName": "Infirmia",
    "accountManager": "Sans vendeur",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Sans vendeur). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Sans vendeur",
    "sourceRow": 9,
    "ddcActive": true
  },
  {
    "clientName": "Les résidences Landry",
    "accountManager": "Sans vendeur",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Départements: TI | Valeur contrats: 750.01 | Rentabilité: Rentable (531 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Sans vendeur). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Sans vendeur",
    "sourceRow": 10,
    "ddcActive": true
  },
  {
    "clientName": "Sigma Assurance",
    "accountManager": "Sans vendeur",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "Départements: TI, Cyber | Valeur contrats: 400 | Rentabilité: Faible (16 $/h)",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Sans vendeur). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Sans vendeur",
    "sourceRow": 11,
    "ddcActive": true
  },
  {
    "clientName": "Ste-Foy Nissan",
    "accountManager": "Sans vendeur",
    "primaryContact": "",
    "contactedBy": "",
    "contactDate": "",
    "status": "À contacter",
    "meetingDate": "",
    "aiMaturity": "À valider",
    "clientInterest": "À valider",
    "approachPriority": "Hors cible temporaire",
    "expertAssessment": "Source Excel DDC. Relation: à documenter. Prime vendeur: à valider. Risque de perte: à valider.",
    "recommendedAngle": "Débuter par une qualification IA courte : irritants, processus répétitifs, données disponibles, risques et décideur.",
    "riskOrCondition": "Risque déclaré: à valider. À valider: données sensibles, gouvernance IA, maturité M365/Copilot, décideur et capacité d’adoption.",
    "nextStep": "Planifier un échange IA avec le client pour valider les irritants, les usages actuels, les données disponibles et la prochaine action BZ.",
    "nextMeetingDate": "",
    "demoNeeded": "À valider",
    "needsAssessment": "À valider",
    "opportunity": "",
    "comments": "",
    "ddcScore": "D - faible potentiel immédiat",
    "ddcBusinessImpact": "Faible",
    "ddcDataReadiness": "À valider",
    "ddcDecisionAccess": "À valider",
    "ddcUseCaseClarity": "À valider",
    "ddcRiskLevel": "À valider",
    "ddcReasoning": "Raisonnement initial basé sur l’évaluation DDC Excel (Sans vendeur). Priorités/enjeux: à préciser. Relation: à documenter. Le score demeure à confirmer en rencontre client.",
    "source": "Évaluation clients BZ.xlsx",
    "sourceSheet": "Sans vendeur",
    "sourceRow": 12,
    "ddcActive": true
  }
] as const;
